webpackJsonp([1],{

/***/ "+Bl8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'achievement-progress-bar',
  props: {
    achievements: Array,
    progress: Number
  },
  computed: {
    achievementPoints: function achievementPoints() {
      var achievementPoints = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.achievements), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var achievement = _step.value;

          achievementPoints.push({
            achieved: achievement.requirement <= this.progress,
            requirement: achievement.requirement,
            reward: achievement.reward
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return achievementPoints;
    },
    completedWidth: function completedWidth() {
      return this.progress < 1 ? 100 * this.progress + '%' : '100%';
    }
  }
});

/***/ }),

/***/ "+Fs2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

// Twitch CDN profile URLs go stale over time, so any avatar can 404. When that
// happens we draw a deterministic coloured circle with the user's initial —
// same name always gets the same colour.
var GRADIENTS = ['linear-gradient(135deg,#f2c14e,#e08a1e)', 'linear-gradient(135deg,#e01f28,#8f1218)', 'linear-gradient(135deg,#9146ff,#5a1fb0)', 'linear-gradient(135deg,#4ea8f2,#1e5ee0)', 'linear-gradient(135deg,#4ef2a8,#1ee07a)'];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-avatar',
  props: {
    name: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      failed: false
    };
  },

  computed: {
    showFallback: function showFallback() {
      return !this.src || this.failed;
    },
    initial: function initial() {
      var match = String(this.name).match(/[a-z0-9]/i);
      return match ? match[0].toUpperCase() : '?';
    },
    gradient: function gradient() {
      var key = String(this.name) || '?';
      var hash = 0;
      for (var i = 0; i < key.length; i++) {
        hash = hash * 31 + key.charCodeAt(i) >>> 0;
      }
      return GRADIENTS[hash % GRADIENTS.length];
    }
  },
  watch: {
    // a fresh url deserves a fresh attempt
    src: function src() {
      this.failed = false;
    }
  }
});

/***/ }),

/***/ "+VKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import loading from 'vue-full-loading'
// import BigNumber from 'BigNumber.js'
// import axios from 'axios'
// import router from '../router'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loot-box-editor',
  props: ['itemId'],
  components: {
    // loading
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.refreshLootItems();

            case 2:
              _context.next = 4;
              return _this.loadItem();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      description: {
        title: 'Loot Box Editor',
        text: 'Do it!'
      },
      selectedMap: { 'common': [], 'uncommon': [], 'rare': [], 'legendary': [], 'exotic': [] },
      isSaving: false,
      chanceCommon: 0,
      chanceUncommon: 0,
      chanceRare: 0,
      chanceLegendary: 0,
      chanceExotic: 0,
      maxPerDay: 0,
      itemName: '',
      itemDescription: '',
      itemRarity: 'common',
      itemForSale: false,
      itemPrice: '50',
      itemPriceCurrencyType: 'mt',
      notification: undefined,
      lootBoxType: 'random',
      existingItem: undefined
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])(['currentUser', 'lootShopLootItemIds', 'lootShopLootItems', 'roomItemPageCurrent', 'roomItemPages']), {
    chanceTotal: function chanceTotal() {
      return parseInt(this.chanceCommon) + parseInt(this.chanceUncommon) + parseInt(this.chanceRare) + parseInt(this.chanceLegendary) + parseInt(this.chanceExotic);
    },
    imageUrl: function imageUrl() {
      return this.existingItem && this.existingItem.image_url ? this.existingItem.image_url : 'lootchest-first.jpg';
    }
  }),
  methods: {
    loadItem: function loadItem() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.$route.query.notify) {
                  _this2.notify(_this2.$route.query.notify);
                }

                if (_this2.itemId) {
                  _this2.$store.dispatch('fetchLootItem', _this2.itemId).then(function () {
                    var item = _this2.$store.state.lootItems[_this2.itemId];
                    _this2.existingItem = item;
                    _this2.itemName = item.name;
                    _this2.itemRarity = item.rarity;
                    _this2.itemDescription = item.description;
                    _this2.itemForSale = item.for_sale;
                    _this2.itemPrice = item.price;
                    _this2.itemPriceCurrencyType = item.price_currency_type;
                    _this2.itemMaxAllowed = item.max_allowed;
                    _this2.existingThumbnailUrl = item.image_url;
                    var arr = void 0;
                    if (item.meta.blbg) {
                      _this2.lootBoxType = 'guaranteed';
                      arr = item.meta.blbg;
                    } else {
                      _this2.lootBoxType = 'random';
                      arr = item.meta.blb;
                    }

                    _this2.chanceCommon = arr[0][0];
                    _this2.chanceUncommon = arr[0][1];
                    _this2.chanceRare = arr[0][2];
                    _this2.chanceLegendary = arr[0][3];
                    _this2.chanceExotic = arr[0][4];

                    _this2.selectedMap = { 'common': [], 'uncommon': [], 'rare': [], 'legendary': [], 'exotic': [] };

                    var _loop = function _loop(_item) {
                      _this2.$store.dispatch('fetchLootItem', _item.li).then(function () {
                        return _this2.selectedMap['common'].push(_this2.$store.state.lootItems[_item.li]);
                      });
                    };

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arr[1][0]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _item = _step.value;

                        _loop(_item);
                      }
                    } catch (err) {
                      _didIteratorError = true;
                      _iteratorError = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                          _iterator.return();
                        }
                      } finally {
                        if (_didIteratorError) {
                          throw _iteratorError;
                        }
                      }
                    }

                    var _loop2 = function _loop2(_item2) {
                      _this2.$store.dispatch('fetchLootItem', _item2.li).then(function (i) {
                        return _this2.selectedMap['uncommon'].push(_this2.$store.state.lootItems[_item2.li]);
                      });
                    };

                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arr[1][1]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _item2 = _step2.value;

                        _loop2(_item2);
                      }
                    } catch (err) {
                      _didIteratorError2 = true;
                      _iteratorError2 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                          _iterator2.return();
                        }
                      } finally {
                        if (_didIteratorError2) {
                          throw _iteratorError2;
                        }
                      }
                    }

                    var _loop3 = function _loop3(_item3) {
                      _this2.$store.dispatch('fetchLootItem', _item3.li).then(function (i) {
                        return _this2.selectedMap['rare'].push(_this2.$store.state.lootItems[_item3.li]);
                      });
                    };

                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                      for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arr[1][2]), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var _item3 = _step3.value;

                        _loop3(_item3);
                      }
                    } catch (err) {
                      _didIteratorError3 = true;
                      _iteratorError3 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                          _iterator3.return();
                        }
                      } finally {
                        if (_didIteratorError3) {
                          throw _iteratorError3;
                        }
                      }
                    }

                    var _loop4 = function _loop4(_item4) {
                      _this2.$store.dispatch('fetchLootItem', _item4.li).then(function (i) {
                        return _this2.selectedMap['legendary'].push(_this2.$store.state.lootItems[_item4.li]);
                      });
                    };

                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                      for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arr[1][3]), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var _item4 = _step4.value;

                        _loop4(_item4);
                      }
                    } catch (err) {
                      _didIteratorError4 = true;
                      _iteratorError4 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                          _iterator4.return();
                        }
                      } finally {
                        if (_didIteratorError4) {
                          throw _iteratorError4;
                        }
                      }
                    }

                    var _loop5 = function _loop5(_item5) {
                      _this2.$store.dispatch('fetchLootItem', _item5.li).then(function (i) {
                        return _this2.selectedMap['exotic'].push(_this2.$store.state.lootItems[_item5.li]);
                      });
                    };

                    var _iteratorNormalCompletion5 = true;
                    var _didIteratorError5 = false;
                    var _iteratorError5 = undefined;

                    try {
                      for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arr[1][4]), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var _item5 = _step5.value;

                        _loop5(_item5);
                      }
                    } catch (err) {
                      _didIteratorError5 = true;
                      _iteratorError5 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                          _iterator5.return();
                        }
                      } finally {
                        if (_didIteratorError5) {
                          throw _iteratorError5;
                        }
                      }
                    }
                  });
                }

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    next: function next() {
      if (this.roomItemPages.length - 1 > this.roomItemPageCurrent) {
        this.$store.dispatch('gotoRoomPage', this.roomItemPageCurrent + 1);
      } else {
        this.$store.dispatch('fetchRoomPage', this.roomItemPages[this.roomItemPageCurrent].cursor);
      }
    },
    back: function back() {
      this.$store.dispatch('gotoRoomPage', this.roomItemPageCurrent - 1);
    },
    refreshLootItems: function refreshLootItems() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$store.dispatch('roomItemPageReset');

              case 2:
                _this3.$store.dispatch('fetchRoomPage');

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    categoryTextFor: function categoryTextFor(shopItem) {
      if (shopItem.category === 'lootChest') {
        return 'Virtual LOOTCHEST';
      } else if (shopItem.category === 'roomItem') {
        return 'Virtual Room Item';
      } else {
        return 'Token';
      }
    },
    lootShopLootItemForId: function lootShopLootItemForId(id) {
      return this.$store.state.lootShopLootItems[id];
    },
    lootItemImageUrl: function lootItemImageUrl(lootItem) {
      return __WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.WEB_ASSET_BASE_URL + '/' + lootItem.image_url;
    },
    currencyIcon: function currencyIcon(priceCurrencyType) {
      var image = priceCurrencyType === 'mt' ? 'swiftGold.png' : 'swiftBucks.png';

      return __WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.WEB_ASSET_BASE_URL + '/' + image;
    },
    attributionText: function attributionText(lootItem) {
      if (!lootItem.attribution_author) {
        return;
      }
      // // "Creative Commons 10th Birthday Celebration San Francisco" by tvol is licensed under CC BY 2.0
      return '<a href="' + lootItem.attribution_title_url + '" target="_blank">"' + lootItem.attribution_title + '"</a> by <a href="' + lootItem.attribution_author_url + '" target="_blank">' + lootItem.attribution_author + '</a> <br/> Licensed under <a href="' + lootItem.attribution_license_url + '" target="_blank">' + lootItem.attribution_license + '</a>';
    },
    requiresAttribution: function requiresAttribution(lootItem) {
      return !!lootItem.attribution_author;
    },
    notify: function notify(text) {
      var _this4 = this;

      this.notification = text;
      setTimeout(function () {
        _this4.notification = undefined;
      }, 5000);
    },
    lootBoxData: function lootBoxData() {
      console.log('rarity', this.itemRarity);
      return {
        name: this.itemName,
        description: this.itemDescription,
        rarity: this.itemRarity,
        for_sale: this.itemForSale,
        price: this.itemPrice,
        price_currency_type: this.itemPriceCurrencyType,
        loot_box_type: this.lootBoxType,
        max_per_day: this.maxPerDay,
        image_url: this.imageUrl,
        chances: [parseInt(this.chanceCommon), parseInt(this.chanceUncommon), parseInt(this.chanceRare), parseInt(this.chanceLegendary), parseInt(this.chanceExotic)],
        buckets: {
          'common': this.selectedMap['common'].map(function (i) {
            return i.id;
          }),
          'uncommon': this.selectedMap['uncommon'].map(function (i) {
            return i.id;
          }),
          'rare': this.selectedMap['rare'].map(function (i) {
            return i.id;
          }),
          'legendary': this.selectedMap['legendary'].map(function (i) {
            return i.id;
          }),
          'exotic': this.selectedMap['exotic'].map(function (i) {
            return i.id;
          })
        }
      };
    },
    save: function save() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, id;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                response = void 0;


                _this5.isSaving = true;

                if (!_this5.existingItem) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/loot-boxes/' + _this5.existingItem.id, _this5.lootBoxData(), { withCredentials: true });

              case 5:
                response = _context4.sent;
                _context4.next = 11;
                break;

              case 8:
                _context4.next = 10;
                return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/loot-boxes', _this5.lootBoxData(), { withCredentials: true });

              case 10:
                response = _context4.sent;

              case 11:

                _this5.isSaving = false;

                if (response.data) {
                  id = response.data.loot_item.id;

                  if (!_this5.itemId || _this5.itemId.toString() !== id.toString()) {
                    __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'LootBoxEditor', query: { notify: 'Item Saved.' }, params: { itemId: id } });
                  } else {
                    _this5.notify('Item Saved');
                  }
                } else {
                  _this5.notify('ERROR SAVING.');
                }

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    containsSelected: function containsSelected(item) {
      return this.selectedMap[item.rarity].map(function (i) {
        return i.id;
      }).includes(item.id);
    },
    addSelected: function addSelected(item) {
      this.selectedMap[item.rarity].push(item);
    },
    removeSelected: function removeSelected(item) {
      this.selectedMap[item.rarity].splice(this.selectedMap[item.rarity].map(function (i) {
        return i.id;
      }).indexOf(item.id), 1);
    }
  },
  watch: {
    '$route.params.itemId': function $routeParamsItemId(id) {
      this.loadItem();
    }
  }
});

/***/ }),

/***/ "+hvY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+lkC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Room_Item_Management_vue__ = __webpack_require__("V+1Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d2e8049_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Room_Item_Management_vue__ = __webpack_require__("883z");
function injectStyle (ssrContext) {
  __webpack_require__("0J3W")
  __webpack_require__("tDME")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d2e8049"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Room_Item_Management_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d2e8049_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Room_Item_Management_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/+6j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Combo_Box_vue__ = __webpack_require__("/Awy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80fdadbc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Combo_Box_vue__ = __webpack_require__("Wng7");
function injectStyle (ssrContext) {
  __webpack_require__("cvwv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Combo_Box_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80fdadbc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Combo_Box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Awy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedOption: {
        name: ''
      },
      showMenu: false,
      placeholderText: 'Please select an item'
    };
  },

  props: {
    options: {
      type: [Array, Object]
    },
    selected: {},
    placeholder: [String]
  },

  mounted: function mounted() {
    this.selectedOption = this.selected;
    if (this.placeholder) {
      this.placeholderText = this.placeholder;
    }
  },


  methods: {
    updateOption: function updateOption(option) {
      this.selectedOption = option;
      this.showMenu = false;
      this.$emit('updateOption', this.selectedOption);
    },
    toggleMenu: function toggleMenu() {
      this.showMenu = !this.showMenu;
    }
  }
});

/***/ }),

/***/ "/dPA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/s8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stream_slide_vue__ = __webpack_require__("9pno");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_913418a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stream_slide_vue__ = __webpack_require__("1Own");
function injectStyle (ssrContext) {
  __webpack_require__("mQLJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-913418a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stream_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_913418a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stream_slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/zlS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0J3W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0qWZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bets_vue__ = __webpack_require__("YO3H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35435f8d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bets_vue__ = __webpack_require__("HhlE");
function injectStyle (ssrContext) {
  __webpack_require__("j54e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35435f8d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35435f8d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0wuu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_Title_vue__ = __webpack_require__("mXMQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae14d65a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_Title_vue__ = __webpack_require__("ne0v");
function injectStyle (ssrContext) {
  __webpack_require__("3JVO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae14d65a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_Title_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae14d65a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_Title_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "15Fk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cssClasses},[(_vm.placed_bets && _vm.placed_bets.length > 0)?_c('table',{staticClass:"table table-hover table-bordered",attrs:{"id":"table"}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.placed_bets),function(placed,index){return _c('tr',{key:index},[_c('td',{attrs:{"data-title":"User"}},[_c('User',{attrs:{"user_id":placed.user_id}})],1),_vm._v(" "),_c('td',{attrs:{"data-title":"Bet"}},[_vm._v(_vm._s(_vm.$store.state.bets[_vm.bet_id].options[placed.option][0]))]),_vm._v(" "),_c('td',{attrs:{"data-title":"Amount"}},[_vm._v(_vm._s(_vm.formatCurrency(placed.amount)))]),_vm._v(" "),_c('td',{attrs:{"data-title":"Won"}},[_vm._v(_vm._s(placed.amount_won ? (placed.status === 2) ? _vm.formatCurrency(placed.amount_won) : "-" : "?"))])])}),0)]):_c('div',[_vm._v("No bets placed")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("User")]),_vm._v(" "),_c('th',[_vm._v("Bet On")]),_vm._v(" "),_c('th',[_vm._v("Amount Bet")]),_vm._v(" "),_c('th',[_vm._v("Amount Won")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1H49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrap",staticClass:"vue-slide-bar-component vue-slide-bar-horizontal",style:(_vm.calculateHeight),attrs:{"id":_vm.id},on:{"click":_vm.wrapClick}},[_c('div',{ref:"elem",staticClass:"vue-slide-bar",style:({
      height: (_vm.lineHeight + "px")
    })},[[_c('div',{ref:"tooltip",staticClass:"vue-slide-bar-always vue-slide-bar-tooltip-container",style:({'width': (_vm.iconWidth + "px")}),on:{"mousedown":_vm.moveStart,"touchstart":_vm.moveStart}},[(_vm.showTooltip)?_c('span',{staticClass:"vue-slide-bar-tooltip-top vue-slide-bar-tooltip-wrap"},[_vm._t("tooltip",[_c('span',{staticClass:"vue-slide-bar-tooltip",style:(_vm.tooltipStyles)},[_vm._v("\n              "+_vm._s(_vm.val)+"%\n            ")])])],2):_vm._e()])],_vm._v(" "),_c('div',{ref:"process",staticClass:"vue-slide-bar-process",style:(_vm.processStyle)})],2),_vm._v(" "),(_vm.range)?_c('div',{staticClass:"vue-slide-bar-range"},_vm._l((_vm.range),function(r,index){return _c('div',{key:index,staticClass:"vue-slide-bar-separate",style:(_vm.dataLabelStyles)},[(!r.isHide)?_c('span',{staticClass:"vue-slide-bar-separate-text"},[_vm._v("\n        "+_vm._s(r.label)+"\n      ")]):_vm._e()])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1L9+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Place_Bet_vue__ = __webpack_require__("uOmy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_779957b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Place_Bet_vue__ = __webpack_require__("vDKi");
function injectStyle (ssrContext) {
  __webpack_require__("aOAS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-779957b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Place_Bet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_779957b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Place_Bet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Own":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"featured",class:{ 'is-active': _vm.active },on:{"click":function($event){return _vm.clicked()}}},[_c('div',{staticClass:"featured__thumb"},[_c('img',{attrs:{"src":_vm.thumb,"alt":_vm.channel_data.name},on:{"error":_vm.fallbackThumb}})]),_vm._v(" "),_c('div',{staticClass:"featured__body"},[_c('div',{staticClass:"featured__name"},[_vm._v(_vm._s(_vm.channel_data.name))]),_vm._v(" "),_c('div',{staticClass:"featured__meta"},[_vm._v(_vm._s(_vm.channel_data.meta || _vm.channel_data.description))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1dfP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bet_vue__ = __webpack_require__("gss/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_721ecce7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bet_vue__ = __webpack_require__("wkEd");
function injectStyle (ssrContext) {
  __webpack_require__("fy0G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-721ecce7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_721ecce7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1e/U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InventoryBrowser',
  props: ['filterCategories'],
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('InventoryBrowser Created');
              // await this.refreshOwnedLootItems()

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    if (this.user) {
      this.refreshOwnedLootItems();
    }
  },
  data: function data() {
    return {
      ownedLootItemsFetched: false,
      todo: 'todfooo'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])(['myOwnedLootItemIds', 'currentUser']), {
    user: function user() {
      return this.currentUser;
    },
    myFilteredOwnedLootItemIds: function myFilteredOwnedLootItemIds() {
      var _this2 = this;

      return this.myOwnedLootItemIds.filter(function (olid) {
        var li = _this2.lootItemForOwnedLootItemId(olid);
        return li.category === 'roomItem';
      });
    }
  }),
  methods: {
    lootItemImageUrl: function lootItemImageUrl(lootItem) {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.WEB_ASSET_BASE_URL + '/' + lootItem.image_url;
    },
    refreshOwnedLootItems: function refreshOwnedLootItems() {
      if (this.ownedLootItemsFetched === false) {
        this.ownedLootItemsFetched = true;
        console.log('Refreshing Owned Loot Items');
        this.$store.dispatch('fetchOwnedLootItems');
      }
    },
    ownedLootItemForId: function ownedLootItemForId(id) {
      return this.$store.state.ownedLootItems[id];
    },
    lootItemForOwnedLootItemId: function lootItemForOwnedLootItemId(id) {
      return this.lootItemForId(this.ownedLootItemForId(id).loot_item_id);
    },
    lootItemForId: function lootItemForId(id) {
      return this.$store.state.lootItems[id];
    }
  },
  watch: {
    user: function user() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].nextTick();

              case 2:
                _this3.refreshOwnedLootItems();

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }
});

/***/ }),

/***/ "1zaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loot_Box_Management_vue__ = __webpack_require__("HE4W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bb9437a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loot_Box_Management_vue__ = __webpack_require__("En2B");
function injectStyle (ssrContext) {
  __webpack_require__("rpM4")
  __webpack_require__("uIN5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bb9437a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loot_Box_Management_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bb9437a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loot_Box_Management_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2fom":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"debug-panel"},[_vm._v("\n  Debug Panel\n  "),_c('button',{on:{"click":function($event){return _vm.debugNewBet()}}},[_vm._v("New Bet")]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.debugNewPlacedBet()}}},[_vm._v("New Placed Bet")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.debugNewTicketRaffle()}}},[_vm._v("New Ticket Raffle")]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.debugNewTicketRaffleEntry()}}},[_vm._v("New Ticket Raffle Entry")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2iXL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2nGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__User_Avatar__ = __webpack_require__("YpvZ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-status',
  components: {
    UserAvatar: __WEBPACK_IMPORTED_MODULE_3__User_Avatar__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['currentUser', 'currentBalance', 'currentGoldBalance']), {
    noDiscord: function noDiscord() {
      return this.currentUser && !this.currentUser.has_discord;
    }
  }),
  methods: {
    currencyIcon: function currencyIcon(priceCurrencyType) {
      var image = priceCurrencyType === 'mt' ? 'swiftGold.png' : 'swiftBucks.png';

      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.WEB_ASSET_BASE_URL + '/' + image;
    }
  }
});

/***/ }),

/***/ "3HkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Buy_Ticket__ = __webpack_require__("8VQ5");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ticket-raffle',
  props: ['ticketRaffleId'],
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.dispatch('fetchTicketRaffle', _this.ticketRaffleId);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  components: {
    buyTicket: __WEBPACK_IMPORTED_MODULE_2__Buy_Ticket__["a" /* default */]
  },
  data: function data() {
    return {
      showPlaced: false
    };
  },

  computed: {
    myTickets: function myTickets() {
      return this.$store.state.myTickets[this.ticketRaffleId] ? this.$store.state.myTickets[this.ticketRaffleId].quantity : 0;
    },
    ticketRaffle: function ticketRaffle() {
      return this.$store.state.ticketRaffles[this.ticketRaffleId];
    },
    ticketRaffleStatus: function ticketRaffleStatus() {
      /*
        "created": 1,
        "completed": 2,
        "pending': 3,
        'canceled': 4
      */
      if (this.ticketRaffle.status === 2) {
        return 'Completed';
      } else if (this.ticketRaffle.status === 4) {
        return 'Canceled';
      } else if (this.ticketRaffle.status === 5) {
        return 'Closed';
      } else {
        return 'Open';
      }
    }
  },
  methods: {
    showRaffle: function showRaffle() {
      if (!this.placedFetched && !this.showPlaced) {
        this.$store.dispatch('fetchTicketRaffle', this.ticketRaffleId);
        this.showPlaced = true;
      }
    },
    hideRaffle: function hideRaffle() {
      this.showPlaced = false;
    },
    callBuyTicket: function callBuyTicket(amount) {
      var raffleIdx = this.ticketRaffleId;
      this.$store.dispatch('buyTicket', { raffleIdx: raffleIdx, amount: amount });
    },
    collapseSection: function collapseSection(element) {
      element.style.maxHeight = 0 + 'px';
    }
  }
});

/***/ }),

/***/ "3JVO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3iHT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3irE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3xjD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"sl-avatar",style:(_vm.showFallback ? { backgroundImage: _vm.gradient } : null),attrs:{"title":_vm.name}},[(!_vm.showFallback)?_c('img',{attrs:{"src":_vm.src,"alt":_vm.name},on:{"error":function($event){_vm.failed = true}}}):_c('svg',{staticClass:"sl-avatar__letter",attrs:{"viewBox":"0 0 40 40","aria-hidden":"true"}},[_c('text',{attrs:{"x":"20","y":"27","text-anchor":"middle"}},[_vm._v(_vm._s(_vm.initial))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "41Su":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stream_slide__ = __webpack_require__("/s8k");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'slider',
  components: {
    streamSlide: __WEBPACK_IMPORTED_MODULE_0__stream_slide__["a" /* default */]
  },
  computed: {
    active: function active() {
      return this.featuredChannels[this.activeIndex];
    },
    channelSlug: function channelSlug() {
      return this.active.name.toLowerCase();
    },
    channelUrl: function channelUrl() {
      return 'https://www.twitch.tv/' + this.channelSlug;
    },
    subscribeUrl: function subscribeUrl() {
      return 'https://www.twitch.tv/subs/' + this.channelSlug;
    }
  },
  methods: {
    setActive: function setActive(index) {
      this.activeIndex = index;
    },
    goBounties: function goBounties() {
      this.$router.push({ path: '/bounties' });
    }
  },
  data: function data() {
    return {
      activeIndex: 0,
      featuredChannels: [{
        name: 'Swiftor',
        url: 'https://player.twitch.tv/?channel=swiftor&parent=swiftorland.com',
        twitch_id: '274625',
        prof_pic: 'https://static-cdn.jtvnw.net/jtv_user_pictures/2174635e-aa4c-42e0-b00b-d1fb6bff9cf0-profile_image-300x300.png',
        banner: 'https://static-cdn.jtvnw.net/jtv_user_pictures/2174635e-aa4c-42e0-b00b-d1fb6bff9cf0-profile_image-300x300.png',
        // `meta` is the short line shown in the Featured rail; `description`
        // is the longer blurb shown only for the channel you're watching
        meta: 'Main channel',
        description: 'Gaming with the community since 2008. As the face of SwiftRage, poor anger management comes standard.'
      }, {
        name: 'Spin247',
        url: 'https://player.twitch.tv/?channel=spin247&parent=swiftorland.com',
        twitch_id: '276400590',
        prof_pic: 'https://static-cdn.jtvnw.net/jtv_user_pictures/0623e8bb-24b5-4d81-8138-b976afe9dbe9-profile_image-70x70.png',
        banner: 'https://static-cdn.jtvnw.net/jtv_user_pictures/0623e8bb-24b5-4d81-8138-b976afe9dbe9-profile_image-300x300.png',
        meta: 'Live 24/7',
        description: 'Play roulette using swiftbucks, Live 24/7'
      }, {
        name: 'SwiftorCasino',
        url: 'https://player.twitch.tv/?channel=swiftorcasino&parent=swiftorland.com',
        twitch_id: '432195675',
        prof_pic: 'https://static-cdn.jtvnw.net/jtv_user_pictures/c2e99394-1e2a-4d48-b942-5a804c4cf052-profile_image-70x70.png',
        banner: 'https://static-cdn.jtvnw.net/jtv_user_pictures/9e32e0d7-d202-49d6-a6d4-6381fc27af6d-profile_banner-480.jpeg',
        meta: 'Swiftor community channel',
        description: 'Live dealer games for Swiftbucks. Channel is part of the Swiftor community. General Manager: Annorax10 Assistant GM: Reptile__dysfunctionShift Managers:Pit Bosses:Dealers: Annorax, Reptile, Ryygaming'
      }]
    };
  }
});

/***/ }),

/***/ "4Q3t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Room_Browser_vue__ = __webpack_require__("zZHJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b29699c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Room_Browser_vue__ = __webpack_require__("l9jD");
function injectStyle (ssrContext) {
  __webpack_require__("A8aH")
  __webpack_require__("n9vI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b29699c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Room_Browser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b29699c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Room_Browser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5YNp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AchievementProgressBar__ = __webpack_require__("wvpE");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rates',
  components: {
    AchievementProgressBar: __WEBPACK_IMPORTED_MODULE_2__components_AchievementProgressBar__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userRates', 'currentUser'])),
  data: function data() {
    return {
      description: {
        title: 'Loot Shop',
        text: 'Spend SwiftBUCKS and SwiftGOLD on awesome loot!'
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])({
    fetchUserRates: 'fetchUserRates'
  })),
  mounted: function mounted() {
    this.fetchUserRates();
  },

  watch: {
    currentUser: function currentUser() {
      var _this = this;

      this.$nextTick(function () {
        _this.fetchUserRates();
      });
    }
  }
});

/***/ }),

/***/ "634k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,on:{"click":_vm.loginRedirect}},[_c('svg',{staticClass:"bi bi-discord",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z"}})]),_c('span',{staticClass:"discord-text"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6NJJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__User__ = __webpack_require__("jyJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component__ = __webpack_require__("lCKi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slider_component_theme_antd_css__ = __webpack_require__("KgMc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slider_component_theme_antd_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_slider_component_theme_antd_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var scriptLoaded = false;
var scriptFinished = false;

var packages = [{
  name: 'SwiftGOLD',
  denomination: 'SwiftGOLD',
  quantityButtons: [5, 10, 20, 30, 40, 50, 75, 100, 200, 300, 400, 500],
  interval: 1,
  authThreshold: 100,
  maxQuantity: 100,
  authMaxQuantity: 500,
  cost: function cost(qty) {
    return qty * 1;
  },
  sku: 'GOLD'
}];

/* global paypal */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gold',
  props: ['user_id'],
  components: {
    VueSlider: __WEBPACK_IMPORTED_MODULE_4_vue_slider_component___default.a,
    User: __WEBPACK_IMPORTED_MODULE_3__User__["a" /* default */]
  },
  data: function data() {
    return {
      displayAmount: 5,
      tsxSuccess: false,
      tsxError: undefined,
      processing: false,
      donation: {},
      baseButtonAmounts: [5, 10, 25, 50, 66.66, 75, 100],
      additionalButtonAmounts: [150, 200, 300, 400, 500],
      paypalDisplayed: false,
      message: '',
      quantity: 1,
      selectedPackage: '0'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])(['currentUser']), {
    // amount () {
    //   return this.convertToMoney(this.displayAmount)
    // },
    buttonAmounts: function buttonAmounts() {
      var _this = this;

      if (this.currentUser) {
        return this.package.quantityButtons;
      } else {
        return this.package.quantityButtons.filter(function (b) {
          return b <= _this.authThreshold;
        });
      }
    },
    sliderMax: function sliderMax() {
      return this.currentUser ? this.authMaxQuantity : this.maxQuantity;
    },
    user: function user() {
      if (this.user_id) {
        return this.$store.state.users[this.user_id.toLowerCase()];
      } else {
        return this.currentUser;
      }
    },
    forUserId: function forUserId() {
      if (this.user_id) {
        return this.user_id;
      } else {
        return this.currentUser ? this.currentUser.id : undefined;
      }
      // return this.user_id ? this.user_id.toLowerCase() : this.currentUser.id
    },
    cost: function cost() {
      // return Math.round(parseInt(this.amount) / 5)
      return this.package.cost(this.quantity);
    },
    package: function _package() {
      return packages[parseInt(this.selectedPackage)];
    },
    name: function name() {
      return this.package.name;
    },
    denomination: function denomination() {
      return this.package.denomination;
    },
    authThreshold: function authThreshold() {
      return this.package.authThreshold;
    },
    interval: function interval() {
      return this.package.interval || 1;
    },
    authMaxQuantity: function authMaxQuantity() {
      return this.package.authMaxQuantity || 100;
    },
    maxQuantity: function maxQuantity() {
      return this.package.maxQuantity || 20;
    },
    sku: function sku() {
      return this.package.sku;
    },
    hasMessage: function hasMessage() {
      return this.package.hasMessage || false;
    }
  }),
  watch: {
    user: function user() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6_vue__["default"].nextTick();

              case 2:
                _this2.displayPaypal();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    '$route.path': function $routePath(to, from) {},
    selectedPackage: function selectedPackage() {
      this.quantity = 1;
    }
  },
  updated: function updated() {
    this.displayPaypal();
  },
  destroyed: function destroyed() {},
  mounted: function mounted() {
    if (this.user) {
      this.displayPaypal();
    }
  },

  created: function created() {
    var _this3 = this;

    if (!scriptLoaded) {
      this.$store.dispatch('fetchUser', this.user_id);
      var paypalScript = document.createElement('script');
      paypalScript.setAttribute('src', 'https://www.paypal.com/sdk/js?client-id=' + __WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.PAYPAL_CLIENT_ID + '&disable-funding=credit');
      document.head.appendChild(paypalScript);

      paypalScript.onload = function () {
        scriptFinished = true;

        _this3.displayPaypal();
      };

      scriptLoaded = paypalScript;
    }

    this.paypalScript = scriptLoaded;
  },
  methods: {
    buttonLabel: function buttonLabel(qty) {
      return qty + ' for $' + this.costFor(qty);
    },
    costFor: function costFor(qty) {
      return this.package.cost(qty);
    },
    convertToMoney: function convertToMoney(amt) {
      return amt.toString().includes('.') ? amt : amt + '.00';
    },
    displayPaypal: function displayPaypal() {
      var _this4 = this;

      if (!this.user || !scriptFinished || this.paypalDisplayed || !this.paypalScript) {
        return;
      } else {
        this.paypalDisplayed = true;
      }

      paypal.Buttons({
        createOrder: function createOrder(data, actions) {
          return actions.order.create({
            application_context: { shipping_preference: 'NO_SHIPPING' },
            purchase_units: [{
              reference_id: _this4.sku + '_' + _this4.forUserId,
              amount: {
                value: '' + _this4.cost
              }
            }]
          });
        },
        onApprove: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(data, actions) {
            var result, sku;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _this4.processing = true;
                    _context2.next = 3;
                    return _this4.$store.dispatch('captureDonation', { orderId: data.orderID, message: _this4.message });

                  case 3:
                    result = _context2.sent;

                    _this4.processing = false;
                    if (!result || result.error) {
                      _this4.tsxError = result.error.data ? result.error.data : result.error;
                    } else {
                      _this4.tsxSuccess = true;
                      _this4.donation = result.donation;

                      sku = 'UNKNOWN';

                      if (_this4.donation.reference_id) {
                        sku = _this4.donation.reference_id.split('_')[0];
                      }
                      // this.$gtag.purchase({
                      //   'transaction_id': this.donation.order_id,
                      //   'affiliation': 'Gold Page',
                      //   'value': this.donation.amount,
                      //   'currency': 'USD',
                      //   'items': [
                      //     {
                      //       'id': sku,
                      //       'name': sku
                      //     }
                      //   ]
                      // })
                      _this4.$gtag.query('event', 'purchase', {
                        'transaction_id': _this4.donation.order_id,
                        'affiliation': 'Gold Page',
                        'value': parseFloat(_this4.donation.amount),
                        'currency': 'USD',
                        'items': [{
                          'item_id': sku,
                          'item_name': sku
                        }]
                      });
                    }

                  case 6:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this4);
          }));

          return function onApprove(_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }()
      }).render('#paypal-button-container');
    },
    changeQuantity: function changeQuantity(qty) {
      this.quantity = qty;
    }
  }
});

/***/ }),

/***/ "6SV5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6Wjt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7ONy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7d4M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slider_vue__ = __webpack_require__("41Su");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57be7f9f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_vue__ = __webpack_require__("JGAR");
function injectStyle (ssrContext) {
  __webpack_require__("NifY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57be7f9f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57be7f9f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "883z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"room-item-management"}},[_c('info-box',{attrs:{"description":_vm.description}}),_vm._v(" "),_c('header-title',{attrs:{"title":"ROOM ITEMS"}}),_vm._v(" "),(_vm.notification)?_c('span',[_vm._v(_vm._s(_vm.notification))]):_vm._e(),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn-enabled",on:{"click":function($event){return _vm.create()}}},[_vm._v("CREATE")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.roomItemPageCurrent))]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[(_vm.roomItemPages[_vm.roomItemPageCurrent])?_c('table',{staticClass:"editor-table"},_vm._l((_vm.roomItemPages[_vm.roomItemPageCurrent]['loot_items']),function(item){return _c('tr',{key:item.id},[_c('td',[_c('img',{staticStyle:{"width":"100px"},attrs:{"src":_vm.lootItemImageUrl(item)}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_c('router-link',{staticClass:"btn-enabled",staticStyle:{"width":"50px","height":"30px","line-height":"30px","text-align":"center"},attrs:{"to":{ name: 'RoomItemEditor', params: { itemId: item.id }}}},[_vm._v("Edit")])],1)])}),0):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn-enabled",on:{"click":function($event){return _vm.next()}}},[_vm._v("Next")]),_vm._v(" "),(_vm.roomItemPageCurrent > 0)?_c('button',{staticClass:"btn-enabled",on:{"click":function($event){return _vm.back()}}},[_vm._v("Back")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8P3/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('info-box',{attrs:{"description":_vm.description}}),_vm._v(" "),_c('header-title',{attrs:{"title":"SETTINGS"}}),_vm._v("\n  "+_vm._s(_vm.message)+"\n  "),(_vm.currentUser)?_c('div',{staticStyle:{"overflow-y":"auto"},style:({maxHeight: '85%'})},[(!_vm.noDiscord)?_c('div',{staticClass:"discord-btn",on:{"click":_vm.disconnectDiscord}},[_c('span',[_vm._v("Disconnect Discord")]),_vm._v(" "),_c('span',{staticClass:"helper"}),_vm._v(" "),_c('svg',{staticClass:"bi bi-discord",staticStyle:{"float":"right"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"discord-btn",staticStyle:{"display":"table"},on:{"click":_vm.logout}},[_c('span',{staticStyle:{"display":"table-cell","vertical-align":"middle"}},[_vm._v("Logout")])])]):_c('span',[_c('login-btn',{staticStyle:{"font-size":"40px","padding":"8px"},attrs:{"buttonClass":"btn-enabled"}},[_vm._v("Login to View Settings!")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Rkw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_BigNumber_js__ = __webpack_require__("RgCM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_BigNumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_BigNumber_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loot-shop',
  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.refreshLootItems();

            case 2:
              if (_this.myOwnedLootItemIds) {
                _context.next = 4;
                break;
              }

              return _context.abrupt('return');

            case 4:
              _this.myOwnedLootItemIds.forEach(function (oliid) {
                __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(_this.ownedLootItemsByLootItemId, _this.ownedLootItems[oliid].loot_item_id, _this.ownedLootItems[oliid]);
              });

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      description: {
        title: 'Loot Shop',
        text: 'Spend SwiftBUCKS and SwiftGOLD on awesome loot!'
      },
      ownedLootItemsByLootItemId: {},
      waitingForPurchase: false,
      notification: undefined,
      unbuyableLootItemIds: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['currentUser', 'currentGoldBalance', 'currentBalance', 'lootShopLootItemIds', 'lootShopLootItems', 'myOwnedLootItemIds', 'ownedLootItems']), {}),
  methods: {
    refreshLootItems: function refreshLootItems() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$store.dispatch('fetchLootShopLootItems');
                _this2.$store.dispatch('fetchOwnedLootItems');

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    categoryTextFor: function categoryTextFor(shopItem) {
      if (shopItem.category === 'lootChest') {
        return 'Virtual LOOTCHEST';
      } else if (shopItem.category === 'roomItem') {
        return 'Virtual Room Item';
      } else {
        return 'Token';
      }
    },
    lootShopLootItemForId: function lootShopLootItemForId(id) {
      return this.$store.state.lootShopLootItems[id];
    },
    lootItemImageUrl: function lootItemImageUrl(lootItem) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.WEB_ASSET_BASE_URL + '/' + lootItem.image_url;
    },
    currencyIcon: function currencyIcon(priceCurrencyType) {
      var image = priceCurrencyType === 'mt' ? 'swiftGold.png' : 'swiftBucks.png';

      return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.WEB_ASSET_BASE_URL + '/' + image;
    },
    attributionText: function attributionText(lootItem) {
      if (!lootItem.attribution_author) {
        return;
      }
      // // "Creative Commons 10th Birthday Celebration San Francisco" by tvol is licensed under CC BY 2.0
      return '<a href="' + lootItem.attribution_title_url + '" target="_blank">"' + lootItem.attribution_title + '"</a> by <a href="' + lootItem.attribution_author_url + '" target="_blank">' + lootItem.attribution_author + '</a> <br/> Licensed under <a href="' + lootItem.attribution_license_url + '" target="_blank">' + lootItem.attribution_license + '</a>';
    },
    requiresAttribution: function requiresAttribution(lootItem) {
      return !!lootItem.attribution_author;
    },
    allowedToBuy: function allowedToBuy(lootItem) {
      if (this.ownedLootItemsByLootItemId && this.ownedLootItemsByLootItemId[lootItem.id]) {
        if (lootItem.max_allowed > 0 && lootItem.max_allowed <= this.ownedLootItemsByLootItemId[lootItem.id].quantity) {
          return { allowed: false, reason: 'Max already owned.' };
        }
      }

      if (this.unbuyableLootItemIds.indexOf(lootItem.id) !== -1) {
        return { allowed: false, reason: 'Purchased max number today, wait until tomorrow!' };
      }

      var price = new __WEBPACK_IMPORTED_MODULE_5_BigNumber_js___default.a(lootItem.price);
      var rightBalance = lootItem.price_currency_type === 'mt' ? this.currentGoldBalance : this.currentBalance;
      var currentTotal = new __WEBPACK_IMPORTED_MODULE_5_BigNumber_js___default.a(rightBalance ? rightBalance.total : 0);
      if (price.gt(currentTotal)) {
        var message = lootItem.price_currency_type === 'mt' ? 'SwiftGOLD' : 'SwiftBUCKS';
        return { allowed: false, reason: 'Not enough ' + message };
      }

      return { allowed: true };
    },
    buy: function buy(lootItem) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this3.waitingForPurchase) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:

                _this3.waitingForPurchase = true;
                response = void 0;
                _context3.prev = 4;
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/item_purchases', {
                  'lootItemId': lootItem.id.toString()
                }, { withCredentials: true });

              case 7:
                response = _context3.sent;
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](4);

                if (_context3.t0 && _context3.t0.response) {
                  response = _context3.t0.response;
                }

              case 13:

                if (response && response.data && response.data.success) {
                  // this.$gtag.purchase({
                  //   'affiliation': 'Loot Shop Page',
                  //   'value': lootItem.price,
                  //   'currency': lootItem.price_currency_type,
                  //   'items': [
                  //     {
                  //       'id': lootItem.id,
                  //       'name': lootItem.name
                  //     }
                  //   ]
                  // })

                  // this.$gtag.event('spend_virtual_currency', {
                  // })

                  _this3.$gtag.query('event', 'spend_virtual_currency', {
                    item_name: lootItem.name,
                    virtual_currency_name: lootItem.price_currency_type,
                    value: parseInt(lootItem.price)
                  });

                  _this3.notify(lootItem.name + ' Purchased!');
                } else if (response && response.data && response.data.error && response.data.error.error_code === 'ipmpd1') {
                  _this3.notify('Sorry! You\'ve purchased the max number of ' + lootItem.name + ' today, wait until tomorrow!');
                  _this3.unbuyableLootItemIds.push(lootItem.id);
                } else {
                  _this3.notify('Error Purchasing - Try again later.');
                }

                setTimeout(function () {
                  _this3.waitingForPurchase = false;
                }, 1000);
                _this3.$store.dispatch('fetchBalances');
                _this3.$store.dispatch('fetchOwnedLootItems');

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[4, 10]]);
      }))();
    },
    notify: function notify(text) {
      var _this4 = this;

      this.notification = text;
      setTimeout(function () {
        _this4.notification = undefined;
      }, 5000);
    }
  },
  watch: {
    ownedLootItems: {
      deep: true,
      handler: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(nv, ov) {
          var _this5 = this;

          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].nextTick();

                case 2:
                  if (this.ownedLootItems) {
                    _context4.next = 4;
                    break;
                  }

                  return _context4.abrupt('return');

                case 4:

                  this.myOwnedLootItemIds.forEach(function (oliid) {
                    __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(_this5.ownedLootItemsByLootItemId, _this5.ownedLootItems[oliid].loot_item_id, _this5.ownedLootItems[oliid]);
                  });

                case 5:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function handler(_x, _x2) {
          return _ref.apply(this, arguments);
        }

        return handler;
      }()
    },
    currentUser: function currentUser() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].nextTick();

              case 2:
                _this6.$store.dispatch('fetchOwnedLootItems');

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    }
  }
});

/***/ }),

/***/ "8VQ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Buy_Ticket_vue__ = __webpack_require__("e8mT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bf52c5f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Buy_Ticket_vue__ = __webpack_require__("EGYs");
function injectStyle (ssrContext) {
  __webpack_require__("Ykvt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3bf52c5f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Buy_Ticket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bf52c5f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Buy_Ticket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8vID":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Debug_Panel_vue__ = __webpack_require__("aKwC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_559ebf74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Debug_Panel_vue__ = __webpack_require__("2fom");
function injectStyle (ssrContext) {
  __webpack_require__("MwQK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Debug_Panel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_559ebf74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Debug_Panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9pno":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stream-slide',
  props: {
    channel_data: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      thumb: this.channel_data.banner
    };
  },

  methods: {
    // banners occasionally 404 on Twitch's CDN — fall back to the avatar
    fallbackThumb: function fallbackThumb() {
      if (this.thumb !== this.channel_data.prof_pic) {
        this.thumb = this.channel_data.prof_pic;
      }
    },
    clicked: function clicked() {
      this.$emit('select', this.channel_data);
    }
  }
});

/***/ }),

/***/ "A8aH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AXKg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"room-item-management"}},[_c('info-box',{attrs:{"description":_vm.description}}),_vm._v(" "),_c('header-title',{attrs:{"title":"LOOT BOX EDITOR"}}),_vm._v(" "),(_vm.notification)?_c('span',[_vm._v(_vm._s(_vm.notification))]):_vm._e(),_vm._v(" "),(!_vm.existingItem)?_c('h1',[_vm._v("Create Loot Box")]):_c('h1',[_vm._v("Editing Loot Box "+_vm._s(_vm.existingItem.id))]),_vm._v(" "),_c('div',[_c('div',[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/loot-box-management"}},[_vm._v("Back to list")])],1),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"},attrs:{"border":"1"}},[_c('tr',[_c('td',[_vm._v("Name")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemName),expression:"itemName"}],attrs:{"type":"text","placeholder":"Enter","align":"center"},domProps:{"value":(_vm.itemName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.itemName=$event.target.value}}})]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("Description")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemDescription),expression:"itemDescription"}],attrs:{"type":"text","placeholder":"Enter","align":"center"},domProps:{"value":(_vm.itemDescription)},on:{"input":function($event){if($event.target.composing){ return; }_vm.itemDescription=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Rarity")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemRarity),expression:"itemRarity"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.itemRarity=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("common")]),_vm._v(" "),_c('option',[_vm._v("uncommon")]),_vm._v(" "),_c('option',[_vm._v("rare")]),_vm._v(" "),_c('option',[_vm._v("legendary")]),_vm._v(" "),_c('option',[_vm._v("exotic")])])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("For Sale?")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemForSale),expression:"itemForSale"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.itemForSale=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":true}},[_vm._v("true")]),_vm._v(" "),_c('option',{domProps:{"value":false}},[_vm._v("false")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Price")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemPrice),expression:"itemPrice"}],attrs:{"type":"text","placeholder":"Enter","align":"center"},domProps:{"value":(_vm.itemPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.itemPrice=$event.target.value}}})]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("Currency Type")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemPriceCurrencyType),expression:"itemPriceCurrencyType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.itemPriceCurrencyType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("sb")]),_vm._v(" "),_c('option',{attrs:{"value":"mt"}},[_vm._v("mt (gold)")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Loot Box Type\n        ")]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.lootBoxType),expression:"lootBoxType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.lootBoxType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("random")]),_vm._v(" "),_c('option',[_vm._v("guaranteed")])])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("Max Per Day (0=unlimited)")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maxPerDay),expression:"maxPerDay"}],attrs:{"type":"text","placeholder":"Enter","align":"center"},domProps:{"value":(_vm.maxPerDay)},on:{"input":function($event){if($event.target.composing){ return; }_vm.maxPerDay=$event.target.value}}})])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('tr',[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chanceCommon),expression:"chanceCommon"}],attrs:{"type":"text","placeholder":"","align":"center"},domProps:{"value":(_vm.chanceCommon)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chanceCommon=$event.target.value}}}),_vm._v("%")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chanceUncommon),expression:"chanceUncommon"}],attrs:{"type":"text","placeholder":"","align":"center"},domProps:{"value":(_vm.chanceUncommon)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chanceUncommon=$event.target.value}}}),_vm._v("%")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chanceRare),expression:"chanceRare"}],attrs:{"type":"text","placeholder":"","align":"center"},domProps:{"value":(_vm.chanceRare)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chanceRare=$event.target.value}}}),_vm._v("%")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chanceLegendary),expression:"chanceLegendary"}],attrs:{"type":"text","placeholder":"","align":"center"},domProps:{"value":(_vm.chanceLegendary)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chanceLegendary=$event.target.value}}}),_vm._v("%")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chanceExotic),expression:"chanceExotic"}],attrs:{"type":"text","placeholder":"","align":"center"},domProps:{"value":(_vm.chanceExotic)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chanceExotic=$event.target.value}}}),_vm._v("%")])]),_vm._v(" "),_c('tr',_vm._l((Object.keys(_vm.selectedMap)),function(key){return _c('td',{key:key},_vm._l((_vm.selectedMap[key]),function(item){return _c('div',{key:item.id,staticStyle:{"padding-top":"5px","padding-bottom":"5px"}},[_c('img',{staticStyle:{"width":"50px"},attrs:{"src":_vm.lootItemImageUrl(item)}}),_c('br'),_vm._v("\n            "+_vm._s(item.name)+"\n          ")])}),0)}),0)]),_vm._v(" "),_c('br'),_vm._v("\n    Current Total: "+_vm._s(_vm.chanceTotal)+"% "),(_vm.chanceTotal != 100)?_c('span',[_vm._v("Total Must Be 100")]):_vm._e(),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn-enabled",on:{"click":function($event){return _vm.save()}}},[_vm._v("SAVE"),(_vm.isSaving)?[_vm._v("ing..")]:_vm._e()],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.roomItemPages[_vm.roomItemPageCurrent])?_c('table',{staticStyle:{"width":"100%"},attrs:{"border":"1"}},_vm._l((_vm.roomItemPages[_vm.roomItemPageCurrent]['loot_items']),function(item){return _c('tr',{key:item.id},[_c('td',[_c('img',{staticStyle:{"width":"100px"},attrs:{"src":_vm.lootItemImageUrl(item)}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.rarity))]),_vm._v(" "),_c('td',[(!_vm.containsSelected(item))?_c('button',{on:{"click":function($event){return _vm.addSelected(item)}}},[_vm._v("Select")]):_c('button',{on:{"click":function($event){return _vm.removeSelected(item)}}},[_vm._v("Deselect")])])])}),0):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn-enabled",on:{"click":function($event){return _vm.next()}}},[_vm._v("Next")]),_vm._v(" "),(_vm.roomItemPageCurrent > 0)?_c('button',{staticClass:"btn-enabled",on:{"click":function($event){return _vm.back()}}},[_vm._v("Back")]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"height":"20px","background-color":"#674a4a"},attrs:{"colspan":"5"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("Common")]),_vm._v(" "),_c('td',[_vm._v("Uncommon")]),_vm._v(" "),_c('td',[_vm._v("Rare")]),_vm._v(" "),_c('td',[_vm._v("Legendary")]),_vm._v(" "),_c('td',[_vm._v("Exotic")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Axgb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__User__ = __webpack_require__("jyJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InventoryBrowser__ = __webpack_require__("J2ke");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobile_device_detect__ = __webpack_require__("nBUE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobile_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mobile_device_detect__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var scriptLoaded = false;
var scriptFinished = false;

/* global SwiftorRooms */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rooms',
  props: ['twitch_name'],
  components: {
    User: __WEBPACK_IMPORTED_MODULE_4__User__["a" /* default */],
    InventoryBrowser: __WEBPACK_IMPORTED_MODULE_5__InventoryBrowser__["a" /* default */]
  },
  data: function data() {
    return {
      roomDisplayed: false,
      room: undefined,
      roomManager: undefined,
      roomObjectMap: {},
      wallParams: {},
      floorParams: {},
      notification: undefined
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])(['currentUser', 'noCurrentUser']), {
    isMobileBrowser: function isMobileBrowser() {
      return __WEBPACK_IMPORTED_MODULE_9_mobile_device_detect__["isMobile"];
    },
    user: function user() {
      if (this.twitch_name) {
        return this.$store.state.users[this.$store.state.userIdByTwitchNames[this.twitch_name]];
      } else {
        return this.currentUser;
      }
    },
    user_id: function user_id() {
      return this.$store.state.userIdByTwitchNames[this.twitch_name];
    },
    editable: function editable() {
      return this.user && this.currentUser && this.user.id === this.currentUser.id;
    },
    showBrowser: function showBrowser() {
      return this.editable && this.roomManager;
    },
    showLogin: function showLogin() {
      return !this.user && !this.twitch_name;
    }
  }),
  watch: {
    '$route': function $route() {
      this.roomDisplayed = false;
    },
    user: function user(nv, ov) {
      this.displayRoom();
    },
    twitch_name: function twitch_name(nv, ov) {
      if (this.twitch_name) {
        this.$store.dispatch('fetchUserByTwitchName', this.twitch_name);
      }
    },
    '$route.path': function $routePath(to, from) {}
  },
  updated: function updated() {},
  destroyed: function destroyed() {},
  mounted: function mounted() {
    if (this.user) {
      this.displayRoom();
    }
  },

  created: function created() {
    var _this = this;

    if (!scriptLoaded) {
      if (this.twitch_name) {
        this.$store.dispatch('fetchUserByTwitchName', this.twitch_name);
      }

      var roomScript = document.createElement('script');
      roomScript.setAttribute('src', __WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.ROOM_JS_URL);
      document.head.appendChild(roomScript);

      roomScript.onload = function () {
        scriptFinished = true;

        _this.displayRoom();
      };

      scriptLoaded = roomScript;
    }

    this.roomScript = scriptLoaded;
  },
  methods: {
    nextRoom: function nextRoom() {
      this.twitch_name = 'crash2burn';
    },
    copyToClipboard: function copyToClipboard() {
      var el = document.createElement('textarea');
      console.log(this.user);
      el.value = 'https://swiftorland.com/#/rooms/' + encodeURIComponent(this.user.twitch_name);
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      this.notify('https://swiftorland.com/#/rooms/' + this.user.twitch_name + ' copied to clipboard!');
    },
    isRoomItem: function isRoomItem(lootItem) {
      return lootItem.meta.objectType === '2d' || lootItem.meta.objectType === '3d' || lootItem.meta.objectType === 'wall';
    },
    isWallBaseItem: function isWallBaseItem(lootItem) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      var res = lootItem.meta.objectType === 'wallBase';
      if (position) {
        res = res && (!this.wallParams[position] || this.wallParams[position].loot_item_id !== lootItem.id);
      }
      return res;
    },
    isFloorBaseItem: function isFloorBaseItem(lootItem) {
      return lootItem.meta.objectType === 'floorBase';
    },
    isCurrentFloorBaseItem: function isCurrentFloorBaseItem(lootItem) {
      return lootItem.id === this.floorParams.loot_item_id;
    },
    canPlaceInRoom: function canPlaceInRoom(lootItemId, ownedLootItem) {
      var nir = this.numberInRoom(lootItemId);
      return nir < ownedLootItem.quantity && nir <= 10;
    },
    numberInRoom: function numberInRoom(lootItemId) {
      if (this.roomManager && this.roomManager.room) {
        return this.roomObjectMap[lootItemId] ? this.roomObjectMap[lootItemId].length : 0;
      } else {
        return 66;
      }
    },
    saveRoom: function saveRoom() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/rooms/' + _this2.currentUser.id.toString(), {
                  'items': _this2.roomParams().items,
                  'walls': _this2.wallParams,
                  'floor': _this2.floorParams
                }, { withCredentials: true });

              case 2:
                response = _context.sent;

                if (response.data.room) {
                  _this2.notify('Room Saved.');
                } else {
                  _this2.notify('ERROR SAVING.');
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    notify: function notify(text) {
      var _this3 = this;

      this.notification = text;
      setTimeout(function () {
        _this3.notification = undefined;
      }, 5000);
    },
    roomParams: function roomParams() {
      var _this4 = this;

      var items = [];

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.roomObjectMap).forEach(function (lootItemId) {
        _this4.roomObjectMap[lootItemId].forEach(function (roomObject) {
          items.push({
            loot_item_id: lootItemId,
            meta: roomObject.toMeta()
          });
        });
      });
      return {
        items: items
      };
    },
    setWallBase: function setWallBase(position, ownedLootItem, lootItem) {
      if (this.wallParams[position] && this.wallParams[position].loot_item_id === lootItem.id) {
        return this.removeWallBase(position);
      }
      this.roomManager.room.createWall(position, lootItem.meta);
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(this.wallParams, position, { loot_item_id: lootItem.id });
    },
    removeWallBase: function removeWallBase(position) {
      this.roomManager.room.createWall(position);
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(this.wallParams, position, undefined);
    },
    setFloorBase: function setFloorBase(ownedLootItem, lootItem) {
      if (this.floorParams && this.floorParams.loot_item_id === lootItem.id) {
        return this.removeFloorBase();
      }
      console.log('CREATEING FLOOR', lootItem.meta);
      this.roomManager.room.createFloor(lootItem.meta);
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(this.floorParams, 'loot_item_id', lootItem.id);
    },
    removeFloorBase: function removeFloorBase() {
      this.roomManager.room.createFloor();
      this.floorParams = {};
    },
    addToRoom: function addToRoom(ownedLootItem, lootItem) {
      var roomObject = this.roomManager.room.addRoomObject(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, ownedLootItem.meta, lootItem.meta));
      var arr = this.roomObjectMap[lootItem.id] || [];
      // this.roomObjectMap[lootItem.id] = this.roomObjectMap[lootItem.id] || []
      arr.push(roomObject);
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(this.roomObjectMap, lootItem.id, arr);
      return roomObject;
    },
    removeFromRoom: function removeFromRoom(ownedLootItem, lootItem) {
      var roomObject = this.roomObjectMap[lootItem.id][0];
      var arr = this.roomObjectMap[lootItem.id] || [];
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(this.roomObjectMap, lootItem.id, arr.splice(1));
      this.roomManager.room.removeRoomObject(roomObject.uuid);
    },
    roomItemToRoomObject: function roomItemToRoomObject(roomItem) {
      /*
      {
        loot_item_id: "",
        meta: "",
        loot_item: {}
      }
      */
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, roomItem.meta, roomItem.loot_item.meta);
    },
    displayRoom: function displayRoom() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!scriptFinished || !_this5.user || _this5.roomDisplayed === _this5.user.id)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/rooms/' + _this5.user.id, { withCredentials: true });

              case 6:
                response = _context2.sent;

                if (!(_this5.roomDisplayed !== _this5.user.id && response && response.data.room)) {
                  _context2.next = 23;
                  break;
                }

                _this5.room = undefined;
                _this5.roomManager = undefined;
                _this5.roomObjectMap = {};

                _this5.room = response.data.room;

                _this5.roomManager = new SwiftorRooms.RoomManager(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({
                  container: document.getElementById('room-container'),
                  assetBaseUrl: __WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.ITEM_ASSET_BASE_URL,
                  editable: _this5.editable,
                  isMobile: __WEBPACK_IMPORTED_MODULE_9_mobile_device_detect__["isMobile"]
                }));
                _this5.roomManager.start();

                if (_this5.room.meta && _this5.room.meta.wallParams) {
                  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this5.room.meta.wallParams).forEach(function (k) {
                    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(_this5.wallParams, k, { loot_item_id: _this5.room.meta.wallParams[k].loot_item_id });
                    _this5.room.meta.wallParams[k] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(_this5.room.meta.wallParams[k], _this5.room.meta.wallParams[k].loot_item.meta);
                  });
                }

                if (_this5.room.meta && _this5.room.meta.floorParams) {
                  _this5.floorParams = { loot_item_id: _this5.room.meta.floorParams.loot_item_id };
                  _this5.room.meta.floorParams = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(_this5.room.meta.floorParams, _this5.room.meta.floorParams.loot_item.meta);
                }

                _context2.next = 18;
                return _this5.roomManager.loadRoom(_this5.room.meta);

              case 18:

                // let roomObjects = []
                if (response.data.room.item_meta && response.data.room.item_meta.items) {
                  // roomObjects = response.data.room.item_meta.items.map(i => this.roomItemToRoomObject(i))
                  response.data.room.item_meta.items.forEach(function (ri) {
                    _this5.addToRoom(ri, ri.loot_item);
                  });
                }
                // await this.roomManager.loadRoom(Object.assign({roomObjects: roomObjects}, this.room.meta))

                _this5.roomManager.gameLoop();

                _this5.roomDisplayed = _this5.user.id;
                _context2.next = 24;
                break;

              case 23:
                console.log('ERROR LOADING ROOM');

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    }
  }
});

/***/ }),

/***/ "CKJ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CPGk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_BigNumber_js__ = __webpack_require__("RgCM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_BigNumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_BigNumber_js__);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    formatCurrency: function formatCurrency(amount) {
      try {
        return new __WEBPACK_IMPORTED_MODULE_0_BigNumber_js___default.a(amount.toString().split('.')[0]).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } catch (e) {
        return amount;
      }
    }
  }
});

/***/ }),

/***/ "CvRS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DKCg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bounty_vue__ = __webpack_require__("PDux");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e193e61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bounty_vue__ = __webpack_require__("qqoY");
function injectStyle (ssrContext) {
  __webpack_require__("GFv7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e193e61"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bounty_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e193e61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bounty_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EGFv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EGYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"buy-ticket"}},[_c('div',{staticStyle:{"width":"85%","display":"inline-block"}},[_c('table',{staticClass:"ticket-form",attrs:{"align":"center"}},[_c('tr',[_c('td',{staticClass:"balance-row",attrs:{"colspan":"4"}},[_c('table',{staticClass:"ticket-bt-box"},[_c('tr',[_c('td',{staticStyle:{"padding":"5px"}},[_c('h1',{staticStyle:{"color":"var(--sl-red)","font-weight":"bold"}},[_vm._v("Balance")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.formatCurrency(_vm.currentBalance.total))+" ")])]),_vm._v(" "),_c('td',{staticStyle:{"padding":"5px"}},[_c('h1',{staticStyle:{"color":"var(--sl-red)","font-weight":"bold"}},[_vm._v("Your Tickets")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.formatCurrency(_vm.myTickets)))])])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('tr',[_c('td',{staticClass:"input-title"},[_vm._v("\n               Tickets: \n          ")]),_vm._v(" "),_c('td',{staticClass:"input-values"},[_c('div',{staticStyle:{"display":"inline-block"}},[_c('div',{staticClass:"value-btn",on:{"click":_vm.valueDown}},[_c('img',{staticClass:"value-btn-img",attrs:{"src":__webpack_require__("zpNP")}})]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","vertical-align":"super"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ticket_amount),expression:"ticket_amount"}],attrs:{"type":"text","placeholder":"Enter Number","id":"ticket-amount","align":"center"},domProps:{"value":(_vm.ticket_amount)},on:{"keypress":function($event){return _vm.amountChanged($event)},"input":function($event){if($event.target.composing){ return; }_vm.ticket_amount=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"value-btn",on:{"click":_vm.valueUp}},[_c('img',{staticClass:"value-btn-img",attrs:{"src":__webpack_require__("WJf4")}})])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('tr',[_c('td',{staticClass:"input-title"},[_vm._v("\n          Price: \n        ")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"total-price"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.ticket_amount*_vm.price))+" Swiftsbucks")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('sliderConrol',{staticClass:"slider-conrol",attrs:{"value":_vm.pers},on:{"persChange":function($event){return _vm.persChange($event)}}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('button-a',{staticStyle:{"font-size":"40px","padding":"8px"},attrs:{"button_status":_vm.valid_amount*_vm.callFree},on:{"clicked":_vm.callBuyTicket}},[_vm._v(_vm._s(_vm.button_value))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ENjp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "En2B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loot-box-management"}},[_c('info-box',{attrs:{"description":_vm.description}}),_vm._v(" "),_c('header-title',{attrs:{"title":"LOOT BOXES"}}),_vm._v(" "),(_vm.notification)?_c('span',[_vm._v(_vm._s(_vm.notification))]):_vm._e(),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn-enabled",on:{"click":function($event){return _vm.create()}}},[_vm._v("CREATE")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.lootBoxPageCurrent))]),_vm._v(" "),(_vm.lootBoxPages[_vm.lootBoxPageCurrent])?_c('table',{staticClass:"editor-table"},_vm._l((_vm.lootBoxPages[_vm.lootBoxPageCurrent]['loot_items']),function(item){return _c('tr',{key:item.id},[_c('td',[_c('img',{staticStyle:{"width":"100px"},attrs:{"src":_vm.lootItemImageUrl(item)}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_c('router-link',{staticClass:"btn-enabled",staticStyle:{"width":"50px","height":"30px","line-height":"30px","text-align":"center"},attrs:{"to":{ name: 'LootBoxEditor', params: { itemId: item.id }}}},[_vm._v("Edit")])],1)])}),0):_vm._e(),_vm._v(" "),(_vm.lootBoxPages.length > 18)?_c('button',{staticClass:"btn-enabled",on:{"click":function($event){return _vm.next()}}},[_vm._v("Next")]):_vm._e(),_vm._v(" "),(_vm.lootBoxPageCurrent > 0)?_c('button',{staticClass:"btn-enabled",on:{"click":function($event){return _vm.back()}}},[_vm._v("Back")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fr4N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__slider__ = __webpack_require__("7d4M");
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  components: {
    slider: __WEBPACK_IMPORTED_MODULE_0__slider__["a" /* default */]
  },
  data: function data() {
    return {
      description: {
        title: 'Welcome!',
        text: 'Check on bets, leaderboards, bounties, and lottery ticket purchases. Login with your twitch to get easy access to your info!'
      }
    };
  }
});

/***/ }),

/***/ "Fvhm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Leaderboard_vue__ = __webpack_require__("IYJr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca35170_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Leaderboard_vue__ = __webpack_require__("jqYQ");
function injectStyle (ssrContext) {
  __webpack_require__("3irE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ca35170"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Leaderboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca35170_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Leaderboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GFv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gh/C":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9Ii0xNzcgMjYzIDI1NiAyNjgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgLTE3NyAyNjMgMjU2IDI2ODsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCgkuc3Qwe2ZpbGw6I0ZGRkZGRjt9DQo8L3N0eWxlPg0KPGc+DQoJPHBhdGggY2xhc3M9InN0MCIgZD0iTS0xNTkuNSwyNjNsLTE3LjUsNDYuNnYxODYuMmg2NHYzNC45aDM0LjlsMzQuOS0zNC45SDkuMkw3OSw0MjZWMjYzSC0xNTkuNXogTS0xMzYuMywyODYuM2gxOTJ2MTI4TDE1LDQ1NQ0KCQloLTY0bC0zNC45LDM0LjlWNDU1aC01Mi40VjI4Ni4zeiBNLTcyLjMsNDAyLjdILTQ5di02OS44aC0yMy4zVjQwMi43eiBNLTguMyw0MDIuN0gxNXYtNjkuOEgtOC4zVjQwMi43eiIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "H6gW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bounties"}},[_c('info-box',{attrs:{"description":_vm.description}}),_vm._v(" "),_c('header-title',{attrs:{"title":"BOUNTIES","subtitle":"Current top bounties. Gift a sub and claim the bounty!"}}),_vm._v(" "),_c('div',{staticClass:"tiers"},[_vm._l((_vm.tiers),function(tier){return _c('section',{key:tier.level,staticClass:"tier sl-panel",class:("tier--" + (tier.variant))},[_c('div',{staticClass:"tier__head"},[_c('div',{staticClass:"tier__id"},[_c('span',{staticClass:"tier__name"},[_vm._v(_vm._s(tier.name))]),_vm._v(" "),_c('span',{staticClass:"tier__badge"},[_vm._v(_vm._s(tier.badge))])]),_vm._v(" "),_c('span',{staticClass:"tier__count"},[_vm._v("\n          "+_vm._s(tier.rows.length)+" "+_vm._s(tier.rows.length === 1 ? 'hunter' : 'hunters')+"\n        ")])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_vm._l((tier.rows),function(subBounty,index){return _c('Bounty',{key:subBounty.user_id,attrs:{"subBounty":subBounty,"tier":tier.level,"rank":index + 1,"btnLabel":tier.btn}})})],2)}),_vm._v(" "),(!_vm.tiers.length)?_c('p',{staticClass:"tiers__empty"},[_vm._v("No bounties on the board right now.")]):_vm._e()],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tier__cols bounty-grid"},[_c('span',[_vm._v("#")]),_vm._v(" "),_c('span',[_vm._v("User Name")]),_vm._v(" "),_c('span',{staticClass:"tier__cols-amount"},[_vm._v("Bounty")]),_vm._v(" "),_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HE4W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import BigNumber from 'BigNumber.js'
// import axios from 'axios'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loot-box-management',
  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.refreshLootBoxes();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      description: {
        title: 'Loot Box Management',
        text: 'Do it!'
      },
      notification: undefined
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['currentUser', 'lootShopLootItemIds', 'lootShopLootItems', 'lootBoxPageCurrent', 'lootBoxPages']), {}),
  methods: {
    next: function next() {
      if (this.lootBoxPages.length - 1 > this.lootBoxPageCurrent) {
        this.$store.dispatch('gotoLootBoxPage', this.lootBoxPageCurrent + 1);
      } else {
        this.$store.dispatch('fetchLootBoxPage', this.lootBoxPages[this.lootBoxPageCurrent].cursor);
      }
    },
    back: function back() {
      this.$store.dispatch('gotoLootBoxPage', this.lootBoxPageCurrent - 1);
    },
    refreshLootBoxes: function refreshLootBoxes() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch('lootBoxPageReset');

              case 2:
                _this2.$store.dispatch('fetchLootBoxPage');

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    categoryTextFor: function categoryTextFor(shopItem) {
      if (shopItem.category === 'lootChest') {
        return 'Virtual LOOTCHEST';
      } else if (shopItem.category === 'roomItem') {
        return 'Virtual Room Item';
      } else {
        return 'Token';
      }
    },
    lootShopLootItemForId: function lootShopLootItemForId(id) {
      return this.$store.state.lootShopLootItems[id];
    },
    lootItemImageUrl: function lootItemImageUrl(lootItem) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.WEB_ASSET_BASE_URL + '/' + lootItem.image_url;
    },
    currencyIcon: function currencyIcon(priceCurrencyType) {
      var image = priceCurrencyType === 'mt' ? 'swiftGold.png' : 'swiftBucks.png';

      return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.WEB_ASSET_BASE_URL + '/' + image;
    },
    attributionText: function attributionText(lootItem) {
      if (!lootItem.attribution_author) {
        return;
      }
      // // "Creative Commons 10th Birthday Celebration San Francisco" by tvol is licensed under CC BY 2.0
      return '<a href="' + lootItem.attribution_title_url + '" target="_blank">"' + lootItem.attribution_title + '"</a> by <a href="' + lootItem.attribution_author_url + '" target="_blank">' + lootItem.attribution_author + '</a> <br/> Licensed under <a href="' + lootItem.attribution_license_url + '" target="_blank">' + lootItem.attribution_license + '</a>';
    },
    requiresAttribution: function requiresAttribution(lootItem) {
      return !!lootItem.attribution_author;
    },
    notify: function notify(text) {
      var _this3 = this;

      this.notification = text;
      setTimeout(function () {
        _this3.notification = undefined;
      }, 5000);
    },
    create: function create() {
      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({ name: 'LootBoxEditorCreate' });
    }
  },
  watch: {}
});

/***/ }),

/***/ "HP7v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-status"},[(_vm.currentUser)?_c('div',{staticClass:"user-chip"},[_c('router-link',{staticClass:"user-chip__avatar",attrs:{"to":"/settings"}},[_c('user-avatar',{attrs:{"name":_vm.currentUser.display_name,"src":_vm.currentUser.profile_image_url}})],1),_vm._v(" "),_c('div',{staticClass:"user-chip__body"},[_c('router-link',{staticClass:"user-chip__name",attrs:{"to":"/settings"}},[_vm._v(_vm._s(_vm.currentUser.display_name))]),_vm._v(" "),_c('div',{staticClass:"user-chip__meta"},[(_vm.currentBalance)?_c('span',{staticClass:"user-chip__bal"},[_vm._v("\n          "+_vm._s(_vm.formatCurrency(_vm.currentBalance.total))+"\n          "),_c('img',{attrs:{"src":_vm.currencyIcon('sb'),"alt":"SwiftBUCKS"}})]):_vm._e(),_vm._v(" "),(_vm.currentGoldBalance)?_c('span',{staticClass:"user-chip__bal user-chip__bal--gold"},[_vm._v("\n          "+_vm._s(_vm.formatCurrency(_vm.currentGoldBalance.total))+"\n          "),_c('img',{attrs:{"src":_vm.currencyIcon('mt'),"alt":"SwiftGOLD"}})]):_vm._e()]),_vm._v(" "),(!_vm.noDiscord && _vm.currentUser.discord_display_name)?_c('div',{staticClass:"user-chip__discord"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z"}})]),_vm._v("\n        "+_vm._s(_vm.currentUser.discord_display_name)+"\n      ")]):_vm._e()],1),_vm._v(" "),(_vm.noDiscord)?_c('discord-btn',{staticClass:"user-chip__add-discord",attrs:{"title":"Connect your Discord"}}):_vm._e()],1):_c('login-btn',[_vm._v("Login")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HhlE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bets"},[_c('info-box',{attrs:{"description":_vm.description}}),_vm._v(" "),_c('header-title',{attrs:{"title":"BETS"}}),_vm._v(" "),_c('transition-group',{attrs:{"name":_vm.gotInitialBets > 1 ? 'bets-list' : '',"mode":"out-in"}},_vm._l((_vm.currentBetIds),function(betId){return _c('bet',{key:betId,attrs:{"betId":betId}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IYJr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bets',
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.dispatch('fetchBalanceLeaderboard');
              _this.$store.dispatch('fetchWatchTimeLeaderboard');

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      order: 'balance'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])([
  // map this.count to store.state.count
  'watchTimeLeaderboard', 'balanceLeaderboard']), {
    currentLeaders: function currentLeaders() {
      return this.order === 'balance' ? this.balanceLeaderboard : this.watchTimeLeaderboard;
    }
  }),
  methods: {
    orderBy: function orderBy(ob) {
      this.order = ob;
    }
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nes_client__ = __webpack_require__("uUYA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nes_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_nes_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_BigNumber_js__ = __webpack_require__("RgCM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_BigNumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_BigNumber_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);














__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */]);

var axios = __WEBPACK_IMPORTED_MODULE_8_axios___default.a.create({
  withCredentials: true
});

var store = new __WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */].Store({
  state: {
    count: 0,
    bets: {},
    ticketRaffles: {},
    users: {},
    userIdByTwitchNames: {},
    placedBets: {}, // betId => [<pb>]
    myBets: {},
    myTickets: {},
    ticketRaffleEntries: {},
    ticketRaffleWinners: {},
    orders: {},
    currentTicketRaffleIds: [],
    balanceLeaderboard: [],
    watchTimeLeaderboard: [],
    currentBetIds: [],
    subBounties: [],
    ownedLootItems: {},
    myOwnedLootItemIds: [],
    lootShopLootItemIds: [],
    lootShopLootItems: {},
    lootItems: {},
    noCurrentUser: false,
    currentBalance: undefined,
    currentGoldBalance: undefined,
    roomItemPages: [],
    roomItemPageCurrent: -1,
    lootBoxPages: [],
    lootBoxPageCurrent: -1,
    userRates: null,
    callFree: true
  },
  mutations: {
    increment: function increment(state) {
      state.count++;
    },
    betsUpdate: function betsUpdate(state, bets) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(bets), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var bet = _step.value;

          __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.bet, bet.id, bet);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    placedBetsUpdate: function placedBetsUpdate(state, data) {
      var pbs = data.placed_bets || [];
      var mbs = data.my_bets || [];
      pbs = pbs.map(function (pb) {
        pb.amount = new __WEBPACK_IMPORTED_MODULE_10_BigNumber_js___default.a(pb.amount);
        return pb;
      });

      mbs = mbs.map(function (pb) {
        pb.amount = new __WEBPACK_IMPORTED_MODULE_10_BigNumber_js___default.a(pb.amount);
        return pb;
      });

      pbs.sort(function (pb1, pb2) {
        if (pb1.amount.gt(pb2.amount)) {
          return -1;
        } else if (pb2.amount.gt(pb1.amount)) {
          return 1;
        } else {
          return 0;
        }
      });

      mbs.sort(function (pb1, pb2) {
        if (pb1.amount.gt(pb2.amount)) {
          return -1;
        } else if (pb2.amount.gt(pb1.amount)) {
          return 1;
        } else {
          return 0;
        }
      });

      // state.placedBets[pbs[0].bet_id] = pbs

      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.placedBets, pbs[0].bet_id, pbs);
      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.myBets, mbs[0].bet_id, mbs);
      // for (let pb of pbs) {
      //   if (!state.placedBets[pb.bet_id]) {
      //     state.placedBets[pb.bet_id] = [pb]
      //   } else {
      //     state.placedBets[pb.bet_id].push(pb)
      //   }
      // }
    },
    newTicketRaffle: function newTicketRaffle(state, tr) {
      tr.created_at = __WEBPACK_IMPORTED_MODULE_12_moment___default()(tr.created_at);
      tr.updated_at = __WEBPACK_IMPORTED_MODULE_12_moment___default()(tr.updated_at);
      tr.total_entries = new __WEBPACK_IMPORTED_MODULE_10_BigNumber_js___default.a(tr.total_entries);
      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.ticketRaffles, tr.id, tr);

      if (state.currentTicketRaffleIds.indexOf(tr.id) === -1) {
        state.currentTicketRaffleIds.push(tr.id);

        state.currentTicketRaffleIds.sort(function (trid1, trid2) {
          if (state.ticketRaffles[trid1].status === 1 && state.ticketRaffles[trid2].status !== 1) {
            return -1;
          }

          if (state.ticketRaffles[trid2].status === 1 && state.ticketRaffles[trid1].status !== 1) {
            return 1;
          }

          if (state.ticketRaffles[trid1].updated_at > state.ticketRaffles[trid2].updated_at) {
            return -1;
          } else {
            return 1;
          }
        });
      }
    },
    newTicketRaffleEntry: function newTicketRaffleEntry(state, tre) {
      var cur = state.ticketRaffleEntries[tre.ticket_raffle_id] || [];
      var existing = cur.find(function (c) {
        return c.user_id === tre.user_id;
      });

      tre.quantity = new __WEBPACK_IMPORTED_MODULE_10_BigNumber_js___default.a(tre.quantity);

      if (existing) {
        cur = cur.filter(function (c) {
          return c.user_id !== tre.user_id;
        });
      }
      cur.unshift(tre);

      var tr = state.ticketRaffles[tre.ticket_raffle_id];
      tr.total_entries = tr.total_entries.plus(tre.quantity.minus(new __WEBPACK_IMPORTED_MODULE_10_BigNumber_js___default.a(existing ? existing.quantity : 0)));

      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.ticketRaffles, tr.id, tr);

      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.ticketRaffleEntries, tre.ticket_raffle_id, cur);
    },
    newTicketRaffleWinner: function newTicketRaffleWinner(state, winner) {
      var cur = state.ticketRaffleWinners[winner.ticket_raffle_id] || [];
      cur.push(winner);

      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.ticketRaffleWinners, winner.ticket_raffle_id, cur);
    },
    setMyTickets: function setMyTickets(state, trs) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(trs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var tr = _step2.value;

          tr.created_at = __WEBPACK_IMPORTED_MODULE_12_moment___default()(tr.created_at);
          tr.updated_at = __WEBPACK_IMPORTED_MODULE_12_moment___default()(tr.updated_at);
          tr.total_entries = new __WEBPACK_IMPORTED_MODULE_10_BigNumber_js___default.a(tr.total_entries);

          __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.myTickets, tr.id, tr);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    setLootItems: function setLootItems(state, lootItems) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(lootItems), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var li = _step3.value;

          // li.created_at = moment(li.created_at)
          // li.updated_at = moment(li.updated_at)

          __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.lootItems, li.id, li);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    setLootShopLootItems: function setLootShopLootItems(state, lootItems) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(lootItems), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var li = _step4.value;

          // li.created_at = moment(li.created_at)
          // li.updated_at = moment(li.updated_at)
          if (state.lootShopLootItemIds.indexOf(li.id) === -1) {
            state.lootShopLootItemIds.push(li.id);
          }

          __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.lootShopLootItems, li.id, li);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    setOwnedLootItems: function setOwnedLootItems(state, lootItems) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(lootItems), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var li = _step5.value;

          // li.created_at = moment(li.created_at)
          // li.updated_at = moment(li.updated_at)
          if (state.myOwnedLootItemIds.indexOf(li.id) === -1) {
            state.myOwnedLootItemIds.push(li.id);
          }

          if (li.loot_item) {
            __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.lootItems, li.loot_item.id, li.loot_item);
          }
          // someObject = Object.assign({}, li)
          __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.ownedLootItems, li.id, li);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    setTicketRaffles: function setTicketRaffles(state, trs) {
      // console.log('set ticket raffles', trs)

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(trs), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var tr = _step6.value;

          tr.created_at = __WEBPACK_IMPORTED_MODULE_12_moment___default()(tr.created_at);
          tr.updated_at = __WEBPACK_IMPORTED_MODULE_12_moment___default()(tr.updated_at);
          tr.total_entries = new __WEBPACK_IMPORTED_MODULE_10_BigNumber_js___default.a(tr.total_entries);

          __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.ticketRaffles, tr.id, tr);
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      var ids = trs.map(function (tr) {
        return tr.id;
      });

      ids.sort(function (trid1, trid2) {
        if (state.ticketRaffles[trid1].status === 1 && state.ticketRaffles[trid2].status !== 1) {
          return -1;
        }

        if (state.ticketRaffles[trid2].status === 1 && state.ticketRaffles[trid1].status !== 1) {
          return 1;
        }
        // console.log(state.ticketRaffles[trid1].updated_at)
        if (state.ticketRaffles[trid1].updated_at > state.ticketRaffles[trid2].updated_at) {
          return -1;
        } else {
          return 1;
        }
      });

      state.currentTicketRaffleIds = ids;
    },
    setTicketRaffleEntries: function setTicketRaffleEntries(state, _ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          tres = _ref2[0],
          winners = _ref2[1];

      // console.log('settings entries', tres, winners)
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(tres), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var tre = _step7.value;

          tre.updated_at = __WEBPACK_IMPORTED_MODULE_12_moment___default()(tre.updated_at);
          tre.created_at = __WEBPACK_IMPORTED_MODULE_12_moment___default()(tre.created_at);
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(winners), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var _tre = _step8.value;

          _tre.updated_at = __WEBPACK_IMPORTED_MODULE_12_moment___default()(_tre.updated_at);
          _tre.created_at = __WEBPACK_IMPORTED_MODULE_12_moment___default()(_tre.created_at);
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      tres.sort(function (tre1, tre2) {
        if (tre1.quantity > tre2.quantity) {
          return -1;
        } else if (tre2.quantity > tre1.quantity) {
          return 1;
        }

        if (tre1.updated_at > tre2.updated_at) {
          return -1;
        } else {
          return 1;
        }
      });

      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.ticketRaffleEntries, tres[0].ticket_raffle_id, tres);
      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.ticketRaffleWinners, tres[0].ticket_raffle_id, winners);
    },
    newBets: function newBets(state, bets) {
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(bets), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var bet = _step9.value;

          __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.bets, bet.id, bet);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      var cbids = bets.map(function (b) {
        return b.id;
      });

      cbids.sort(function (bid1, bid2) {
        if (__WEBPACK_IMPORTED_MODULE_12_moment___default()(state.bets[bid1].created_at) > __WEBPACK_IMPORTED_MODULE_12_moment___default()(state.bets[bid2].created_at)) {
          return -1;
        } else {
          return 1;
        }
      });

      state.currentBetIds = cbids;
    },
    newBet: function newBet(state, bet) {
      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.bets, bet.id, bet);

      if (state.currentBetIds.indexOf(bet.id) === -1) {
        state.currentBetIds.unshift(bet.id);
      }

      state.currentBetIds.sort(function (bid1, bid2) {
        if (__WEBPACK_IMPORTED_MODULE_12_moment___default()(state.bets[bid1].created_at) > __WEBPACK_IMPORTED_MODULE_12_moment___default()(state.bets[bid2].created_at)) {
          return -1;
        } else {
          return 1;
        }
      });
    },
    newPlacedBet: function newPlacedBet(state, data) {
      var bet = data.bet;
      var previousSavedBet = state.bets ? state.bets[bet.id] : undefined;

      if (state.currentBetIds.indexOf(bet.id) === -1) {
        state.currentBetIds.unshift(bet.id);

        state.currentBetIds.sort(function (bid1, bid2) {
          if (state.bets[bid1].status < state.bets[bid2].status) {
            return -1;
          } else if (state.bets[bid1].status > state.bets[bid2].status) {
            return 1;
          } else {
            if (__WEBPACK_IMPORTED_MODULE_12_moment___default()(state.bets[bid1].created_at) > __WEBPACK_IMPORTED_MODULE_12_moment___default()(state.bets[bid2].created_at)) {
              return -1;
            } else {
              return 1;
            }
          }
        });
      }

      if (previousSavedBet) {
        previousSavedBet.total = bet.total;
        previousSavedBet.bet_options = previousSavedBet.bet_options || [];

        var bo = previousSavedBet.bet_options.find(function (b) {
          return b.option_number === data.bet_option.option_number;
        });
        if (bo) {
          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(bo, data.bet_option);
        }
      } else {
        data.bet.bet_options = [data.bet_option];
        previousSavedBet = data.bet;
        this.commit('newBet', data.bet);
      }

      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.bets, previousSavedBet.id, previousSavedBet);

      data.placed_bet.amount = new __WEBPACK_IMPORTED_MODULE_10_BigNumber_js___default.a(data.placed_bet.amount);

      if (!state.placedBets[previousSavedBet.id]) {
        __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.placedBets, previousSavedBet.id, [data.placed_bet]);
      } else {
        var pbs = state.placedBets[previousSavedBet.id];
        pbs.push(data.placed_bet);

        pbs.sort(function (pb1, pb2) {
          if (pb1.amount.gt(pb2.amount)) {
            return -1;
          } else if (pb2.amount.gt(pb1.amount)) {
            return 1;
          } else {
            return 0;
          }
        });

        if (data.placed_bet.user_id === state.currentUser.id) {
          var mbs = state.myBets[previousSavedBet.id] || [];
          mbs.push(data.placed_bet);

          mbs.sort(function (pb1, pb2) {
            if (pb1.amount.gt(pb2.amount)) {
              return -1;
            } else if (pb2.amount.gt(pb1.amount)) {
              return 1;
            } else {
              return 0;
            }
          });

          __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.myBets, previousSavedBet.id, mbs);
        }
        __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.placedBets, previousSavedBet.id, pbs);
      }
    },
    usersUpdate: function usersUpdate(state, users) {
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(users), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var user = _step10.value;

          __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.users, user.id, user);
          __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.userIdByTwitchNames, user.twitch_name, user.id);
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }
    },
    balanceLeaderboardUpdate: function balanceLeaderboardUpdate(state, leaders) {
      state.balanceLeaderboard = leaders;
    },
    watchTimeLeaderboardUpdate: function watchTimeLeaderboardUpdate(state, leaders) {
      state.watchTimeLeaderboard = leaders;
    },
    currentUser: function currentUser(state, user) {
      if (!user) {
        __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state, 'noCurrentUser', true);
      }
      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state, 'currentUser', user);
    },
    currentBalance: function currentBalance(state, balances) {
      if (Array.isArray(balances)) {
        var sb = balances.find(function (b) {
          return b.currency_type === 'sb';
        });
        var gold = balances.find(function (b) {
          return b.currency_type === 'mt';
        });
        __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state, 'currentBalance', sb);
        __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state, 'currentGoldBalance', gold);
      } else {
        __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state, 'currentBalance', balances);
      }
    },
    subBountiesUpdate: function subBountiesUpdate(state, bountiesx) {
      var minBounties = [];
      var minBounite = bountiesx.tier === 3 ? 50000000 : bountiesx.tier === 2 ? 20000000 : 0;
      bountiesx.bounties.forEach(function (element) {
        if (Number(element.amount) >= minBounite) {
          minBounties.push(element);
        }
      });
      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.subBounties, 'sub_bounties_t' + bountiesx.tier, minBounties);
    },
    roomItemPageUpdate: function roomItemPageUpdate(state, params) {
      if (params.loot_items && params.loot_items.length > 0) {
        state.roomItemPageCurrent = state.roomItemPages.length;
        state.roomItemPages.push({ loot_items: params.loot_items, cursor: params.cursor });
      }
    },
    roomItemPageReset: function roomItemPageReset(state, items, cursor) {
      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.roomItemPages, []);
      // Vue.set(state.roomItemPageCurrent, -1)
      state.roomItemPageCurrent = -1;
    },
    gotoRoomPage: function gotoRoomPage(state, page) {
      state.roomItemPageCurrent = page;
    },
    lootBoxPageUpdate: function lootBoxPageUpdate(state, params) {
      if (params.loot_items && params.loot_items.length > 0) {
        state.lootBoxPageCurrent = state.lootBoxPages.length;
        state.lootBoxPages.push({ loot_items: params.loot_items, cursor: params.cursor });
      }
    },
    lootBoxPageReset: function lootBoxPageReset(state, items, cursor) {
      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.lootBoxPages, []);
      // Vue.set(state.roomItemPageCurrent, -1)
      state.lootBoxPageCurrent = -1;
    },
    lootBoxPage: function lootBoxPage(state, page) {
      state.lootBoxPageCurrent = page;
    },
    setUserRates: function setUserRates(state, rates) {
      state.userRates = rates;
    }
  },
  actions: {
    fetchCurrentUser: function fetchCurrentUser(context) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, response2;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!context.state.currentUser) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', context.state.currentUser);

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/users/me', { withCredentials: true });

              case 5:
                response = _context.sent;


                context.commit('usersUpdate', [response.data.user]);
                context.commit('currentUser', response.data.user);

                context.dispatch('fetchMyTickets');

                _context.next = 11;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/balances/me', { withCredentials: true });

              case 11:
                response2 = _context.sent;


                context.commit('currentBalance', response2.data.balances);
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](2);

                context.commit('currentUser');
                console.log('FETCH CURRENT ERROR', _context.t0);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 15]]);
      }))();
    },
    fetchBalances: function fetchBalances(context) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/balances/me', { withCredentials: true });

              case 3:
                response = _context2.sent;

                context.commit('currentBalance', response.data.balances);
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }))();
    },
    fetchUser: function fetchUser(context, userId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!context.state.users[userId]) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return', context.state.users[userId]);

              case 2:
                if (!(!userId || userId.toString() === 'undefined')) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt('return');

              case 4:
                _context3.next = 6;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/users/' + userId);

              case 6:
                response = _context3.sent;


                context.commit('usersUpdate', [response.data.user]);

                return _context3.abrupt('return', response.data.user);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    fetchUserByTwitchName: function fetchUserByTwitchName(context, twitchName) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!context.state.userIdByTwitchNames[twitchName]) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return', context.state.users[context.state.userIdByTwitchNames[twitchName]]);

              case 2:
                if (!(!twitchName || twitchName.toString() === 'undefined')) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return');

              case 4:
                _context4.next = 6;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/users?twitch_name=' + twitchName);

              case 6:
                response = _context4.sent;


                context.commit('usersUpdate', [response.data.user]);

                return _context4.abrupt('return', response.data.user);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    fetchTicketRaffle: function fetchTicketRaffle(context, ticketRaffleId) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                if (!context.state.ticketRaffles[ticketRaffleId]) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt('return', context.state.ticketRaffles[ticketRaffleId]);

              case 3:
                _context5.next = 5;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/ticket_raffles/' + ticketRaffleId);

              case 5:
                response = _context5.sent;

                context.commit('newTicketRaffle', [response.data.ticket_raffle]);
                _context5.next = 11;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](0);

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 9]]);
      }))();
    },
    fetchLootShopLootItems: function fetchLootShopLootItems(context) {
      var _this6 = this;

      var channelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/loot_shop/loot_items');

              case 3:
                response = _context6.sent;

                context.commit('setLootShopLootItems', response.data.loot_items);
                // for (let bet of response.data.bets.reverse()) {
                //   context.commit('newBet', bet)
                // }
                _context6.next = 9;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6['catch'](0);

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 7]]);
      }))();
    },
    fetchLootItem: function fetchLootItem(context, itemId) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/loot_items/' + itemId);

              case 3:
                response = _context7.sent;

                context.commit('setLootItems', [response.data.loot_item]);
                // for (let bet of response.data.bets.reverse()) {
                //   context.commit('newBet', bet)
                // }
                _context7.next = 9;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7['catch'](0);

              case 9:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 7]]);
      }))();
    },
    fetchOwnedLootItems: function fetchOwnedLootItems(context) {
      var _this8 = this;

      var channelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                if (context.state.currentUser) {
                  _context8.next = 3;
                  break;
                }

                return _context8.abrupt('return', context.state.currentUser);

              case 3:
                _context8.next = 5;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/users/' + context.state.currentUser.id + '/owned_loot_items?channel_id=' + channelId);

              case 5:
                response = _context8.sent;


                // context.commit('setLootItems', response.data.loot_items || [])
                context.commit('setOwnedLootItems', response.data.owned_loot_items);
                // for (let bet of response.data.bets.reverse()) {
                //   context.commit('newBet', bet)
                // }
                _context8.next = 12;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8['catch'](0);

                console.log('Error fetching owned loot items', _context8.t0);

              case 12:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[0, 9]]);
      }))();
    },
    fetchCurrentTicketRaffles: function fetchCurrentTicketRaffles(context) {
      var _this9 = this;

      var channelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/channels/' + channelId + '/ticket_raffles');

              case 3:
                response = _context9.sent;

                context.commit('setTicketRaffles', response.data.ticket_raffles);
                // for (let bet of response.data.bets.reverse()) {
                //   context.commit('newBet', bet)
                // }
                _context9.next = 9;
                break;

              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9['catch'](0);

              case 9:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9, [[0, 7]]);
      }))();
    },
    fetchMyTickets: function fetchMyTickets(context) {
      var _this10 = this;

      var channelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;

                if (context.state.currentUser) {
                  _context10.next = 3;
                  break;
                }

                return _context10.abrupt('return', context.state.currentUser);

              case 3:
                _context10.next = 5;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/channels/' + channelId + '/ticket_raffles?userId=' + context.state.currentUser.id);

              case 5:
                response = _context10.sent;

                context.commit('setMyTickets', response.data.ticket_raffles);
                // for (let bet of response.data.bets.reverse()) {
                //   context.commit('newBet', bet)
                // }
                _context10.next = 11;
                break;

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10['catch'](0);

              case 11:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10, [[0, 9]]);
      }))();
    },
    fetchTicketRaffleEntries: function fetchTicketRaffleEntries(context, ticketRaffleId) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/ticket_raffles/' + ticketRaffleId + '/entries');

              case 3:
                response = _context11.sent;

                context.commit('setTicketRaffleEntries', [response.data.ticket_raffle_entries, response.data.ticket_raffle_winners]);
                response.data.ticket_raffle_entries.sort(function (a, b) {
                  return parseFloat(a.quantity) < parseFloat(b.quantity) ? 1 : parseFloat(b.quantity) < parseFloat(a.quantity) ? -1 : 0;
                });
                return _context11.abrupt('return', true);

              case 9:
                _context11.prev = 9;
                _context11.t0 = _context11['catch'](0);
                return _context11.abrupt('return', []);

              case 12:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11, [[0, 9]]);
      }))();
    },
    fetchCurrentBets: function fetchCurrentBets(context) {
      var _this12 = this;

      var channelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/channels/' + channelId + '/bets');

              case 3:
                response = _context12.sent;

                context.commit('newBets', response.data.bets);
                // for (let bet of response.data.bets.reverse()) {
                //   context.commit('newBet', bet)
                // }
                _context12.next = 9;
                break;

              case 7:
                _context12.prev = 7;
                _context12.t0 = _context12['catch'](0);

              case 9:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this12, [[0, 7]]);
      }))();
    },
    fetchPlacedBets: function fetchPlacedBets(context, betId) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/bets/' + betId + '/placed_bets');

              case 3:
                response = _context13.sent;

                context.state.bets[betId].participantsCount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_11_lodash___default()(response.data.placed_bets).groupBy('user_id').value()).length;
                context.commit('placedBetsUpdate', response.data);
                return _context13.abrupt('return', true);

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13['catch'](0);
                return _context13.abrupt('return', []);

              case 12:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, _this13, [[0, 9]]);
      }))();
    },
    fetchBet: function fetchBet(context, betId) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;

                if (!context.state.bets[betId]) {
                  _context14.next = 3;
                  break;
                }

                return _context14.abrupt('return', context.state.bets[betId]);

              case 3:
                _context14.next = 5;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/bets/' + betId);

              case 5:
                response = _context14.sent;

                context.commit('betsUpdate', [response.data.bet]);

                return _context14.abrupt('return', response.data.bet);

              case 10:
                _context14.prev = 10;
                _context14.t0 = _context14['catch'](0);
                return _context14.abrupt('return', []);

              case 13:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, _this14, [[0, 10]]);
      }))();
    },
    fetchBalanceLeaderboard: function fetchBalanceLeaderboard(context) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/leaderboards/default/balance');

              case 3:
                response = _context15.sent;

                context.commit('balanceLeaderboardUpdate', response.data.leaders);
                _context15.next = 10;
                break;

              case 7:
                _context15.prev = 7;
                _context15.t0 = _context15['catch'](0);

                console.log('Error Fetching Balance Leaderboard', _context15.t0);

              case 10:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, _this15, [[0, 7]]);
      }))();
    },
    fetchWatchTimeLeaderboard: function fetchWatchTimeLeaderboard(context) {
      var _this16 = this;

      var channelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                _context16.next = 3;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/leaderboards/' + channelId + '/watch_time');

              case 3:
                response = _context16.sent;

                context.commit('watchTimeLeaderboardUpdate', response.data.leaders);
                _context16.next = 10;
                break;

              case 7:
                _context16.prev = 7;
                _context16.t0 = _context16['catch'](0);

                console.log('Error Fetching Watch Time Leaderboard', _context16.t0);

              case 10:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, _this16, [[0, 7]]);
      }))();
    },
    fetchSubBounties: function fetchSubBounties(context, bountieProbs) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                _context17.next = 3;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/sub_bounties?channelId=' + bountieProbs.channelId + '&tier=' + bountieProbs.tier);

              case 3:
                response = _context17.sent;

                context.commit('subBountiesUpdate', { tier: bountieProbs.tier, bounties: response.data.sub_bounties });
                _context17.next = 10;
                break;

              case 7:
                _context17.prev = 7;
                _context17.t0 = _context17['catch'](0);

                console.log('Error Fetching Sub Bounties', _context17.t0);

              case 10:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, _this17, [[0, 7]]);
      }))();
    },
    captureDonation: function captureDonation(context, _ref3) {
      var _this18 = this;

      var orderId = _ref3.orderId,
          message = _ref3.message;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                _context18.next = 3;
                return axios.post(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/donations', { orderId: orderId, message: message }, { withCredentials: true });

              case 3:
                response = _context18.sent;
                return _context18.abrupt('return', response.data);

              case 7:
                _context18.prev = 7;
                _context18.t0 = _context18['catch'](0);

                console.log('Error Fetching Sub Bounties', _context18.t0);
                return _context18.abrupt('return', { error: _context18.t0 });

              case 11:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, _this18, [[0, 7]]);
      }))();
    },
    buyTicket: function buyTicket(context, dets) {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee19() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (store.state.currentUser) {
                  store.state.callFree = false;
                  axios.post(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/ticket_raffles/' + dets.raffleIdx.toString(), {
                    'amount': dets.amount.toString(),
                    'userId': store.state.currentUser.id.toString()
                  }).then(function (response) {
                    context.dispatch('fetchMyTickets');
                    store.dispatch('fetchBalances');
                    store.state.callFree = true;
                  }).catch(function (error) {
                    console.log(error);
                  });
                }

              case 1:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, _this19);
      }))();
    },
    placeBet: function placeBet(context, dets) {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee20() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                if (store.state.currentUser) {
                  store.state.callFree = false;
                  axios.post(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/bets/' + dets.betIdx.toString(), {
                    'amount': dets.amount.toString(),
                    'option': dets.option.toString(),
                    'userId': store.state.currentUser.id.toString()
                  }, { withCredentials: true }).then(function (response) {
                    store.state.callFree = true;
                  }).catch(function (error) {
                    console.log(error);
                  });
                }

              case 1:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, _this20);
      }))();
    },
    saveRoom: function saveRoom(context, roomParams) {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee21() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                store.state.callFree = false;
                return _context21.abrupt('return', axios.post(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/rooms/' + store.state.currentUser.id.toString(), {
                  'items': roomParams.items
                }, { withCredentials: true }).then(function (response) {
                  store.state.callFree = true;
                }).catch(function (error) {
                  console.log(error);
                }));

              case 2:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, _this21);
      }))();
    },
    createRoomItem: function createRoomItem(context, params) {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee22() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                store.state.callFree = false;
                return _context22.abrupt('return', axios.post(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/room-items', params.formData, { withCredentials: true }).then(function (response) {
                  store.state.callFree = true;
                }).catch(function (error) {
                  console.log(error);
                }));

              case 2:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, _this22);
      }))();
    },
    fetchRoomPage: function fetchRoomPage(context, cursor) {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee23() {
        var qs, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.prev = 0;
                qs = '';

                if (cursor) {
                  qs = '?cursor=' + cursor;
                }
                _context23.next = 5;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/room_items' + qs, { withCredentials: true });

              case 5:
                response = _context23.sent;

                context.commit('roomItemPageUpdate', { cursor: response.data.meta.cursor, loot_items: response.data.loot_items });
                _context23.next = 12;
                break;

              case 9:
                _context23.prev = 9;
                _context23.t0 = _context23['catch'](0);

                console.log('Error Fetching Room Items', _context23.t0);

              case 12:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, _this23, [[0, 9]]);
      }))();
    },

    // async fetchRooms (context, params) {
    //   try {
    //     let qs = ''
    //     if (params.olderThan) { qs = `?olderThan=${params.olderThan}` }
    //     if (params.newerThan) { qs = `?newerThan=${params.newerThan}` }
    //     const response = await axios.get(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/rooms${qs}`, { withCredentials: true })
    //     context.commit('roomItemPageUpdate', {cursor: response.data.meta.cursor, loot_items: response.data.loot_items})
    //   } catch (e) {
    //     console.log('Error Fetching Room Items', e)
    //   }
    // },
    roomItemPageReset: function roomItemPageReset(context) {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee24() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                context.commit('roomItemPageReset');

              case 1:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, _this24);
      }))();
    },
    gotoRoomPage: function gotoRoomPage(context, page) {
      var _this25 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee25() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                context.commit('gotoRoomPage', page);

              case 1:
              case 'end':
                return _context25.stop();
            }
          }
        }, _callee25, _this25);
      }))();
    },
    fetchLootBoxPage: function fetchLootBoxPage(context, cursor) {
      var _this26 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee26() {
        var qs, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.prev = 0;
                qs = '';

                if (cursor) {
                  qs = '?cursor=' + cursor;
                }
                _context26.next = 5;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/loot_boxes' + qs, { withCredentials: true });

              case 5:
                response = _context26.sent;

                context.commit('lootBoxPageUpdate', { cursor: response.data.meta.cursor, loot_items: response.data.loot_items });
                _context26.next = 12;
                break;

              case 9:
                _context26.prev = 9;
                _context26.t0 = _context26['catch'](0);

                console.log('Error Fetching Room Items', _context26.t0);

              case 12:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, _this26, [[0, 9]]);
      }))();
    },
    lootBoxPageReset: function lootBoxPageReset(context) {
      var _this27 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee27() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                context.commit('lootBoxPageReset');

              case 1:
              case 'end':
                return _context27.stop();
            }
          }
        }, _callee27, _this27);
      }))();
    },
    lootBoxPage: function lootBoxPage(context, page) {
      var _this28 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee28() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                context.commit('gotoLootBoxPage', page);

              case 1:
              case 'end':
                return _context28.stop();
            }
          }
        }, _callee28, _this28);
      }))();
    },
    fetchUserRates: function fetchUserRates(context) {
      var _this29 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee29() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.prev = 0;

                if (context.state.currentUser) {
                  _context29.next = 3;
                  break;
                }

                return _context29.abrupt('return');

              case 3:
                _context29.next = 5;
                return axios.get(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/users/' + context.state.currentUser.id + '/rate_details');

              case 5:
                response = _context29.sent;

                context.commit('setUserRates', response.data.rate_details);
                _context29.next = 12;
                break;

              case 9:
                _context29.prev = 9;
                _context29.t0 = _context29['catch'](0);

                console.log('Error fetching user rates', _context29.t0);

              case 12:
              case 'end':
                return _context29.stop();
            }
          }
        }, _callee29, _this29, [[0, 9]]);
      }))();
    }
  }
});

store.connect = function () {
  var client = new __WEBPACK_IMPORTED_MODULE_9_nes_client___default.a.Client(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.WS_SERVICE_BASE_URL); // ws://localhost:8001/ws') // ue.config.WS_SERVICE_BASE_URL)
  client.connect(function (err) {
    if (err) {
      return;
    }

    var newTicketRaffleHandler = function newTicketRaffleHandler(update, flags) {
      store.commit('newTicketRaffle', update.ticket_raffle);
    };

    client.subscribe('/new_ticket_raffle', newTicketRaffleHandler, function (err) {
      // console.log('subscribed', err)
      if (err) {
        console.log(err);
      }
    });

    var newTicketRaffleEntryHandler = function newTicketRaffleEntryHandler(update, flags) {
      store.commit('newTicketRaffleEntry', update.ticket_raffle_entry);
    };

    client.subscribe('/new_ticket_raffle_entry', newTicketRaffleEntryHandler, function (err) {
      if (err) {
        console.log(err);
      }
      // console.log('subscribed', err)
    });

    var newTicketRaffleWinnerHandler = function newTicketRaffleWinnerHandler(update, flags) {
      // console.log('ticketwinner', update)
      store.commit('newTicketRaffleWinner', update.ticket_raffle_winner);
    };

    client.subscribe('/new_ticket_raffle_winner', newTicketRaffleWinnerHandler, function (err) {
      // console.log('subscribed', err)
      if (err) {
        console.log(err);
      }
    });

    var newBetsHandler = function newBetsHandler(update, flags) {
      // console.log('new bet', update, flags)

      if (store.state.placedBets[update.bet.id]) {
        store.dispatch('fetchPlacedBets', update.bet.id);
      }

      store.commit('newBet', update.bet);
    };

    client.subscribe('/new_bets', newBetsHandler, function (err) {
      // console.log('subscribed', err)
      if (err) {
        console.log(err);
      }
    });

    var newPlacedBetsHandler = function newPlacedBetsHandler(update, flags) {
      // console.log('new placed bet', update, flags)
      store.commit('newPlacedBet', update);
    };

    client.subscribe('/new_placed_bets', newPlacedBetsHandler, function (err) {
      // console.log('subscribed', err)
      if (err) {
        console.log(err);
      }
    });

    client.request('/h', function (err, payload) {
      if (err) {
        return;
      }
      // console.log('wat', payload)
    });

    store.dispatch('fetchCurrentUser');
  });
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "ItZT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J2ke":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryBrowser_vue__ = __webpack_require__("1e/U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65381d9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryBrowser_vue__ = __webpack_require__("uET0");
function injectStyle (ssrContext) {
  __webpack_require__("UO5z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65381d9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryBrowser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65381d9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryBrowser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JGAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-grid",attrs:{"id":"slider"}},[_c('section',{staticClass:"home-main"},[_c('div',{staticClass:"sl-panel stream-card"},[_c('div',{staticClass:"stream-card__bar"},[_c('span',{staticClass:"stream-card__channel"},[_vm._v(_vm._s(_vm.active.name))]),_vm._v(" "),_c('a',{staticClass:"stream-card__out",attrs:{"href":_vm.channelUrl,"target":"_blank","rel":"noopener"}},[_vm._v("Watch on Twitch ↗")])]),_vm._v(" "),_c('div',{staticClass:"stream-card__video"},[_c('iframe',{key:_vm.active.twitch_id,attrs:{"src":_vm.active.url,"allowfullscreen":"","frameborder":"0","scrolling":"no"}})])]),_vm._v(" "),_c('div',{staticClass:"channel"},[_c('div',{staticClass:"channel__avatar"},[_c('img',{attrs:{"src":_vm.active.prof_pic,"alt":_vm.active.name}})]),_vm._v(" "),_c('div',{staticClass:"channel__body"},[_c('h1',{staticClass:"channel__name"},[_vm._v(_vm._s(_vm.active.name))]),_vm._v(" "),_c('p',{staticClass:"channel__desc"},[_vm._v(_vm._s(_vm.active.description))])]),_vm._v(" "),_c('div',{staticClass:"channel__actions"},[_c('a',{staticClass:"sl-btn sl-btn--red",attrs:{"href":_vm.channelUrl,"target":"_blank","rel":"noopener"}},[_vm._v("Watch")]),_vm._v(" "),_c('a',{staticClass:"sl-btn sl-btn--purple",attrs:{"href":_vm.subscribeUrl,"target":"_blank","rel":"noopener"}},[_vm._v("Subscribe")])])])]),_vm._v(" "),_c('aside',{staticClass:"home-rail"},[_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"home-rail__list"},_vm._l((_vm.featuredChannels),function(channel,index){return _c('streamSlide',{key:channel.twitch_id,attrs:{"channel_data":channel,"active":index === _vm.activeIndex},on:{"select":function($event){return _vm.setActive(index)}}})}),1)]),_vm._v(" "),_c('div',{staticClass:"bounty-teaser"},[_c('div',{staticClass:"bounty-teaser__title"},[_vm._v("Sub Bounties")]),_vm._v(" "),_c('p',{staticClass:"bounty-teaser__copy"},[_vm._v("\n        Check the current sub bounties - grab some swiftbucks!\n      ")]),_vm._v(" "),_c('button',{staticClass:"sl-btn sl-btn--red sl-btn--block",on:{"click":_vm.goBounties}},[_vm._v("View Bounties →")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sl-section-head"},[_c('h2',[_vm._v("Featured")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JZSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'settings',
  props: ['message'],
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['currentUser']), {
    disconnectUrl: function disconnectUrl() {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.CURRENCY_SERVICE_ROOT_BASE_URL + '/auth/disconnect/discord?path=' + encodeURIComponent(this.$route.path);
    },
    logoutUrl: function logoutUrl() {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.CURRENCY_SERVICE_ROOT_BASE_URL + '/auth/logout?path=' + encodeURIComponent(this.$route.path);
    },
    noDiscord: function noDiscord() {
      return this.currentUser && !this.currentUser.has_discord;
    },
    classes: function classes() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.buttonClass, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.buttonSelectedClass, this.selected), _ref;
    }
  }),
  data: function data() {
    return {
      description: {
        title: 'Settings',
        text: 'Account Settings'
      }
    };
  },

  methods: {
    disconnectDiscord: function disconnectDiscord() {
      window.location = this.disconnectUrl;
    },
    logout: function logout() {
      window.location = this.logoutUrl;
    }
  },
  watch: {
    currentUser: function currentUser() {
      var _this = this;

      this.$nextTick(function () {
        _this.fetchUserRates();
      });
    }
  }
});

/***/ }),

/***/ "Jgbc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket-raffles"},[_c('info-box',{attrs:{"description":_vm.description}}),_vm._v(" "),_c('header-title',{attrs:{"title":"TICKET RAFFLES"}}),_vm._v(" "),_c('transition-group',{attrs:{"name":_vm.gotInitialRaffles > 1 ? 'raffles-list' : '',"mode":"out-in"}},_vm._l((_vm.currentTicketRaffleIds),function(ticketRaffleId){return _c('ticket-raffle',{key:ticketRaffleId,attrs:{"ticketRaffleId":ticketRaffleId}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KRtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ticket_Raffles_vue__ = __webpack_require__("QEpL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f7f9b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ticket_Raffles_vue__ = __webpack_require__("Jgbc");
function injectStyle (ssrContext) {
  __webpack_require__("Q4zm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39f7f9b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ticket_Raffles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f7f9b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ticket_Raffles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KgMc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ku67":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,on:{"click":function($event){return _vm.clicked()}}},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kw4S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gold_vue__ = __webpack_require__("6NJJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d643138_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gold_vue__ = __webpack_require__("P2re");
function injectStyle (ssrContext) {
  __webpack_require__("2iXL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d643138"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gold_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d643138_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gold_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LYVf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-slide-bar',
  data: function data() {
    return {
      flag: false,
      size: 0,
      currentValue: 0,
      currentSlider: 0,
      isComponentExists: true,
      interval: 1,
      lazy: true,
      realTime: false,
      dataLabelStyles: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        'color': '#4a4a4a',
        'font-family': 'Arial, sans-serif',
        'font-size': '20px'
      }, this.$props.labelStyles)
    };
  },

  props: {
    data: {
      type: Array,
      default: null
    },
    id: {
      type: String,
      default: 'wrap'
    },
    range: {
      type: Array,
      default: null
    },
    speed: {
      type: Number,
      default: 0.3
    },
    lineHeight: {
      type: Number,
      default: 20
    },
    iconWidth: {
      type: Number,
      default: 20
    },
    value: {
      type: [String, Number],
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    showTooltip: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: true
    },
    paddingless: {
      type: Boolean,
      default: false
    },
    tooltipStyles: Object,
    labelStyles: Object,
    processStyle: Object
  },
  computed: {
    slider: function slider() {
      return this.$refs.tooltip;
    },

    val: {
      get: function get() {
        return this.data ? this.data[this.currentValue] : this.currentValue;
      },
      set: function set(val) {
        if (this.data) {
          var index = this.data.indexOf(val);
          if (index > -1) {
            this.currentValue = index;
          }
        } else {
          this.currentValue = val;
        }
      }
    },
    currentIndex: function currentIndex() {
      return (this.currentValue - this.minimum) / this.spacing;
    },
    indexRange: function indexRange() {
      return [0, this.currentIndex];
    },
    minimum: function minimum() {
      return this.data ? 0 : this.min;
    },
    maximum: function maximum() {
      return this.data ? this.data.length - 1 : this.max;
    },
    multiple: function multiple() {
      var decimals = ('' + this.interval).split('.')[1];
      return decimals ? Math.pow(10, decimals.length) : 1;
    },
    spacing: function spacing() {
      return this.data ? 1 : this.interval;
    },
    total: function total() {
      if (this.data) {
        return this.data.length - 1;
      } else if (Math.floor((this.maximum - this.minimum) * this.multiple) % (this.interval * this.multiple) !== 0) {
        this.printError('[VueSlideBar error]: Prop[interval] is illegal, Please make sure that the interval can be divisible');
      }
      return (this.maximum - this.minimum) / this.interval;
    },
    gap: function gap() {
      return this.size / this.total;
    },
    position: function position() {
      return (this.currentValue - this.minimum) / this.spacing * this.gap;
    },
    limit: function limit() {
      return [0, this.size];
    },
    valueLimit: function valueLimit() {
      return [this.minimum, this.maximum];
    },
    calculateHeight: function calculateHeight() {
      return this.paddingless ? {} : { 'padding-top': '40px', 'min-height': this.range ? '100px' : null };
    }
  },
  watch: {
    value: function value(val) {
      if (this.flag) this.setValue(val);else this.setValue(val, this.speed);
    },
    max: function max(val) {
      if (val < this.min) {
        return this.printError('[VueSlideBar error]: The maximum value can not be less than the minimum value.');
      }
      var resetVal = this.limitValue(this.val);
      this.setValue(resetVal);
      this.refresh();
    },
    min: function min(val) {
      if (val > this.max) {
        return this.printError('[VueSlideBar error]: The minimum value can not be greater than the maximum value.');
      }
      var resetVal = this.limitValue(this.val);
      this.setValue(resetVal);
      this.refresh();
    }
  },
  methods: {
    bindEvents: function bindEvents() {
      document.addEventListener('touchmove', this.moving, { passive: false });
      document.addEventListener('touchend', this.moveEnd, { passive: false });
      document.addEventListener('mousemove', this.moving);
      document.addEventListener('mouseup', this.moveEnd);
      document.addEventListener('mouseleave', this.moveEnd);
      window.addEventListener('resize', this.refresh);
    },
    unbindEvents: function unbindEvents() {
      window.removeEventListener('resize', this.refresh);
      document.removeEventListener('touchmove', this.moving);
      document.removeEventListener('touchend', this.moveEnd);
      document.removeEventListener('mousemove', this.moving);
      document.removeEventListener('mouseup', this.moveEnd);
      document.removeEventListener('mouseleave', this.moveEnd);
    },
    getPos: function getPos(e) {
      this.realTime && this.getStaticData();
      return e.clientX - this.offset;
    },
    wrapClick: function wrapClick(e) {
      if (this.isDisabled || !this.draggable && e.target.id === this.id) return false;
      var pos = this.getPos(e);
      this.setValueOnPos(pos);
    },
    moveStart: function moveStart(e, index) {
      if (!this.draggable) return false;
      this.flag = true;
      this.$emit('dragStart', this);
    },
    moving: function moving(e) {
      if (!this.flag || !this.draggable) return false;
      e.preventDefault();
      if (e.targetTouches && e.targetTouches[0]) e = e.targetTouches[0];
      this.setValueOnPos(this.getPos(e), true);
    },
    moveEnd: function moveEnd(e) {
      if (this.flag && this.draggable) {
        this.$emit('dragEnd', this);
        if (this.lazy && this.isDiff(this.val, this.value)) {
          this.syncValue();
        }
      } else {
        return false;
      }
      this.flag = false;
      this.setPosition();
    },
    setValueOnPos: function setValueOnPos(pos, isDrag) {
      var range = this.limit;
      var valueRange = this.valueLimit;
      if (pos >= range[0] && pos <= range[1]) {
        this.setTransform(pos);
        var v = (Math.round(pos / this.gap) * (this.spacing * this.multiple) + this.minimum * this.multiple) / this.multiple;
        this.setCurrentValue(v, isDrag);
      } else if (pos < range[0]) {
        this.setTransform(range[0]);
        this.setCurrentValue(valueRange[0]);
        if (this.currentSlider === 1) this.currentSlider = 0;
      } else {
        this.setTransform(range[1]);
        this.setCurrentValue(valueRange[1]);
        if (this.currentSlider === 0) this.currentSlider = 1;
      }
    },
    isDiff: function isDiff(a, b) {
      if (Object.prototype.toString.call(a) !== Object.prototype.toString.call(b)) {
        return true;
      } else if (Array.isArray(a) && a.length === b.length) {
        return a.some(function (v, i) {
          return v !== b[i];
        });
      }
      return a !== b;
    },
    setCurrentValue: function setCurrentValue(val, bool) {
      if (val < this.minimum || val > this.maximum) return false;
      if (this.isDiff(this.currentValue, val)) {
        this.$emit('persChange', val);
        this.currentValue = val;
        if (!this.lazy || !this.flag) {
          this.syncValue();
        }
      }
      bool || this.setPosition();
    },
    setIndex: function setIndex(val) {
      val = this.spacing * val + this.minimum;
      this.setCurrentValue(val);
    },
    setValue: function setValue(val, speed) {
      var _this = this;

      if (this.isDiff(this.val, val)) {
        var resetVal = this.limitValue(val);
        this.val = resetVal;
        this.syncValue();
      }
      this.$nextTick(function () {
        return _this.setPosition(speed);
      });
    },
    setPosition: function setPosition(speed) {
      if (!this.flag) this.setTransitionTime(speed === undefined ? this.speed : speed);else this.setTransitionTime(0);
      this.setTransform(this.position);
    },
    setTransform: function setTransform(val) {
      var value = val - (this.$refs.tooltip.scrollWidth - 2) / 2;
      var translateValue = 'translateX(' + value + 'px)';
      this.slider.style.transform = translateValue;
      this.slider.style.WebkitTransform = translateValue;
      this.slider.style.msTransform = translateValue;
      this.$refs.process.style.width = val + 'px';
      this.$refs.process.style['left'] = 0;
    },
    setTransitionTime: function setTransitionTime(time) {
      this.slider.style.transitionDuration = time + 's';
      this.slider.style.WebkitTransitionDuration = time + 's';
      this.$refs.process.style.transitionDuration = time + 's';
      this.$refs.process.style.WebkitTransitionDuration = time + 's';
    },
    limitValue: function limitValue(val) {
      var _this2 = this;

      if (this.data) {
        return val;
      }
      var inRange = function inRange(v) {
        if (v < _this2.min) {
          _this2.printError('[VueSlideBar warn]: The value of the slider is ' + val + ', the minimum value is ' + _this2.min + ', the value of this slider can not be less than the minimum value');
          return _this2.min;
        } else if (v > _this2.max) {
          _this2.printError('[VueSlideBar warn]: The value of the slider is ' + val + ', the maximum value is ' + _this2.max + ', the value of this slider can not be greater than the maximum value');
          return _this2.max;
        }
        return v;
      };
      return inRange(val);
    },
    syncValue: function syncValue() {
      var val = this.val;
      if (this.range) {
        this.$emit('callbackRange', this.range[this.currentIndex]);
      }
      this.$emit('input', val);
    },
    getValue: function getValue() {
      return this.val;
    },
    getIndex: function getIndex() {
      return this.currentIndex;
    },
    getStaticData: function getStaticData() {
      if (this.$refs.elem) {
        this.size = this.$refs.elem.offsetWidth;
        this.offset = this.$refs.elem.getBoundingClientRect().left;
      }
    },
    refresh: function refresh() {
      if (this.$refs.elem) {
        this.getStaticData();
        this.setPosition();
      }
    },
    printError: function printError(msg) {
      console.error(msg);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.isComponentExists = true;
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return this.printError('[VueSlideBar error]: window or document is undefined, can not be initialization.');
    }
    this.$nextTick(function () {
      if (_this3.isComponentExists) {
        _this3.getStaticData();
        _this3.setValue(_this3.limitValue(_this3.value), 0);
        _this3.bindEvents();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.isComponentExists = false;
    this.unbindEvents();
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_214617df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("mwy/");
function injectStyle (ssrContext) {
  __webpack_require__("eD3p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_214617df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MwQK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_theme_css__ = __webpack_require__("TXXm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Bet__ = __webpack_require__("1dfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Ticket_Raffle__ = __webpack_require__("QoSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Ticket_Raffle_Entries__ = __webpack_require__("lvsm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Placed_Bets__ = __webpack_require__("PyNB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_User__ = __webpack_require__("jyJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Debug_Panel__ = __webpack_require__("8vID");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Login_Btn__ = __webpack_require__("qsJG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Discord_Btn__ = __webpack_require__("crjj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Login_Status__ = __webpack_require__("zLEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_button_a__ = __webpack_require__("dk+Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Navigation_Bar__ = __webpack_require__("jBHF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Header_Title__ = __webpack_require__("0wuu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Info_Box__ = __webpack_require__("ej5g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_util_js__ = __webpack_require__("CPGk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_gtag__ = __webpack_require__("Z3T5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_upload_component__ = __webpack_require__("1Wvq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_upload_component__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = "production" === 'production';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.ENV = "production";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.CURRENCY_SERVICE_BASE_URL = "https://api.swiftorland.com/api";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.WS_SERVICE_BASE_URL = "wss://api.swiftorland.com/ws";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.CURRENCY_SERVICE_ROOT_BASE_URL = "https://api.swiftorland.com";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.PAYPAL_CLIENT_ID = "AbP5vmOf208zMXmLCADx7--vXWJlMXsvR-0MhKmCKwRYqehXpA5cSyrJQ6Oyp2NYY0UVynsMGFMF3DaV";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.ITEM_ASSET_BASE_URL = "https://swiftorland.com/item-assets";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.WEB_ASSET_BASE_URL = "https://swiftorland.com/web-assets";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.ROOM_JS_URL = "https://swiftorland.com/js/swiftorrooms.js";

// console.log('PROCESS', Vue.config.WS_SERVICE_BASE_URL)























// config: { id: 'UA-177228719-1' }
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_gtag__["a" /* default */], {
  config: { id: 'G-FZDEQXC5WP' }
}, __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].connect();

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('file-upload', __WEBPACK_IMPORTED_MODULE_21_vue_upload_component___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Bet', __WEBPACK_IMPORTED_MODULE_4__components_Bet__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('placed-bets', __WEBPACK_IMPORTED_MODULE_7__components_Placed_Bets__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('login-btn', __WEBPACK_IMPORTED_MODULE_10__components_Login_Btn__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('discord-btn', __WEBPACK_IMPORTED_MODULE_11__components_Discord_Btn__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('login-status', __WEBPACK_IMPORTED_MODULE_12__components_Login_Status__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ticket-raffle', __WEBPACK_IMPORTED_MODULE_5__components_Ticket_Raffle__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ticket-raffle-entries', __WEBPACK_IMPORTED_MODULE_6__components_Ticket_Raffle_Entries__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('button-a', __WEBPACK_IMPORTED_MODULE_13__components_button_a__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('nav-bar', __WEBPACK_IMPORTED_MODULE_14__components_Navigation_Bar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('header-title', __WEBPACK_IMPORTED_MODULE_15__components_Header_Title__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('info-box', __WEBPACK_IMPORTED_MODULE_16__components_Info_Box__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('User', __WEBPACK_IMPORTED_MODULE_8__components_User__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('debug-panel', __WEBPACK_IMPORTED_MODULE_9__components_Debug_Panel__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_17__lib_util_js__["a" /* default */]);

// console.log('mixins', mixins)

/* eslint-disable no-new */
window.App = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_17__lib_util_js__["a" /* default */]]
});

/***/ }),

/***/ "NifY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NtJT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'info-box',
  data: function data() {
    return {
      expanded: false
    };
  },

  props: ['description'],
  methods: {
    toggleExpand: function toggleExpand() {
      var _this = this;

      if (this.expanded) {
        document.getElementsByClassName('info-container')[0].className = 'info-container';
        setTimeout(function () {
          _this.expanded = false;
        }, 300);
      } else {
        this.expanded = true;
        document.getElementsByClassName('info-container')[0].classList.add('expand');
      }
    }
  }
});

/***/ }),

/***/ "O5HS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P2re":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.$route.fullPath,staticClass:"hello"},[_c('header-title',{attrs:{"title":"GOLD"}}),_vm._v(" "),(_vm.user)?_c('div',{staticStyle:{"margin":"40px"}},[_c('div',[_c('User',{attrs:{"user_id":_vm.forUserId}}),_vm._v(" "),_c('br'),_c('br')],1),_vm._v(" "),(_vm.processing)?_c('div',[_vm._v("\n      Processing..."),_c('br'),_c('br'),_vm._v(" "),_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"cspin",attrs:{"cx":"50","cy":"50","r":"45"}})])]):_c('div',[(_vm.tsxError)?_c('div',[_vm._v("Sorry, there was an error with your order."),_c('br'),_c('br'),_vm._v(_vm._s(_vm.tsxError))]):(_vm.tsxSuccess)?_c('div',[_vm._v("\n        Thanks for donating!"),_c('br'),_c('br'),_vm._v(" "),(_vm.donation)?_c('table',{staticStyle:{"margin-left":"auto","margin-right":"auto"},attrs:{"border":"1"}},[_c('tr',[_c('td',[_vm._v("Order ID")]),_c('td',[_vm._v(_vm._s(_vm.donation.order_id))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Amount")]),_c('td',[_vm._v("$"+_vm._s(_vm.donation.amount))])])]):_vm._e()]):_c('div',[_c('div',{staticClass:"package-select",staticStyle:{"display":"none"}},[_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPackage),expression:"selectedPackage"}],attrs:{"type":"radio","id":"pkg0","value":"0"},domProps:{"checked":_vm._q(_vm.selectedPackage,"0")},on:{"change":function($event){_vm.selectedPackage="0"}}}),_vm._v(" "),_c('br'),_c('label',{class:{'btn-enabled':true, 'btn-top':true, 'btn-selected':_vm.selectedPackage === '0'},attrs:{"for":"pkg0"}},[_vm._v("SwiftGOLD")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"font-size":"30px","font-weight":"bold"}},[_vm._v("Donate $"+_vm._s(_vm.cost)+" = "+_vm._s(_vm.quantity)+" "+_vm._s(_vm.denomination)+"!")]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"auto","margin-right":"auto","margin-top":"10px"}},[_c('vue-slider',{attrs:{"min":1,"max":_vm.sliderMax,"interval":_vm.interval,"adsorb":true},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}}),_c('br'),_vm._v(" "),_vm._l((_vm.buttonAmounts),function(buttonQuantity){return _c('span',{key:buttonQuantity},[_c('button-a',{staticStyle:{"font-size":"40px","padding":"8px"},attrs:{"selected":buttonQuantity === _vm.quantity},on:{"clicked":function($event){return _vm.changeQuantity(buttonQuantity)}}},[_vm._v(_vm._s(_vm.buttonLabel(buttonQuantity)))])],1)}),_vm._v(" "),_c('span',[(!_vm.currentUser)?_c('login-btn',{staticStyle:{"font-size":"40px","padding":"8px"},attrs:{"buttonClass":"btn-enabled"}},[_vm._v("Login for more options!")]):_vm._e()],1)],2),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.hasMessage)?_c('span',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"messagetext",attrs:{"placeholder":"Your Message Here!"},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"paypal-button-container"}})])])]):_c('div',[(_vm.currentUser)?_c('span',[_vm._v("Unknown User"),_c('br'),_vm._v("Were you trying to donate to someone else?"),_c('br'),_c('br'),_c('h1',[_vm._v("If you want to donate on behalf of yourself "),_c('router-link',{attrs:{"to":"/donate"}},[_vm._v("CLICK HERE")])],1)]):_c('span',[_c('login-btn',{staticStyle:{"font-size":"40px","padding":"8px"},attrs:{"buttonClass":"btn-enabled"}},[_vm._v("Login to donate!")])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"font-size":"20px","font-weight":"bold"}},[_vm._v("!Save uses 10 gold & !Kill uses 66 gold")]),_vm._v(" "),_c('div',[_vm._v("(If you had unused tokens before July 4th, 2023 they were converted to gold at the same rate!)")]),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PDux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bounty',
  props: {
    subBounty: {
      type: Object,
      required: true
    },
    tier: {
      type: Number,
      default: 1
    },
    rank: {
      type: Number,
      default: 0
    },
    btnLabel: {
      type: String,
      default: 'Gift Sub'
    }
  },
  methods: {
    giftSub: function giftSub() {
      window.open('https://www.twitch.tv/products/swiftor' + (this.tier === 2 ? '_2000' : this.tier === 3 ? '_3000' : '') + '?recipient=' + this.users[this.subBounty.user_id].twitch_name);
    }
  },
  data: function data() {
    return {
      users: this.$store.state.users
    };
  }
});

/***/ }),

/***/ "PIM1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-title',{attrs:{"title":"LEGAL"}}),_vm._v(" "),_c('div',{staticClass:"legal"},[_c('div',[_vm._v("For all inquiries legal and otherwise please contact joseph@swiftor.com")]),_vm._v(" "),_c('div',[_c('button',{staticClass:"linkbutton",on:{"click":function($event){return _vm.goto('pp')}}},[_vm._v("Privacy Policy")]),_vm._v(" "),_c('button',{staticClass:"linkbutton",on:{"click":function($event){return _vm.goto('tos')}}},[_vm._v("Terms Of Service")]),_vm._v(" "),_c('button',{staticClass:"linkbutton",on:{"click":function($event){return _vm.goto('cookie')}}},[_vm._v("Cookie Policy")])]),_vm._v(" "),_c('div',{ref:"pp"},[_c('h2',[_vm._v("Privacy Policy")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h3',[_vm._v("1. Information we collect")]),_vm._v(" "),_c('h4',[_vm._v("Log data")]),_vm._v(" "),_c('p',[_vm._v("When you visit our website, our servers may automatically log the standard data provided by your web browser. It may include your computer’s Internet Protocol (IP) address, your browser type and version, the pages you visit, the time and date of your visit, the time spent on each page, and other details.")]),_vm._v(" "),_c('h4',[_vm._v("Device data")]),_vm._v(" "),_c('p',[_vm._v("We may also collect data about the device you’re using to access our website. This data may include the device type, operating system, unique device identifiers, device settings, and geo-location data. What we collect can depend on the individual settings of your device and software. We recommend checking the policies of your device manufacturer or software provider to learn what information they make available to us.")]),_vm._v(" "),_c('h4',[_vm._v("Personal information")]),_vm._v(" "),_c('p',[_vm._v("We may ask for personal information, such as your:")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h3',[_vm._v("2. Legal bases for processing")]),_vm._v(" "),_c('p',[_vm._v("We will process your personal information lawfully, fairly and in a transparent manner. We collect and process information about you only where we have legal bases for doing so.")]),_vm._v(" "),_c('p',[_vm._v("These legal bases depend on the services you use and how you use them, meaning we collect and use your information only where:")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("Where you consent to our use of information about you for a specific purpose, you have the right to change your mind at any time (but this will not affect any processing that has already taken place).")]),_vm._v(" "),_c('p',[_vm._v("We don’t keep personal information for longer than is necessary. While we retain this information, we will protect it within commercially acceptable means to prevent loss and theft, as well as unauthorized access, disclosure, copying, use or modification. That said, we advise that no method of electronic transmission or storage is 100% secure and cannot guarantee absolute data security. If necessary, we may retain your personal information for our compliance with a legal obligation or in order to protect your vital interests or the vital interests of another natural person.")]),_vm._v(" "),_c('h3',[_vm._v("3. Collection and use of information")]),_vm._v(" "),_c('p',[_vm._v("We may collect, hold, use and disclose information for the following purposes and personal information will not be further processed in a manner that is incompatible with these purposes:")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h3',[_vm._v("4. Disclosure of personal information to third parties")]),_vm._v(" "),_c('p',[_vm._v("We may disclose personal information to:")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h3',[_vm._v("5. International transfers of personal information")]),_vm._v(" "),_c('p',[_vm._v("The personal information we collect is stored and processed in United States, or where we or our partners, affiliates and third-party providers maintain facilities. By providing us with your personal information, you consent to the disclosure to these overseas third parties.")]),_vm._v(" "),_c('p',[_vm._v("We will ensure that any transfer of personal information from countries in the European Economic Area (EEA) to countries outside the EEA will be protected by appropriate safeguards, for example by using standard data protection clauses approved by the European Commission, or the use of binding corporate rules or other legally accepted means.")]),_vm._v(" "),_c('p',[_vm._v("Where we transfer personal information from a non-EEA country to another country, you acknowledge that third parties in other jurisdictions may not be subject to similar data protection laws to the ones in our jurisdiction. There are risks if any such third party engages in any act or practice that would contravene the data privacy laws in our jurisdiction and this might mean that you will not be able to seek redress under our jurisdiction’s privacy laws.")]),_vm._v(" "),_c('h3',[_vm._v("6. Your rights and controlling your personal information")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('h3',[_vm._v("7. Cookies")]),_vm._v(" "),_c('p',[_vm._v("We use “cookies” to collect information about you and your activity across our site. A cookie is a small piece of data that our website stores on your computer, and accesses each time you visit, so we can understand how you use our site. This helps us serve you content based on preferences you have specified. Please refer to our Cookie Policy for more information.")]),_vm._v(" "),_c('h3',[_vm._v("8. Business transfers")]),_vm._v(" "),_c('p',[_vm._v("If we or our assets are acquired, or in the unlikely event that we go out of business or enter bankruptcy, we would include data among the assets transferred to any parties who acquire us. You acknowledge that such transfers may occur, and that any parties who acquire us may continue to use your personal information according to this policy.")]),_vm._v(" "),_c('h3',[_vm._v("9. Limits of our policy")]),_vm._v(" "),_c('p',[_vm._v("Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and policies of those sites, and cannot accept responsibility or liability for their respective privacy practices.")]),_vm._v(" "),_c('h3',[_vm._v("10. Changes to this policy")]),_vm._v(" "),_c('p',[_vm._v("At our discretion, we may change our privacy policy to reflect current acceptable practices. We will take reasonable steps to let users know about changes via our website. Your continued use of this site after any changes to this policy will be regarded as acceptance of our practices around privacy and personal information. ")]),_vm._v(" "),_c('p',[_vm._v("If we make a significant change to this privacy policy, for example changing a lawful basis on which we process your personal information, we will ask you to re-consent to the amended privacy policy.")]),_vm._v(" "),_vm._m(13)]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{ref:"tos"},[_c('h2',[_vm._v("Crash2Swift LLP Terms of Service")]),_vm._v(" "),_c('h3',[_vm._v("1. Terms")]),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('h3',[_vm._v("2. Use License")]),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('h3',[_vm._v("3. Disclaimer")]),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('h3',[_vm._v("4. Limitations")]),_vm._v(" "),_c('p',[_vm._v("In no event shall Crash2Swift LLP or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Crash2Swift LLP's website, even if Crash2Swift LLP or a Crash2Swift LLP authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.")]),_vm._v(" "),_c('h3',[_vm._v("5. Accuracy of materials")]),_vm._v(" "),_c('p',[_vm._v("The materials appearing on Crash2Swift LLP's website could include technical, typographical, or photographic errors. Crash2Swift LLP does not warrant that any of the materials on its website are accurate, complete or current. Crash2Swift LLP may make changes to the materials contained on its website at any time without notice. However Crash2Swift LLP does not make any commitment to update the materials.")]),_vm._v(" "),_c('h3',[_vm._v("6. Links")]),_vm._v(" "),_c('p',[_vm._v("Crash2Swift LLP has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Crash2Swift LLP of the site. Use of any such linked website is at the user's own risk.")]),_vm._v(" "),_c('h3',[_vm._v("7. Modifications")]),_vm._v(" "),_c('p',[_vm._v("Crash2Swift LLP may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.")]),_vm._v(" "),_c('h3',[_vm._v("8. Governing Law")]),_vm._v(" "),_c('p',[_vm._v("These terms and conditions are governed by and construed in accordance with the laws of NJ and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.")])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{ref:"cookie"},[_c('h2',[_vm._v("Cookie Policy")]),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('h3',[_vm._v("What is a cookie?")]),_vm._v(" "),_c('p',[_vm._v("A cookie is a small piece of data that a website stores on your device when you visit, typically containing information about the website itself, a unique identifier that allows the site to recognize your web browser when you return, additional data that serves the purpose of the cookie, and the lifespan of the cookie itself.")]),_vm._v(" "),_c('p',[_vm._v("Cookies are used to enable certain features (eg. logging in), to track site usage (eg. analytics), to store your user settings (eg. timezone, notification preferences), and to personalize your content (eg. advertising, language).")]),_vm._v(" "),_c('p',[_vm._v("Cookies set by the website you are visiting are normally referred to as “first-party cookies”, and typically only track your activity on that particular site. Cookies set by other sites and companies (ie. third parties) are called “third-party cookies”, and can be used to track you on other websites that use the same third-party service.")]),_vm._v(" "),_c('h3',[_vm._v("Types of cookies and how we use them")]),_vm._v(" "),_c('h4',[_vm._v("Essential cookies")]),_vm._v(" "),_c('p',[_vm._v("Essential cookies are crucial to your experience of a website, enabling core features like user logins, account management, shopping carts and payment processing. We use essential cookies to enable certain functions on our website.")]),_vm._v(" "),_c('h4',[_vm._v("Performance cookies")]),_vm._v(" "),_c('p',[_vm._v("Performance cookies are used in the tracking of how you use a website during your visit, without collecting personal information about you. Typically, this information is anonymous and aggregated with information tracked across all site users, to help companies understand visitor usage patterns, identify and diagnose problems or errors their users may encounter, and make better strategic decisions in improving their audience’s overall website experience. These cookies may be set by the website you’re visiting (first-party) or by third-party services. We use performance cookies on our site.")]),_vm._v(" "),_c('h4',[_vm._v("Functionality cookies")]),_vm._v(" "),_c('p',[_vm._v("Functionality cookies are used in collecting information about your device and any settings you may configure on the website you’re visiting (like language and time zone settings). With this information, websites can provide you with customized, enhanced or optimized content and services. These cookies may be set by the website you’re visiting (first-party) or by third-party service. We use functionality cookies for selected features on our site.")]),_vm._v(" "),_c('h4',[_vm._v("Targeting/advertising cookies")]),_vm._v(" "),_c('p',[_vm._v("Targeting/advertising cookies are used in determining what promotional content is more relevant and appropriate to you and your interests. Websites may use them to deliver targeted advertising or to limit the number of times you see an advertisement. This helps companies improve the effectiveness of their campaigns and the quality of content presented to you. These cookies may be set by the website you’re visiting (first-party) or by third-party services. Targeting/advertising cookies set by third-parties may be used to track you on other websites that use the same third-party service. We use targeting/advertising cookies on our site.")]),_vm._v(" "),_c('h3',[_vm._v("Third-party cookies on our site")]),_vm._v(" "),_c('p',[_vm._v("We may employ third-party companies and individuals on our websites—for example, analytics providers and content partners. We grant these third parties access to selected information to perform specific tasks on our behalf. They may also set third-party cookies in order to deliver the services they are providing. Third-party cookies can be used to track you on other websites that use the same third-party service. As we have no control over third-party cookies, they are not covered by Crash2Swift LLP's cookie policy.")]),_vm._v(" "),_c('h4',[_vm._v("Our third-party privacy promise")]),_vm._v(" "),_c('p',[_vm._v("We review the privacy policies of all our third-party providers before enlisting their services to ensure their practices align with ours. We will never knowingly include third-party services that compromise or violate the privacy of our users.")]),_vm._v(" "),_c('h3',[_vm._v("How you can control or opt out of cookies")]),_vm._v(" "),_c('p',[_vm._v("If you do not wish to accept cookies from us, you can instruct your browser to refuse cookies from our website. Most browsers are configured to accept cookies by default, but you can update these settings to either refuse cookies altogether, or to notify you when a website is trying to set or update a cookie.")]),_vm._v(" "),_c('p',[_vm._v("If you browse websites from multiple devices, you may need to update your settings on each individual device.")]),_vm._v(" "),_c('p',[_vm._v("Although some cookies can be blocked with little impact on your experience of a website, blocking all cookies may mean you are unable to access certain features and content across the sites you visit.")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Your privacy is important to us. It is Crash2Swift LLP's policy to respect your privacy regarding any information we may collect from you across our website, "),_c('a',{attrs:{"href":"https://swiftorland.com"}},[_vm._v("https://swiftorland.com")]),_vm._v(", and other sites we own and operate.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Name")]),_vm._v(" "),_c('li',[_vm._v("Email")]),_vm._v(" "),_c('li',[_vm._v("Social media profiles")]),_vm._v(" "),_c('li',[_vm._v("Date of birth")]),_vm._v(" "),_c('li',[_vm._v("Phone/mobile number")]),_vm._v(" "),_c('li',[_vm._v("Home/Mailing address")]),_vm._v(" "),_c('li',[_vm._v("Work address")]),_vm._v(" "),_c('li',[_vm._v("Payment information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("it’s necessary for the performance of a contract to which you are a party or to take steps at your request before entering into such a contract (for example, when we provide a service you request from us);")]),_vm._v(" "),_c('li',[_vm._v("it satisfies a legitimate interest (which is not overridden by your data protection interests), such as for research and development, to market and promote our services, and to protect our legal rights and interests;")]),_vm._v(" "),_c('li',[_vm._v("you give us consent to do so for a specific purpose (for example, you might consent to us sending you our newsletter); or")]),_vm._v(" "),_c('li',[_vm._v("we need to process your data to comply with a legal obligation.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("to enable you to customize or personalize your experience of our website;")]),_vm._v(" "),_c('li',[_vm._v("to enable you to access and use our website, associated applications and associated social media platforms;")]),_vm._v(" "),_c('li',[_vm._v("to contact and communicate with you;")]),_vm._v(" "),_c('li',[_vm._v("for internal record keeping and administrative purposes;")]),_vm._v(" "),_c('li',[_vm._v("for analytics, market research and business development, including to operate and improve our website, associated applications and associated social media platforms;")]),_vm._v(" "),_c('li',[_vm._v("to run competitions and/or offer additional benefits to you;")]),_vm._v(" "),_c('li',[_vm._v("for advertising and marketing, including to send you promotional information about our products and services and information about third parties that we consider may be of interest to you;")]),_vm._v(" "),_c('li',[_vm._v("to comply with our legal obligations and resolve any disputes that we may have; and")]),_vm._v(" "),_c('li',[_vm._v("to consider your employment application.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("third party service providers for the purpose of enabling them to provide their services, including (without limitation) IT service providers, data storage, hosting and server providers, ad networks, analytics, error loggers, debt collectors, maintenance or problem-solving providers, marketing or advertising providers, professional advisors and payment systems operators;")]),_vm._v(" "),_c('li',[_vm._v("our employees, contractors and/or related entities;")]),_vm._v(" "),_c('li',[_vm._v("sponsors or promoters of any competition we run;")]),_vm._v(" "),_c('li',[_vm._v("credit reporting agencies, courts, tribunals and regulatory authorities, in the event you fail to pay for goods or services we have provided to you;")]),_vm._v(" "),_c('li',[_vm._v("courts, tribunals, regulatory authorities and law enforcement officers, as required by law, in connection with any actual or prospective legal proceedings, or in order to establish, exercise or defend our legal rights;")]),_vm._v(" "),_c('li',[_vm._v("third parties, including agents or sub-contractors, who assist us in providing information, products, services or direct marketing to you; and")]),_vm._v(" "),_c('li',[_vm._v("third parties to collect and process data.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Choice and consent:")]),_vm._v(" By providing personal information to us, you consent to us collecting, holding, using and disclosing your personal information in accordance with this privacy policy. If you are under 16 years of age, you must have, and warrant to the extent permitted by law to us, that you have your parent or legal guardian’s permission to access and use the website and they (your parents or guardian) have consented to you providing us with your personal information. You do not have to provide personal information to us, however, if you do not, it may affect your use of this website or the products and/or services offered on or through it.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Information from third parties:")]),_vm._v(" If we receive personal information about you from a third party, we will protect it as set out in this privacy policy. If you are a third party providing personal information about somebody else, you represent and warrant that you have such person’s consent to provide the personal information to us.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Restrict:")]),_vm._v(" You may choose to restrict the collection or use of your personal information. If you have previously agreed to us using your personal information for direct marketing purposes, you may change your mind at any time by contacting us using the details below. If you ask us to restrict or limit how we process your personal information, we will let you know how the restriction affects your use of our website or products and services.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Access and data portability:")]),_vm._v(" You may request details of the personal information that we hold about you. You may request a copy of the personal information we hold about you. Where possible, we will provide this information in CSV format or other easily readable machine format. You may request that we erase the personal information we hold about you at any time. You may also request that we transfer this personal information to another third party.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Correction:")]),_vm._v(" If you believe that any information we hold about you is inaccurate, out of date, incomplete, irrelevant or misleading, please contact us using the details below. We will take reasonable steps to correct any information found to be inaccurate, incomplete, misleading or out of date.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Notification of data breaches:")]),_vm._v(" We will comply laws applicable to us in respect of any data breach.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Complaints:")]),_vm._v(" If you believe that we have breached a relevant data protection law and wish to make a complaint, please contact us using the details below and provide us with full details of the alleged breach. We will promptly investigate your complaint and respond to you, in writing, setting out the outcome of our investigation and the steps we will take to deal with your complaint. You also have the right to contact a regulatory body or data protection authority in relation to your complaint.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Unsubscribe:")]),_vm._v(" To unsubscribe from our e-mail database or opt-out of communications (including marketing communications), please contact us using the details below or opt-out using the opt-out facilities provided in the communication.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Crash2Swift LLP Data Controller")]),_c('br'),_vm._v("\n      Joseph Alminawi"),_c('br'),_vm._v("\n      joseph@swiftor.com")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("By accessing the website at "),_c('a',{attrs:{"href":"http://swiftorland.com"}},[_vm._v("http://swiftorland.com")]),_vm._v(", you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{attrs:{"type":"a"}},[_c('li',[_vm._v("Permission is granted to temporarily download one copy of the materials (information or software) on Crash2Swift LLP's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:\n        "),_c('ol',{attrs:{"type":"i"}},[_c('li',[_vm._v("modify or copy the materials;")]),_vm._v(" "),_c('li',[_vm._v("use the materials for any commercial purpose, or for any public display (commercial or non-commercial);")]),_vm._v(" "),_c('li',[_vm._v("attempt to decompile or reverse engineer any software contained on Crash2Swift LLP's website;")]),_vm._v(" "),_c('li',[_vm._v("remove any copyright or other proprietary notations from the materials; or")]),_vm._v(" "),_c('li',[_vm._v("transfer the materials to another person or \"mirror\" the materials on any other server.")])])]),_vm._v(" "),_c('li',[_vm._v("This license shall automatically terminate if you violate any of these restrictions and may be terminated by Crash2Swift LLP at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{attrs:{"type":"a"}},[_c('li',[_vm._v("The materials on Crash2Swift LLP's website are provided on an 'as is' basis. Crash2Swift LLP makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.")]),_vm._v(" "),_c('li',[_vm._v("Further, Crash2Swift LLP does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("We use cookies to help improve your experience of "),_c('a',{attrs:{"href":"http://swiftorland.com"}},[_vm._v("http://swiftorland.com")]),_vm._v(". This cookie policy is part of Crash2Swift LLP's privacy policy, and covers the use of cookies between your device and our site. We also provide basic information on third-party services we may use, who may also use cookies as part of their service, though they are not covered by our policy.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If you don’t wish to accept cookies from us, you should instruct your browser to refuse cookies from "),_c('a',{attrs:{"href":"http://swiftorland.com"}},[_vm._v("http://swiftorland.com")]),_vm._v(", with the understanding that we may be unable to provide you with some of your desired content and services.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PyNB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Placed_Bets_vue__ = __webpack_require__("YnHO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a9c1677_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Placed_Bets_vue__ = __webpack_require__("15Fk");
function injectStyle (ssrContext) {
  __webpack_require__("gvmA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a9c1677"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Placed_Bets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a9c1677_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Placed_Bets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q1NU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loot_Box_Editor_vue__ = __webpack_require__("+VKC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a924ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loot_Box_Editor_vue__ = __webpack_require__("AXKg");
function injectStyle (ssrContext) {
  __webpack_require__("ENjp")
  __webpack_require__("R51L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20a924ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loot_Box_Editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a924ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loot_Box_Editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q4zm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QEpL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ticket-raffles',
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.refreshTicketRaffles();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      gotInitialRaffles: 0,
      description: {
        title: 'Ticket Raffles',
        text: 'New raffles will be displayed here, You can buy tickets to enter an open raffle by clicking on the raffle and entering an amount then clicking "Buy Tickets", If you want to buy tickets in chat, type the KEYWORD (without !) and the # of tickets you want - you don\u2019t need to be here if you win, you\u2019ll get whispered your prize or info'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['currentTicketRaffleIds']), {}),
  watch: {
    currentTicketRaffleIds: function currentTicketRaffleIds() {
      this.gotInitialRaffles += 1;
    }
  },
  methods: {
    refreshTicketRaffles: function refreshTicketRaffles() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$store.dispatch('fetchCurrentTicketRaffles');
                _this2.$store.dispatch('fetchMyTickets');

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ "QUrP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Legal_vue__ = __webpack_require__("dBxG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d54fb24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Legal_vue__ = __webpack_require__("PIM1");
function injectStyle (ssrContext) {
  __webpack_require__("7ONy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d54fb24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Legal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d54fb24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Legal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QoSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ticket_Raffle_vue__ = __webpack_require__("3HkH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a62c08a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ticket_Raffle_vue__ = __webpack_require__("fVht");
function injectStyle (ssrContext) {
  __webpack_require__("mHoR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a62c08a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ticket_Raffle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a62c08a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ticket_Raffle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R51L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sur4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Donate_vue__ = __webpack_require__("dPtJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae9f194_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Donate_vue__ = __webpack_require__("YTl1");
function injectStyle (ssrContext) {
  __webpack_require__("nmIj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ae9f194"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Donate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae9f194_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Donate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T053":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Equipped_Items_vue__ = __webpack_require__("kpOj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d7abb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Equipped_Items_vue__ = __webpack_require__("Vog3");
function injectStyle (ssrContext) {
  __webpack_require__("W3dH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63d7abb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Equipped_Items_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d7abb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Equipped_Items_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T6eZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('info-box',{attrs:{"description":_vm.description}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TXXm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U/mA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Room_Item_Editor_vue__ = __webpack_require__("oJIt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df1fb52e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Room_Item_Editor_vue__ = __webpack_require__("waJr");
function injectStyle (ssrContext) {
  __webpack_require__("+hvY")
  __webpack_require__("oIDu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-df1fb52e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Room_Item_Editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df1fb52e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Room_Item_Editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UO5z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V+1Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import BigNumber from 'BigNumber.js'
// import axios from 'axios'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'room-item-management',
  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.refreshLootItems();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      description: {
        title: 'Room Item Management',
        text: 'Do it!'
      },
      notification: undefined
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['currentUser', 'lootShopLootItemIds', 'lootShopLootItems', 'roomItemPageCurrent', 'roomItemPages']), {}),
  methods: {
    next: function next() {
      if (this.roomItemPages.length - 1 > this.roomItemPageCurrent) {
        this.$store.dispatch('gotoRoomPage', this.roomItemPageCurrent + 1);
      } else {
        this.$store.dispatch('fetchRoomPage', this.roomItemPages[this.roomItemPageCurrent].cursor);
      }
    },
    back: function back() {
      this.$store.dispatch('gotoRoomPage', this.roomItemPageCurrent - 1);
    },
    refreshLootItems: function refreshLootItems() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch('roomItemPageReset');

              case 2:
                _this2.$store.dispatch('fetchRoomPage');

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    categoryTextFor: function categoryTextFor(shopItem) {
      if (shopItem.category === 'lootChest') {
        return 'Virtual LOOTCHEST';
      } else if (shopItem.category === 'roomItem') {
        return 'Virtual Room Item';
      } else {
        return 'Token';
      }
    },
    lootShopLootItemForId: function lootShopLootItemForId(id) {
      return this.$store.state.lootShopLootItems[id];
    },
    lootItemImageUrl: function lootItemImageUrl(lootItem) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.WEB_ASSET_BASE_URL + '/' + lootItem.image_url;
    },
    currencyIcon: function currencyIcon(priceCurrencyType) {
      var image = priceCurrencyType === 'mt' ? 'swiftGold.png' : 'swiftBucks.png';

      return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.WEB_ASSET_BASE_URL + '/' + image;
    },
    attributionText: function attributionText(lootItem) {
      if (!lootItem.attribution_author) {
        return;
      }
      // // "Creative Commons 10th Birthday Celebration San Francisco" by tvol is licensed under CC BY 2.0
      return '<a href="' + lootItem.attribution_title_url + '" target="_blank">"' + lootItem.attribution_title + '"</a> by <a href="' + lootItem.attribution_author_url + '" target="_blank">' + lootItem.attribution_author + '</a> <br/> Licensed under <a href="' + lootItem.attribution_license_url + '" target="_blank">' + lootItem.attribution_license + '</a>';
    },
    requiresAttribution: function requiresAttribution(lootItem) {
      return !!lootItem.attribution_author;
    },
    notify: function notify(text) {
      var _this3 = this;

      this.notification = text;
      setTimeout(function () {
        _this3.notification = undefined;
      }, 5000);
    },
    create: function create() {
      __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({ name: 'RoomItemEditorCreate' });
    }
  },
  watch: {}
});

/***/ }),

/***/ "VHjs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vog3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('info-box',{attrs:{"description":_vm.description}}),_vm._v(" "),_c('header-title',{attrs:{"title":"EQUIPPED ITEMS"}}),_vm._v(" "),(_vm.currentUser)?_c('div',{staticStyle:{"overflow-y":"auto"},style:({maxHeight: '85%'})},[_c('div',{staticClass:"rate-title"},[_c('div',{style:({fontSize: '1.5rem', fontWeight: 700})},[_vm._v("Your Rate")])]),_vm._v(" "),_vm._m(0)]):_c('span',[_c('login-btn',{staticStyle:{"font-size":"40px","padding":"8px"},attrs:{"buttonClass":"btn-enabled"}},[_vm._v("Login to View Equipped Items!")])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"inventory-container"},[_c('div',{staticClass:"slot-grid"},[_c('div',{staticClass:"slot-cell"},[_c('img',{attrs:{"src":"path/to/your/slot-item1.png","alt":"Slot Item 1"}})])]),_vm._v(" "),_c('div',{staticClass:"inventory-grid"},[_c('div',{staticClass:"inventory-item"},[_c('img',{attrs:{"src":"path/to/your/inventory-item1.png","alt":"Inventory Item 1"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W3dH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WFG9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WJf4":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjE1MHB4IiB2aWV3Qm94PSIwIDAgMjAwIDE1MCI+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9IkdyYWRpZW50XzEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iLTAuMDEyNTAwMDAwMDAwMDAyODQyIiB5MT0iNzQuOTUiIHgyPSI5OS45MTI1MDAwMDAwMDAwMSIgeTI9Ijc0Ljk1IiBzcHJlYWRNZXRob2Q9InBhZCI+CjxzdG9wICBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjRkZGRkZGIi8+Cgo8c3RvcCAgb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjQTRBNEE0Ii8+CjwvbGluZWFyR3JhZGllbnQ+Cgo8bGluZWFyR3JhZGllbnQgaWQ9IkdyYWRpZW50XzIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iOTkuOTM3NDk5OTk5OTk5OTkiIHkxPSI3NC45NSIgeDI9IjE5OS45NjI0OTk5OTk5OTk5OCIgeTI9Ijc0Ljk1IiBzcHJlYWRNZXRob2Q9InBhZCI+CjxzdG9wICBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjRkZGRkZGIi8+Cgo8c3RvcCAgb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjQTRBNEE0Ii8+CjwvbGluZWFyR3JhZGllbnQ+Cgo8ZyBpZD0iTGF5ZXIwXzBfRklMTCI+CjxwYXRoIGZpbGw9InVybCgjR3JhZGllbnRfMSkiIHN0cm9rZT0ibm9uZSIgZD0iCk0gOTkuOTUgNzcuMgpMIDk5Ljk1IDAgMCA3OS41IDAgMTQ5Ljk1IDk5Ljk1IDc3LjIgWiIvPgoKPHBhdGggZmlsbD0idXJsKCNHcmFkaWVudF8yKSIgc3Ryb2tlPSJub25lIiBkPSIKTSAyMDAgMTUwCkwgMjAwIDc5LjYgOTkuOTUgMCA5OS45NSA3Ny4yIDIwMCAxNTAgWiIvPgo8L2c+CjwvZGVmcz4KCjxnIHRyYW5zZm9ybT0ibWF0cml4KCAxLCAwLCAwLCAxLCAwLDApICI+Cjx1c2UgeGxpbms6aHJlZj0iI0xheWVyMF8wX0ZJTEwiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "Wng7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group"},[(_vm.selectedOption.name !== undefined)?_c('li',{staticClass:"dropdown-toggle",on:{"click":function($event){return _vm.toggleMenu()}}},[_vm._v("\n      "+_vm._s(_vm.selectedOption.name)+"\n      "),_c('span',{staticClass:"caret"})]):_vm._e(),_vm._v(" "),(_vm.selectedOption.name === undefined)?_c('li',{staticClass:"dropdown-toggle",on:{"click":function($event){return _vm.toggleMenu()}}},[_vm._v("\n      "+_vm._s(_vm.placeholderText)+"\n      "),_c('span',{staticClass:"caret"})]):_vm._e(),_vm._v(" "),(_vm.showMenu)?_c('ul',{staticClass:"dropdown-menu"},_vm._l((_vm.options),function(option){return _c('li',{key:option.name},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.updateOption(option)}}},[_vm._v("\n                "+_vm._s(option.name)+"\n            ")])])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YO3H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bets',
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.refreshBets();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      gotInitialBets: 0,
      description: {
        title: 'Bets',
        text: 'When a bet is open It will be displayed here, If you want to place a bet just click on the bet and enter an amount then choose an option and click "Place Bet", Subscribers can bet on half of the options, non-subscribers can only bet on a single option. If you want to bet in chat, type your choice followed by the amount to bet. For example, Win 1000. Type !info to see your point balance, you get more for watching'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['bets', 'currentBetIds']), {}),
  watch: {
    currentBetIds: function currentBetIds() {
      this.gotInitialBets += 1;
    }
  },
  methods: {
    refreshBets: function refreshBets() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$store.dispatch('fetchCurrentBets');

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ "YTl1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.$route.fullPath,staticClass:"hello"},[_c('header-title',{attrs:{"title":"DONATE"}}),_vm._v(" "),(_vm.user)?_c('div',{staticStyle:{"margin":"40px"}},[_c('div',[_c('User',{attrs:{"user_id":_vm.forUserId}}),_vm._v(" "),_c('br'),_c('br')],1),_vm._v(" "),(_vm.processing)?_c('div',[_vm._v("\n      Processing..."),_c('br'),_c('br'),_vm._v(" "),_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"cspin",attrs:{"cx":"50","cy":"50","r":"45"}})])]):_c('div',[(_vm.tsxError)?_c('div',[_vm._v("Sorry, there was an error with your order."),_c('br'),_c('br'),_vm._v(_vm._s(_vm.tsxError))]):(_vm.tsxSuccess)?_c('div',[_vm._v("\n        Thanks for donating!"),_c('br'),_c('br'),_vm._v(" "),(_vm.donation)?_c('table',{staticStyle:{"margin-left":"auto","margin-right":"auto"},attrs:{"border":"1"}},[_c('tr',[_c('td',[_vm._v("Order ID")]),_c('td',[_vm._v(_vm._s(_vm.donation.order_id))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Amount")]),_c('td',[_vm._v("$"+_vm._s(_vm.donation.amount))])])]):_vm._e()]):_c('div',[_c('div',{staticClass:"package-select",staticStyle:{"display":"none"}},[_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPackage),expression:"selectedPackage"}],attrs:{"type":"radio","id":"pkg0","value":"0"},domProps:{"checked":_vm._q(_vm.selectedPackage,"0")},on:{"change":function($event){_vm.selectedPackage="0"}}}),_vm._v(" "),_c('br'),_c('label',{class:{'btn-enabled':true, 'btn-top':true, 'btn-selected':_vm.selectedPackage === '0'},attrs:{"for":"pkg0"}},[_vm._v("Save Token")])]),_vm._v(" "),_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPackage),expression:"selectedPackage"}],attrs:{"type":"radio","id":"pkg1","value":"1"},domProps:{"checked":_vm._q(_vm.selectedPackage,"1")},on:{"change":function($event){_vm.selectedPackage="1"}}}),_vm._v(" "),_c('br'),_c('label',{class:{'btn-enabled':true, 'btn-top':true, 'btn-selected':_vm.selectedPackage === '1'},attrs:{"for":"pkg1"}},[_vm._v("Kill Token")])]),_vm._v(" "),_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPackage),expression:"selectedPackage"}],attrs:{"type":"radio","id":"pkg2","value":"2"},domProps:{"checked":_vm._q(_vm.selectedPackage,"2")},on:{"change":function($event){_vm.selectedPackage="2"}}}),_vm._v(" "),_c('br'),_c('label',{class:{'btn-enabled':true, 'btn-top':true, 'btn-selected':_vm.selectedPackage === '2'},attrs:{"for":"pkg2"}},[_vm._v("Donate")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"font-size":"30px","font-weight":"bold"}},[_vm._v("Donate $"+_vm._s(_vm.cost)+"!")]),_vm._v(" "),(_vm.hasMessage)?_c('span',[_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"messagetext",attrs:{"placeholder":"Your Message Here!"},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"auto","margin-right":"auto","margin-top":"10px"}},[_c('vue-slider',{attrs:{"min":1,"max":_vm.sliderMax,"interval":_vm.interval,"adsorb":true},model:{value:(_vm.quantity),callback:function ($$v) {_vm.quantity=$$v},expression:"quantity"}}),_c('br'),_vm._v(" "),_vm._l((_vm.buttonAmounts),function(buttonQuantity){return _c('span',{key:buttonQuantity},[_c('button-a',{staticStyle:{"font-size":"40px","padding":"8px"},attrs:{"selected":buttonQuantity === _vm.quantity},on:{"clicked":function($event){return _vm.changeQuantity(buttonQuantity)}}},[_vm._v(_vm._s(_vm.buttonLabel(buttonQuantity)))])],1)}),_vm._v(" "),_c('span',[(!_vm.currentUser)?_c('login-btn',{staticStyle:{"font-size":"40px","padding":"8px"},attrs:{"buttonClass":"btn-enabled"}},[_vm._v("Login for more options!")]):_vm._e()],1)],2),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"paypal-button-container"}})])])]):_c('div',[(_vm.currentUser)?_c('span',[_vm._v("Unknown User"),_c('br'),_vm._v("Were you trying to donate to someone else?"),_c('br'),_c('br'),_c('h1',[_vm._v("If you want to donate on behalf of yourself "),_c('router-link',{attrs:{"to":"/donate"}},[_vm._v("CLICK HERE")])],1)]):_c('span',[_c('login-btn',{staticStyle:{"font-size":"40px","padding":"8px"},attrs:{"buttonClass":"btn-enabled"}},[_vm._v("Login to donate!")])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"font-size":"20px","font-weight":"bold"}},[_vm._v("Thanks for considering a donation to the Bald man - any donation below $5 up will pop your message up on the screen when he’s live! You can buy Gold for Sellout games HERE")]),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__("qSdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Bets__ = __webpack_require__("0qWZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Ticket_Raffles__ = __webpack_require__("KRtu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Leaderboard__ = __webpack_require__("Fvhm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bounties__ = __webpack_require__("u4nE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Donate__ = __webpack_require__("Sur4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Gold__ = __webpack_require__("Kw4S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Rooms__ = __webpack_require__("hNhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Room_Browser__ = __webpack_require__("4Q3t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Loot_Shop__ = __webpack_require__("aVr6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Equipped_Items__ = __webpack_require__("T053");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Legal__ = __webpack_require__("QUrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Room_Item_Management__ = __webpack_require__("+lkC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Room_Item_Editor__ = __webpack_require__("U/mA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Loot_Box_Editor__ = __webpack_require__("Q1NU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Loot_Box_Management__ = __webpack_require__("1zaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Admin_Push_Notifications__ = __webpack_require__("rSgh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Rates__ = __webpack_require__("fKYD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Settings__ = __webpack_require__("niH5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Support__ = __webpack_require__("d9Q/");
























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Home__["a" /* default */]
  }, {
    path: '/leaderboard',
    name: 'Leaderboard',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Leaderboard__["a" /* default */]
  }, {
    path: '/bets',
    name: 'Bets',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Bets__["a" /* default */]
  }, {
    path: '/hello',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
  }, {
    path: '/ticket-raffles',
    name: 'TicketRaffles',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Ticket_Raffles__["a" /* default */]
  }, {
    path: '/bounties',
    name: 'Bounties',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Bounties__["a" /* default */]
  }, {
    path: '/donate/:user_id',
    name: 'Donate',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_8__components_Donate__["a" /* default */]
  }, {
    path: '/donate',
    name: 'DonateSelf',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Donate__["a" /* default */]
  }, {
    path: '/gold/:user_id',
    name: 'Gold',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_9__components_Gold__["a" /* default */]
  }, {
    path: '/gold',
    name: 'GoldSelf',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Gold__["a" /* default */]
  }, {
    path: '/rooms/:twitch_name',
    name: 'Rooms',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_10__components_Rooms__["a" /* default */]
  }, {
    path: '/rooms',
    name: 'RoomsSelf',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Rooms__["a" /* default */]
  }, {
    path: '/room-browser',
    name: 'RoomBrowser',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Room_Browser__["a" /* default */]
  }, {
    path: '/loot-shop',
    name: 'LootShop',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Loot_Shop__["a" /* default */]
  }, {
    path: '/equipped-items',
    name: 'EquippedItems',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Equipped_Items__["a" /* default */]
  }, {
    path: '/room-item-management',
    name: 'RoomItemManagement',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Room_Item_Management__["a" /* default */]
  }, {
    path: '/loot-box-management',
    name: 'LootBoxManagement',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Loot_Box_Management__["a" /* default */]
  }, {
    path: '/room-item-editor/:itemId',
    name: 'RoomItemEditor',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_16__components_Room_Item_Editor__["a" /* default */]
  }, {
    path: '/room-item-editor',
    name: 'RoomItemEditorCreate',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Room_Item_Editor__["a" /* default */]
  }, {
    path: '/loot-box-editor/:itemId',
    name: 'LootBoxEditor',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_17__components_Loot_Box_Editor__["a" /* default */]
  }, {
    path: '/loot-box-editor',
    name: 'LootBoxEditorCreate',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Loot_Box_Editor__["a" /* default */]
  }, {
    path: '/admin-push-notifications',
    name: 'AdminPushNotifications',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Admin_Push_Notifications__["a" /* default */]
  }, {
    path: '/legal',
    name: 'Legal',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Legal__["a" /* default */]
  }, {
    path: '/rates',
    name: 'Rates',
    component: __WEBPACK_IMPORTED_MODULE_20__components_Rates__["a" /* default */]
  }, {
    path: '/settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Settings__["a" /* default */],
    props: function props(route) {
      return { message: route.query.message };
    }
  }, {
    path: '/support',
    name: 'Support',
    component: __WEBPACK_IMPORTED_MODULE_22__components_Support__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Ykvt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YnHO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapState } from 'vuex'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'placed-bets',
  props: ['bet_id', 'placed_bets', 'size'],
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      wat: []
    };
  },

  computed: {
    cssClasses: function cssClasses() {
      var classes = ['table-responsive-vertical', 'shadow-z-1'];
      if (this.size === 'mini') {
        classes.unshift('table-mini');
      }
      return classes.join(' ');
    }
    // placedBets () {
    //   // console.log('STORE', this.$store.state.placedBets)
    //   return (this.$store.state.placedBets[this.bet_id] || []).concat(this.wat)
    // }

  },
  methods: {
    refreshPlacedBets: function refreshPlacedBets() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch('fetchPlacedBets', _this2.bet_id);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ "YpvZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_Avatar_vue__ = __webpack_require__("+Fs2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44dc3f3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_Avatar_vue__ = __webpack_require__("3xjD");
function injectStyle (ssrContext) {
  __webpack_require__("/zlS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44dc3f3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_Avatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44dc3f3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_Avatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZDgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.$route.fullPath,staticClass:"room-hello"},[_c('header-title',{attrs:{"title":"MY ROOM"}}),_vm._v(" "),(_vm.user)?_c('div',[_vm._v("\n    "+_vm._s(_vm.user.twitch_name)+"'s Room "),_c('button',{staticClass:"btn-copy",on:{"click":_vm.copyToClipboard}},[_vm._v("Copy Share Link")]),_vm._v(" "),_c('div',{staticClass:"upper-right-area"},[(_vm.editable)?_c('button',{staticClass:"btn-save",on:{"click":_vm.saveRoom}},[_vm._v("SAVE")]):_vm._e(),_vm._v(" "),(_vm.editable && _vm.isMobileBrowser)?_c('div',[_vm._v("Mobile ALPHA CONTROLS: Double tap an item to select it. Tap-drag to edit.")]):_vm._e()]),_vm._v(" "),(_vm.notification)?_c('span',[_vm._v("- "+_vm._s(_vm.notification))]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"room-container"}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"10px"}},[_vm._v("ROOMS are beta, there will be bugs! Press spacebar to change modes. Edit mode - Use mouse to click and orbit, mousewheel to zoom. FPS mode - Use most to click and look, wsad to move.")]),_vm._v(" "),(this.showBrowser)?_c('div',[_vm._v("Your Inventory")]):_vm._e(),_vm._v(" "),(this.showBrowser)?_c('InventoryBrowser',{scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var lootItem = ref.lootItem;
var ownedLootItem = ref.ownedLootItem;
return [(_vm.isRoomItem(lootItem))?_c('span',[(_vm.canPlaceInRoom(lootItem.id, ownedLootItem))?_c('button',{staticClass:"btn-save",staticStyle:{"font-size":"12px"},on:{"click":function($event){return _vm.addToRoom(ownedLootItem, lootItem)}}},[_vm._v("ADD TO ROOM")]):_vm._e(),_vm._v(" "),(_vm.numberInRoom(lootItem.id) > 0)?_c('button',{staticClass:"btn-save",staticStyle:{"font-size":"12px"},on:{"click":function($event){return _vm.removeFromRoom(ownedLootItem, lootItem)}}},[_vm._v("REMOVE FROM ROOM")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isWallBaseItem(lootItem))?_c('span',[_c('button',{class:_vm.isWallBaseItem(lootItem, 'back') ? 'wall-base-add' : 'wall-base-remove',staticStyle:{"font-size":"12px"},on:{"click":function($event){return _vm.setWallBase('back', ownedLootItem, lootItem)}}},[_vm._v("B")]),_vm._v(" "),_c('button',{class:_vm.isWallBaseItem(lootItem, 'front') ? 'wall-base-add' : 'wall-base-remove',staticStyle:{"font-size":"12px"},on:{"click":function($event){return _vm.setWallBase('front', ownedLootItem, lootItem)}}},[_vm._v("F")]),_vm._v(" "),_c('button',{class:_vm.isWallBaseItem(lootItem, 'left') ? 'wall-base-add' : 'wall-base-remove',staticStyle:{"font-size":"12px"},on:{"click":function($event){return _vm.setWallBase('left', ownedLootItem, lootItem)}}},[_vm._v("L")]),_vm._v(" "),_c('button',{class:_vm.isWallBaseItem(lootItem, 'right') ? 'wall-base-add' : 'wall-base-remove',staticStyle:{"font-size":"12px"},on:{"click":function($event){return _vm.setWallBase('right', ownedLootItem, lootItem)}}},[_vm._v("R")])]):_vm._e(),_vm._v(" "),(_vm.isFloorBaseItem(lootItem))?_c('span',[(_vm.isCurrentFloorBaseItem(lootItem))?_c('button',{staticClass:"wall-base-remove",staticStyle:{"width":"80%","font-size":"12px"},on:{"click":function($event){return _vm.setFloorBase(ownedLootItem, lootItem)}}},[_vm._v("REMOVE FLOOR")]):_c('button',{staticClass:"wall-base-add",staticStyle:{"width":"80%","font-size":"12px"},on:{"click":function($event){return _vm.setFloorBase(ownedLootItem, lootItem)}}},[_vm._v("SET FLOOR")])]):_vm._e()]}},{key:"numberInRoom",fn:function(ref){
var lootItem = ref.lootItem;
return [_vm._v("\n        "+_vm._s(_vm.numberInRoom(lootItem.id))+"\n      ")]}}],null,false,1223306136)}):_vm._e()],1):(_vm.noCurrentUser)?_c('div',[_c('login-btn',{staticStyle:{"font-size":"40px","padding":"8px"},attrs:{"buttonClass":"btn-enabled"}},[_vm._v("Login to edit your room!")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aKwC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);




//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'debug',
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {};
  },

  methods: {
    debugNewTicketRaffle: function debugNewTicketRaffle() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$store.commit('newTicketRaffle', {
                  created_at: Date.now(),
                  updated_at: Date.now(),
                  id: Math.random() * 100,
                  keyword: Math.floor(Math.random() * 100),
                  price: Math.floor(Math.random() * 100)
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    debugNewTicketRaffleEntry: function debugNewTicketRaffleEntry() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var tr, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, b;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tr = void 0;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 4;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this3.$store.state.currentTicketRaffleIds);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 14;
                  break;
                }

                b = _step.value;

                if (!_this3.$store.state.ticketRaffles[b]) {
                  _context3.next = 11;
                  break;
                }

                tr = _this3.$store.state.ticketRaffles[b];
                return _context3.abrupt('break', 14);

              case 11:
                _iteratorNormalCompletion = true;
                _context3.next = 6;
                break;

              case 14:
                _context3.next = 20;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 20:
                _context3.prev = 20;
                _context3.prev = 21;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 23:
                _context3.prev = 23;

                if (!_didIteratorError) {
                  _context3.next = 26;
                  break;
                }

                throw _iteratorError;

              case 26:
                return _context3.finish(23);

              case 27:
                return _context3.finish(20);

              case 28:

                if (tr) {
                  if (_this3.$store.state.users.length === 0) {}

                  // console.log('u', this.$store.state.users)
                  // console.log('u2', Object.keys(this.$store.state.users)[0])

                  _this3.$store.commit('newTicketRaffleEntry', {
                    quantity: Math.floor(Math.random() * 10),
                    user_id: _this3.$store.state.users[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this3.$store.state.users)[0]].id,
                    ticket_raffle_id: tr.id
                  });
                }

              case 29:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[4, 16, 20, 28], [21,, 23, 27]]);
      }))();
    },
    debugNewPlacedBet: function debugNewPlacedBet() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var bet, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, b;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                bet = void 0;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context4.prev = 4;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this4.$store.state.currentBetIds);

              case 6:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context4.next = 14;
                  break;
                }

                b = _step2.value;

                if (!_this4.$store.state.bets[b]) {
                  _context4.next = 11;
                  break;
                }

                bet = _this4.$store.state.bets[b];
                return _context4.abrupt('break', 14);

              case 11:
                _iteratorNormalCompletion2 = true;
                _context4.next = 6;
                break;

              case 14:
                _context4.next = 20;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4['catch'](4);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t0;

              case 20:
                _context4.prev = 20;
                _context4.prev = 21;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 23:
                _context4.prev = 23;

                if (!_didIteratorError2) {
                  _context4.next = 26;
                  break;
                }

                throw _iteratorError2;

              case 26:
                return _context4.finish(23);

              case 27:
                return _context4.finish(20);

              case 28:

                if (bet) {
                  if (_this4.$store.state.users.length === 0) {}

                  // console.log('u', this.$store.state.users)
                  // console.log('u2', Object.keys(this.$store.state.users)[0])

                  _this4.$store.commit('newPlacedBet', { bet: bet, bet_option: {}, placed_bet: { option: 0, amount: Math.floor(Math.random() * 10), user_id: _this4.$store.state.users[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this4.$store.state.users)[0]].id } });
                }

              case 29:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[4, 16, 20, 28], [21,, 23, 27]]);
      }))();
    },
    debugNewBet: function debugNewBet() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.$store.commit('newBet', {
                  id: '' + Math.random(),
                  status: 1,
                  created_at: __WEBPACK_IMPORTED_MODULE_4_moment___default()(),
                  options: [['a', 1], ['b', 1]],
                  bet_options: [{
                    option_number: 0,
                    name: 'a',
                    total: 0
                  }, {
                    option_number: 1,
                    name: 'b',
                    total: 0
                  }]
                });

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  }
});

/***/ }),

/***/ "aOAS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aRfN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aVr6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loot_Shop_vue__ = __webpack_require__("8Rkw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf42be22_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loot_Shop_vue__ = __webpack_require__("o1B/");
function injectStyle (ssrContext) {
  __webpack_require__("y7Ye")
  __webpack_require__("aRfN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf42be22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loot_Shop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf42be22_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loot_Shop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "atEt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,on:{"click":_vm.loginRedirect}},[_c('img',{staticClass:"login-img",attrs:{"src":__webpack_require__("Gh/C")}}),_vm._v(" "),_c('span',{staticClass:"login-text"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b/nM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"site-header",attrs:{"id":"nav-bar"}},[_c('div',{staticClass:"site-header__inner"},[_c('a',{staticClass:"brand",on:{"click":function($event){return _vm.navigate('/')}}},[_vm._v("SWIFTORLAND")]),_vm._v(" "),_c('nav',{staticClass:"nav"},[_vm._l((_vm.primary),function(item){return _c('a',{key:item.path,staticClass:"nav__link",class:{ 'is-active': _vm.isActive(item), 'is-gold': item.gold },on:{"click":function($event){return _vm.navigate(item.path)}}},[_vm._v("\n        "+_vm._s(item.label)+"\n        "),_c('span',{staticClass:"nav__underline"})])}),_vm._v(" "),_c('div',{staticClass:"nav__more"},[_c('a',{staticClass:"nav__link",class:{ 'is-active': _vm.moreOpen || _vm.moreIsActive },on:{"click":function($event){$event.stopPropagation();return _vm.toggleMore($event)}}},[_vm._v("\n          More"),_c('span',{staticClass:"nav__caret"},[_vm._v("▾")]),_vm._v(" "),_c('span',{staticClass:"nav__underline"})]),_vm._v(" "),(_vm.moreOpen)?_c('div',{staticClass:"menu",on:{"click":function($event){$event.stopPropagation();}}},_vm._l((_vm.more),function(item){return _c('a',{key:item.path,staticClass:"menu__link",class:{ 'is-active': _vm.isActive(item) },on:{"click":function($event){return _vm.navigate(item.path)}}},[_vm._v(_vm._s(item.label))])}),0):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"site-header__account"},[_c('login-status')],1)]),_vm._v(" "),_c('div',{staticClass:"site-header__rule"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b03K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login-btn',
  props: {
    buttonClass: {
      type: String,
      default: 'login-btn'
    },
    buttonSelectedClass: {
      type: String,
      default: 'login-btn-selected'
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    loginUrl: function loginUrl() {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.CURRENCY_SERVICE_ROOT_BASE_URL + '/auth/login?path=' + encodeURIComponent(this.$route.path);
    },
    classes: function classes() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.buttonClass, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.buttonSelectedClass, this.selected), _ref;
    }
  },
  methods: {
    loginRedirect: function loginRedirect() {
      window.location = this.loginUrl;
    }
  }
});

/***/ }),

/***/ "bVt0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bcmc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('info-box',{attrs:{"description":_vm.description}}),_vm._v(" "),_c('slider')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c/th":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"info-box"}},[_c('div',{staticClass:"info-container"},[(!_vm.expanded)?_c('div',{staticClass:"info-i",on:{"click":_vm.toggleExpand}},[_vm._v("\n            i\n        ")]):_c('div',[_c('div',{staticClass:"info-x",on:{"click":_vm.toggleExpand}},[_vm._v("\n                ✖\n            ")]),_vm._v(" "),_c('p',{staticClass:"info-title"},[_vm._v("\n                "+_vm._s(_vm.description.title)+"\n            ")]),_vm._v(" "),_c('p',{staticClass:"info-text"},[_vm._v("\n                "+_vm._s(_vm.description.text)+"\n            ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "crjj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Discord_Btn_vue__ = __webpack_require__("iUXO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7ad3fb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Discord_Btn_vue__ = __webpack_require__("634k");
function injectStyle (ssrContext) {
  __webpack_require__("EGFv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a7ad3fb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Discord_Btn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7ad3fb2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Discord_Btn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cvwv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d9Q/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Support_vue__ = __webpack_require__("pgF/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f074bf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Support_vue__ = __webpack_require__("wmGc");
function injectStyle (ssrContext) {
  __webpack_require__("iTOo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f074bf8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Support_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f074bf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Support_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dBxG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'legal',
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  methods: {
    goto: function goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    }
  }
});

/***/ }),

/***/ "dM8B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Bounty__ = __webpack_require__("DKCg");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bounties',
  components: {
    Bounty: __WEBPACK_IMPORTED_MODULE_4__Bounty__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.refreshSubBounties();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      description: {
        title: 'Bounties',
        text: 'You want to get some SwiftBucks, Gift a sub to one of the accounts displayed below and win the bounty, Not subbed? Add SwiftBucks to your bounty by typing !add followed by the amount in chat, if someone gift subs you, they get em'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['subBounties']), {
    tiers: function tiers() {
      return [{
        level: 3,
        name: 'TIER 3',
        badge: 'Prestige',
        variant: 'gold',
        btn: 'Gift Tier 3 Sub',
        rows: this.subBounties.sub_bounties_t3 || []
      }, {
        level: 2,
        name: 'TIER 2',
        badge: 'Elite',
        variant: 'purple',
        btn: 'Gift Tier 2 Sub',
        rows: this.subBounties.sub_bounties_t2 || []
      }, {
        level: 1,
        name: 'TIER 1',
        badge: 'Open',
        variant: 'plain',
        btn: 'Gift Sub',
        rows: this.subBounties.sub_bounties_t1 || []
      }].filter(function (tier) {
        return tier.rows.length > 0;
      });
    }
  }),
  methods: {
    refreshSubBounties: function refreshSubBounties() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$store.dispatch('fetchSubBounties', { channelId: '274625', tier: 1 });
                _this2.$store.dispatch('fetchSubBounties', { channelId: '274625', tier: 2 });
                _this2.$store.dispatch('fetchSubBounties', { channelId: '274625', tier: 3 });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ "dPtJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__User__ = __webpack_require__("jyJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component__ = __webpack_require__("lCKi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slider_component_theme_antd_css__ = __webpack_require__("KgMc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slider_component_theme_antd_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_slider_component_theme_antd_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var scriptLoaded = false;
var scriptFinished = false;

var packages = [
// {
//   name: 'Save Token',
//   denomination: 'Save Tokens',
//   quantityButtons: [1, 2, 3, 4, 5, 7, 10, 15, 20, 30, 40, 50],
//   interval: 1,
//   authThreshold: 10,
//   maxQuantity: 10,
//   authMaxQuantity: 50,
//   cost: (qty) => {
//     return qty * 10
//   },
//   sku: 'SAVETOKEN'
// },
// {
//   name: 'Kill Token',
//   denomination: 'Kill Tokens',
//   quantityButtons: [1, 2, 3, 4, 5, 6, 7, 8],
//   interval: 1,
//   authThreshold: 2,
//   cost: (qty) => {
//     return (qty * 66).toFixed(2)
//   },
//   maxQuantity: 2,
//   authMaxQuantity: 8,
//   sku: 'KILLTOKEN'
// },
{
  name: 'Donation',
  denomination: 'bars',
  quantityButtons: [1, 2, 4, 7, 10, 15, 20, 30, 40, 60, 80, 100],
  interval: 1,
  authThreshold: 20,
  cost: function cost(qty) {
    return qty * 5;
  },
  sku: 'DONATE',
  hasMessage: true
}];

/* global paypal */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'donate',
  props: ['user_id'],
  components: {
    VueSlider: __WEBPACK_IMPORTED_MODULE_4_vue_slider_component___default.a,
    User: __WEBPACK_IMPORTED_MODULE_3__User__["a" /* default */]
  },
  data: function data() {
    return {
      displayAmount: 5,
      tsxSuccess: false,
      tsxError: undefined,
      processing: false,
      donation: {},
      baseButtonAmounts: [5, 10, 25, 50, 66, 75, 100],
      additionalButtonAmounts: [150, 200, 300, 400, 500],
      paypalDisplayed: false,
      message: '',
      quantity: 1,
      selectedPackage: '0'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])(['currentUser']), {
    // amount () {
    //   return this.convertToMoney(this.displayAmount)
    // },
    buttonAmounts: function buttonAmounts() {
      var _this = this;

      if (this.currentUser) {
        return this.package.quantityButtons;
      } else {
        return this.package.quantityButtons.filter(function (b) {
          return b <= _this.authThreshold;
        });
      }
    },
    sliderMax: function sliderMax() {
      return this.currentUser ? this.authMaxQuantity : this.maxQuantity;
    },
    user: function user() {
      if (this.user_id) {
        return this.$store.state.users[this.user_id.toLowerCase()];
      } else {
        return this.currentUser;
      }
    },
    forUserId: function forUserId() {
      if (this.user_id) {
        return this.user_id;
      } else {
        return this.currentUser ? this.currentUser.id : undefined;
      }
      // return this.user_id ? this.user_id.toLowerCase() : this.currentUser.id
    },
    cost: function cost() {
      // return Math.round(parseInt(this.amount) / 5)
      return this.package.cost(this.quantity);
    },
    package: function _package() {
      return packages[parseInt(this.selectedPackage)];
    },
    name: function name() {
      return this.package.name;
    },
    denomination: function denomination() {
      return this.package.denomination;
    },
    authThreshold: function authThreshold() {
      return this.package.authThreshold;
    },
    interval: function interval() {
      return this.package.interval || 1;
    },
    authMaxQuantity: function authMaxQuantity() {
      return this.package.authMaxQuantity || 100;
    },
    maxQuantity: function maxQuantity() {
      return this.package.maxQuantity || 20;
    },
    sku: function sku() {
      return this.package.sku;
    },
    hasMessage: function hasMessage() {
      return this.package.hasMessage || false;
    }
  }),
  watch: {
    user: function user() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6_vue__["default"].nextTick();

              case 2:
                _this2.displayPaypal();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    '$route.path': function $routePath(to, from) {},
    selectedPackage: function selectedPackage() {
      this.quantity = 1;
    }
  },
  updated: function updated() {
    this.displayPaypal();
  },
  destroyed: function destroyed() {},
  mounted: function mounted() {
    if (this.user) {
      this.displayPaypal();
    }
  },

  created: function created() {
    var _this3 = this;

    if (!scriptLoaded) {
      this.$store.dispatch('fetchUser', this.user_id);
      var paypalScript = document.createElement('script');
      paypalScript.setAttribute('src', 'https://www.paypal.com/sdk/js?client-id=' + __WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.PAYPAL_CLIENT_ID + '&disable-funding=credit');
      document.head.appendChild(paypalScript);

      paypalScript.onload = function () {
        scriptFinished = true;

        _this3.displayPaypal();
      };

      scriptLoaded = paypalScript;
    }

    this.paypalScript = scriptLoaded;
  },
  methods: {
    buttonLabel: function buttonLabel(qty) {
      // return `${qty} for $${this.costFor(qty)}`
      return '$' + this.costFor(qty);
    },
    costFor: function costFor(qty) {
      return this.package.cost(qty);
    },
    convertToMoney: function convertToMoney(amt) {
      return amt.toString().includes('.') ? amt : amt + '.00';
    },
    displayPaypal: function displayPaypal() {
      var _this4 = this;

      if (!this.user || !scriptFinished || this.paypalDisplayed || !this.paypalScript) {
        return;
      } else {
        this.paypalDisplayed = true;
      }

      paypal.Buttons({
        createOrder: function createOrder(data, actions) {
          return actions.order.create({
            application_context: { shipping_preference: 'NO_SHIPPING' },
            purchase_units: [{
              reference_id: _this4.sku + '_' + _this4.forUserId,
              amount: {
                value: '' + _this4.cost
              }
            }]
          });
        },
        onApprove: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(data, actions) {
            var result, sku;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _this4.processing = true;
                    _context2.next = 3;
                    return _this4.$store.dispatch('captureDonation', { orderId: data.orderID, message: _this4.message });

                  case 3:
                    result = _context2.sent;

                    _this4.processing = false;
                    if (!result || result.error) {
                      _this4.tsxError = result.error.data ? result.error.data : result.error;
                    } else {
                      _this4.tsxSuccess = true;
                      _this4.donation = result.donation;

                      sku = 'UNKNOWN';

                      if (_this4.donation.reference_id) {
                        sku = _this4.donation.reference_id.split('_')[0];
                      }
                      _this4.$gtag.query('event', 'purchase', {
                        'transaction_id': _this4.donation.order_id,
                        'affiliation': 'Donation Page',
                        'value': parseFloat(_this4.donation.amount),
                        'currency': 'USD',
                        'items': [{
                          'item_id': sku,
                          'item_name': sku
                        }]
                      });
                    }

                  case 6:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this4);
          }));

          return function onApprove(_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }()
      }).render('#paypal-button-container');
    },
    changeQuantity: function changeQuantity(qty) {
      this.quantity = qty;
    }
  }
});

/***/ }),

/***/ "dk+Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_a_vue__ = __webpack_require__("wW7H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2adfe006_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_a_vue__ = __webpack_require__("Ku67");
function injectStyle (ssrContext) {
  __webpack_require__("WFG9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_button_a_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2adfe006_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_button_a_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e8mT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Slider_Conrol__ = __webpack_require__("wo/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pers: 0,
      ticket_amount: '',
      valid_amount: false,
      button_value: 'Buy Tickets'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['currentBalance', 'callFree'])),
  props: ['price', 'myTickets'],
  components: {
    sliderConrol: __WEBPACK_IMPORTED_MODULE_1__Slider_Conrol__["a" /* default */]
  },
  methods: {
    persChange: function persChange(val) {
      this.ticket_amount = Math.floor(this.currentBalance.total / this.price * (val / 100));
    },
    amountChanged: function amountChanged(evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    callBuyTicket: function callBuyTicket() {
      this.$emit('callBuyTicket', this.ticket_amount);
    },
    valueUp: function valueUp() {
      var valDigits = this.ticket_amount.toString().length;
      this.ticket_amount = parseFloat(this.ticket_amount) + Math.pow(10, valDigits - 1);
    },
    valueDown: function valueDown() {
      var valDigits = this.ticket_amount.toString().length;
      this.ticket_amount = parseFloat(this.ticket_amount) - Math.pow(10, valDigits - 1);
    }
  },
  watch: {
    ticket_amount: function ticket_amount(val) {
      val = parseFloat(val);
      if (val > parseFloat(this.currentBalance.total) / this.price) {
        this.persChange(100);
        this.pers = 100;
      } else {
        this.pers = Math.floor(val / (parseFloat(this.currentBalance.total) / this.price) * 100);
      }
      this.valid_amount = true;
      if (val < 1) {
        this.persChange(0);
        this.valid_amount = false;
      }
    },
    callFree: function callFree() {
      if (this.callFree) {
        this.button_value = 'Buy Tickets';
        document.getElementsByClassName('balance-row')[0].classList.add('pulse');
      } else {
        document.getElementsByClassName('balance-row')[0].className = 'balance-row';
        this.button_value = 'Processing';
      }
    }
  },
  created: function created() {
    this.ticket_amount = Math.floor(parseFloat(this.currentBalance.total) / this.price / 10);
  }
});

/***/ }),

/***/ "eD3p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ej5g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Info_Box_vue__ = __webpack_require__("NtJT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10320477_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Info_Box_vue__ = __webpack_require__("c/th");
function injectStyle (ssrContext) {
  __webpack_require__("bVt0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10320477"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Info_Box_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10320477_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Info_Box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fKYD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rates_vue__ = __webpack_require__("5YNp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b6cf81e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rates_vue__ = __webpack_require__("zuBa");
function injectStyle (ssrContext) {
  __webpack_require__("CKJ1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b6cf81e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b6cf81e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rates_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fVht":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticStyle:{"width":"100%"}},[_c('td',{staticStyle:{"width":"10%"},on:{"click":_vm.hideRaffle}}),_vm._v(" "),_c('td',{staticClass:"ticket-raffle-table",staticStyle:{"width":"80%"},on:{"click":function($event){return _vm.showRaffle()}}},[_c('table',{staticStyle:{"width":"100%"},attrs:{"align":"center"}},[_c('tr',[_c('td',{class:'stat-bar-'+_vm.ticketRaffleStatus}),_vm._v(" "),_c('td',[_c('table',{staticStyle:{"width":"100%"}},[_c('tr',[_c('td',{staticClass:"ticket-raffle-keyword",attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.ticketRaffle.keyword))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"ticket-raffle-info"},[_vm._v("Status: "+_vm._s(_vm.ticketRaffleStatus))]),_vm._v(" "),_c('td',{staticClass:"ticket-raffle-info",staticStyle:{"text-align":"center"}},[_vm._v("Your Tickets: "+_vm._s(_vm.formatCurrency(_vm.myTickets)))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"ticket-raffle-info"},[_vm._v("Price per ticket: "+_vm._s(_vm.formatCurrency(_vm.ticketRaffle.price)))]),_vm._v(" "),_c('td',{staticClass:"ticket-raffle-info",staticStyle:{"text-align":"center"}},[_vm._v("Total Entries: "+_vm._s(_vm.formatCurrency(_vm.ticketRaffle.total_entries)))])])])]),_vm._v(" "),_c('td',{class:'stat-bar-'+_vm.ticketRaffleStatus})])]),_vm._v(" "),(_vm.showPlaced)?_c('div',{staticClass:"ticket-raffle-expand"},[_c('br'),_vm._v(" "),_c('a',[_vm._v(_vm._s(_vm.ticketRaffle.title))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$store.state.currentUser&&_vm.ticketRaffleStatus=='Open')?_c('buyTicket',{attrs:{"price":_vm.ticketRaffle.price,"myTickets":_vm.formatCurrency(_vm.myTickets)},on:{"callBuyTicket":_vm.callBuyTicket}}):_vm._e(),_vm._v(" "),(!_vm.$store.state.currentUser&&_vm.ticketRaffleStatus=='Open')?_c('login-btn',{staticStyle:{"display":"inline-block"}},[_vm._v("Login to buy tickets")]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',[_c('br'),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"bold"}},[_vm._v("Entries")]),_vm._v(" "),(_vm.showPlaced)?_c('ticket-raffle-entries',{attrs:{"ticketRaffleId":_vm.ticketRaffleId,"ticketRaffle":_vm.ticketRaffle}}):_vm._e()],1)])],1):_vm._e()]),_vm._v(" "),_c('td',{staticStyle:{"width":"10%"},on:{"click":_vm.hideRaffle}})]),_vm._v(" "),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fivR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fy0G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gss/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Place_Bet__ = __webpack_require__("1L9+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bet',
  props: ['betId'],
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.dispatch('fetchBet', _this.betId);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  components: {
    placeBet: __WEBPACK_IMPORTED_MODULE_2__Place_Bet__["a" /* default */]
  },
  data: function data() {
    return {
      showPlaced: false,
      placedFetched: false
    };
  },

  computed: {
    bet: function bet() {
      return this.$store.state.bets[this.betId];
    },
    placedBets: function placedBets() {
      // console.log('STORE', this.$store.state.placedBets)
      return this.$store.state.placedBets[this.betId] || [];
    },
    myBets: function myBets() {
      // console.log('STORE', this.$store.state.placedBets)
      return this.$store.state.myBets[this.betId] || [];
    },
    betStatus: function betStatus() {
      /*
        'created': 1,
        'completed': 2,
        'pending': 3,
        'canceled': 4
      */
      if (this.bet.status === 2) {
        return 'Completed';
      } else if (this.bet.status === 4) {
        return 'Canceled';
      } else if (this.bet.status === 5) {
        return 'Closed';
      } else {
        return 'Open';
      }
    }
  },
  methods: {
    showBet: function showBet() {
      if (!this.placedFetched && !this.showPlaced) {
        this.$store.dispatch('fetchPlacedBets', this.betId);
        this.showPlaced = true;
      }
    },
    hideBet: function hideBet() {
      this.showPlaced = false;
    },
    callPlaceBet: function callPlaceBet(amount, option) {
      var betIdx = this.betId;
      this.$store.dispatch('placeBet', { amount: amount, betIdx: betIdx, option: option });
    },
    getLocalDate: function getLocalDate(datex) {
      var localDate = new Date(datex.toString());
      return localDate.getHours() + ':' + localDate.getMinutes() + ':' + (localDate.getSeconds().toString().length === 1 ? '0' + localDate.getSeconds() : localDate.getSeconds());
    }
  }
});

/***/ }),

/***/ "gvmA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h8Cz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-bar',
  data: function data() {
    return {
      moreOpen: false,
      primary: [{ label: 'Home', path: '/' }, { label: 'Leaderboard', path: '/leaderboard' }, { label: 'Bets', path: '/bets' }, { label: 'Sub Bounties', path: '/bounties' }, { label: 'GOLD', path: '/gold', gold: true }, { label: 'Loot Shop', path: '/loot-shop' }],
      more: [{ label: 'Ticket Raffles', path: '/ticket-raffles' }, { label: 'My Room', path: '/rooms' }, { label: 'Room Browser', path: '/room-browser' }, { label: 'Rates', path: '/rates' }]
    };
  },

  computed: {
    moreIsActive: function moreIsActive() {
      var _this = this;

      return this.more.some(function (item) {
        return _this.isActive(item);
      });
    }
  },
  watch: {
    $route: function $route() {
      this.moreOpen = false;
    }
  },
  mounted: function mounted() {
    document.addEventListener('click', this.closeMore);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.closeMore);
  },

  methods: {
    isActive: function isActive(item) {
      var path = this.$route.path;
      return item.path === '/' ? path === '/' : path.indexOf(item.path) === 0;
    },
    toggleMore: function toggleMore() {
      this.moreOpen = !this.moreOpen;
    },
    closeMore: function closeMore() {
      this.moreOpen = false;
    },
    navigate: function navigate(path) {
      this.moreOpen = false;
      if (this.$route.path === path) {
        this.$router.go(0);
      } else {
        this.$router.push({ path: path });
      }
    }
  }
});

/***/ }),

/***/ "hNhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rooms_vue__ = __webpack_require__("Axgb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1482acba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rooms_vue__ = __webpack_require__("ZDgj");
function injectStyle (ssrContext) {
  __webpack_require__("yVmx")
  __webpack_require__("Fr4N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1482acba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rooms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1482acba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rooms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iTOo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iUXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'discord-btn',
  props: {
    buttonClass: {
      type: String,
      default: 'discord-btn'
    },
    buttonSelectedClass: {
      type: String,
      default: 'discord-btn-selected'
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    loginUrl: function loginUrl() {
      return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.CURRENCY_SERVICE_ROOT_BASE_URL + '/auth/connect/discord?path=' + encodeURIComponent(this.$route.path);
    },
    classes: function classes() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.buttonClass, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.buttonSelectedClass, this.selected), _ref;
    }
  },
  methods: {
    loginRedirect: function loginRedirect() {
      window.location = this.loginUrl;
    }
  }
});

/***/ }),

/***/ "j54e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j6kf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"admin-push-notifications"}},[_c('info-box',{attrs:{"description":_vm.description}}),_vm._v(" "),_c('header-title',{attrs:{"title":"PUSH NOTIFICATIONS"}}),_vm._v(" "),(_vm.notification)?_c('div',{staticClass:"notification-banner",class:_vm.notificationType},[_vm._v("\n    "+_vm._s(_vm.notification)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"two-column-layout"},[_c('div',{staticClass:"left-column"},[_c('div',{staticClass:"form-container"},[_c('h2',[_vm._v("Send Push Notification")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Notification Title:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notificationTitle),expression:"notificationTitle"}],staticClass:"input-field",attrs:{"type":"text","placeholder":"Enter notification title"},domProps:{"value":(_vm.notificationTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notificationTitle=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Notification Message:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.notificationMessage),expression:"notificationMessage"}],staticClass:"textarea-field",attrs:{"placeholder":"Enter notification message","rows":"4"},domProps:{"value":(_vm.notificationMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.notificationMessage=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Target Audience:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.targetType),expression:"targetType"}],staticClass:"select-field",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.targetType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"topic"}},[_vm._v("Send to Topic")]),_vm._v(" "),_c('option',{attrs:{"value":"user"}},[_vm._v("Send to Specific User")]),_vm._v(" "),_c('option',{attrs:{"value":"endpoint"}},[_vm._v("Send to Specific Endpoint")])])]),_vm._v(" "),(_vm.targetType === 'topic')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Notification Type:")]),_vm._v(" "),_c('div',{staticClass:"radio-group"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedNotificationType),expression:"selectedNotificationType"}],attrs:{"type":"radio","value":"live"},domProps:{"checked":_vm._q(_vm.selectedNotificationType,"live")},on:{"change":function($event){_vm.selectedNotificationType="live"}}}),_vm._v(" Live\n            ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedNotificationType),expression:"selectedNotificationType"}],attrs:{"type":"radio","value":"update_all"},domProps:{"checked":_vm._q(_vm.selectedNotificationType,"update_all")},on:{"change":function($event){_vm.selectedNotificationType="update_all"}}}),_vm._v(" All\n            ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedNotificationType),expression:"selectedNotificationType"}],attrs:{"type":"radio","value":"update_minigames"},domProps:{"checked":_vm._q(_vm.selectedNotificationType,"update_minigames")},on:{"change":function($event){_vm.selectedNotificationType="update_minigames"}}}),_vm._v(" Minigames\n            ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedNotificationType),expression:"selectedNotificationType"}],attrs:{"type":"radio","value":"update_party"},domProps:{"checked":_vm._q(_vm.selectedNotificationType,"update_party")},on:{"change":function($event){_vm.selectedNotificationType="update_party"}}}),_vm._v(" Party\n            ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedNotificationType),expression:"selectedNotificationType"}],attrs:{"type":"radio","value":"update_playtogether"},domProps:{"checked":_vm._q(_vm.selectedNotificationType,"update_playtogether")},on:{"change":function($event){_vm.selectedNotificationType="update_playtogether"}}}),_vm._v(" Play Together\n            ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedNotificationType),expression:"selectedNotificationType"}],attrs:{"type":"radio","value":"update_solosquad"},domProps:{"checked":_vm._q(_vm.selectedNotificationType,"update_solosquad")},on:{"change":function($event){_vm.selectedNotificationType="update_solosquad"}}}),_vm._v(" SoloSquad\n            ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedNotificationType),expression:"selectedNotificationType"}],attrs:{"type":"radio","value":"update_other"},domProps:{"checked":_vm._q(_vm.selectedNotificationType,"update_other")},on:{"change":function($event){_vm.selectedNotificationType="update_other"}}}),_vm._v(" Other\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.targetType === 'user')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("User ID:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.targetUserId),expression:"targetUserId"}],staticClass:"input-field",attrs:{"type":"text","placeholder":"Enter user ID"},domProps:{"value":(_vm.targetUserId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.targetUserId=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.targetType === 'endpoint')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Endpoint ARN:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.targetEndpoint),expression:"targetEndpoint"}],staticClass:"input-field",attrs:{"type":"text","placeholder":"Enter SNS endpoint ARN"},domProps:{"value":(_vm.targetEndpoint)},on:{"input":function($event){if($event.target.composing){ return; }_vm.targetEndpoint=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Platform:")]),_vm._v(" "),_c('div',{staticClass:"checkbox-group"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.platforms.ios),expression:"platforms.ios"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.platforms.ios)?_vm._i(_vm.platforms.ios,null)>-1:(_vm.platforms.ios)},on:{"change":function($event){var $$a=_vm.platforms.ios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.platforms, "ios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.platforms, "ios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.platforms, "ios", $$c)}}}}),_vm._v(" iOS\n            ")]),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.platforms.android),expression:"platforms.android"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.platforms.android)?_vm._i(_vm.platforms.android,null)>-1:(_vm.platforms.android)},on:{"change":function($event){var $$a=_vm.platforms.android,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.platforms, "android", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.platforms, "android", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.platforms, "android", $$c)}}}}),_vm._v(" Android\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Options:")]),_vm._v(" "),_c('div',{staticClass:"checkbox-group"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.includeTwitchDeeplink),expression:"includeTwitchDeeplink"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.includeTwitchDeeplink)?_vm._i(_vm.includeTwitchDeeplink,null)>-1:(_vm.includeTwitchDeeplink)},on:{"change":function($event){var $$a=_vm.includeTwitchDeeplink,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.includeTwitchDeeplink=$$a.concat([$$v]))}else{$$i>-1&&(_vm.includeTwitchDeeplink=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.includeTwitchDeeplink=$$c}}}}),_vm._v(" Include Twitch Deeplink\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Additional Data (JSON):")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.additionalData),expression:"additionalData"}],staticClass:"textarea-field",attrs:{"placeholder":"{\"key\": \"value\"}","rows":"3"},domProps:{"value":(_vm.additionalData)},on:{"input":function($event){if($event.target.composing){ return; }_vm.additionalData=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"button-group"},[_c('button',{staticClass:"btn-enabled",attrs:{"disabled":_vm.sending || !_vm.isFormValid},on:{"click":_vm.sendNotification}},[_vm._v("\n            "+_vm._s(_vm.sending ? 'Sending...' : 'Send Notification')+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn-secondary",on:{"click":_vm.resetForm}},[_vm._v("\n            Reset Form\n          ")])]),_vm._v(" "),(_vm.lastSendResult)?_c('div',{staticClass:"stats-container"},[_c('h3',[_vm._v("Last Send Result:")]),_vm._v(" "),_c('div',{staticClass:"stats-content"},[(_vm.lastSendResult.success)?_c('div',[_vm._m(0),_vm._v(" "),(_vm.lastSendResult.messageId)?_c('p',[_c('strong',[_vm._v("Message ID:")]),_vm._v(" "+_vm._s(_vm.lastSendResult.messageId))]):_vm._e(),_vm._v(" "),(_vm.lastSendResult.recipientCount)?_c('p',[_c('strong',[_vm._v("Recipients:")]),_vm._v(" "+_vm._s(_vm.lastSendResult.recipientCount))]):_vm._e()]):_c('div',[_vm._m(1),_vm._v(" "),(_vm.lastSendResult.error)?_c('p',[_c('strong',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.lastSendResult.error))]):_vm._e()])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"right-column"},[_c('div',{staticClass:"history-container"},[_c('h2',[_vm._v("Send History")]),_vm._v(" "),(_vm.loadingHistory)?_c('div',{staticClass:"history-loading"},[_vm._v("Loading...")]):(_vm.history.length === 0)?_c('div',{staticClass:"history-empty"},[_vm._v("No notifications sent yet.")]):_c('div',{staticClass:"history-list"},_vm._l((_vm.history),function(entry){return _c('div',{key:entry.id,staticClass:"history-entry",class:{ 'history-failed': !entry.success }},[_c('div',{staticClass:"history-header"},[_c('span',{staticClass:"history-badge",class:entry.success ? 'badge-success' : 'badge-error'},[_vm._v("\n                "+_vm._s(entry.success ? 'OK' : 'FAIL')+"\n              ")]),_vm._v(" "),(entry.category || entry.type)?_c('span',{staticClass:"history-type-badge"},[_vm._v("\n                "+_vm._s(_vm.formatTypeBadge(entry))+"\n              ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"history-time"},[_vm._v(_vm._s(_vm.formatTime(entry.createdAt)))])]),_vm._v(" "),_c('div',{staticClass:"history-title"},[_vm._v(_vm._s(entry.title))]),_vm._v(" "),_c('div',{staticClass:"history-body"},[_vm._v(_vm._s(entry.message))]),_vm._v(" "),_c('div',{staticClass:"history-meta"},[_c('span',[_vm._v("by "+_vm._s(entry.sent_by))]),_vm._v(" "),(entry.recipient_count)?_c('span',[_vm._v(" | "+_vm._s(entry.recipient_count)+" recipients")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(" | "+_vm._s(entry.target_type))])]),_vm._v(" "),(!entry.success && entry.error_message)?_c('div',{staticClass:"history-error"},[_vm._v("\n              "+_vm._s(entry.error_message)+"\n            ")]):_vm._e()])}),0)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Status:")]),_vm._v(" "),_c('span',{staticClass:"success-text"},[_vm._v("Success")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Status:")]),_vm._v(" "),_c('span',{staticClass:"error-text"},[_vm._v("Failed")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jBHF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_Bar_vue__ = __webpack_require__("h8Cz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c2cc756_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_Bar_vue__ = __webpack_require__("b/nM");
function injectStyle (ssrContext) {
  __webpack_require__("O5HS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c2cc756"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_Bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c2cc756_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_Bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jqYQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboard"},[_c('header-title',{attrs:{"title":"LEADERBOARD"}}),_vm._v(" "),_c('div',{staticClass:"sl-panel sl-scroll-x"},[_c('table',{staticClass:"sl-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"col-rank"},[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("User")]),_vm._v(" "),_c('th',{staticClass:"col-num is-sortable",class:{ 'is-sorted': _vm.order === 'balance' },on:{"click":function($event){return _vm.orderBy('balance')}}},[_vm._v("Swiftbucks")]),_vm._v(" "),_c('th',{staticClass:"col-num is-sortable",class:{ 'is-sorted': _vm.order === 'watchTime' },on:{"click":function($event){return _vm.orderBy('watchTime')}}},[_vm._v("Watch Time (minutes)")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.currentLeaders),function(leader,index){return _c('tr',{key:leader.user_id.toString()},[_c('td',{staticClass:"col-rank rank"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticClass:"user-cell",attrs:{"data-title":"User"}},[_c('User',{attrs:{"user_id":leader.user_id}})],1),_vm._v(" "),_c('td',{staticClass:"col-num sl-num",attrs:{"data-title":"Swiftbucks"}},[_vm._v(_vm._s(_vm.formatCurrency(leader.total)))]),_vm._v(" "),_c('td',{staticClass:"col-num",attrs:{"data-title":"WatchTime"}},[_vm._v(_vm._s(_vm.formatCurrency(leader.minutes)))])])}),0)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jyJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__("qgpy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e996529_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__("xMGV");
function injectStyle (ssrContext) {
  __webpack_require__("3iHT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e996529"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e996529_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kpOj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'equipped-items',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userRates', 'currentUser'])),
  data: function data() {
    return {
      description: {
        title: 'Loot Shop',
        text: 'Spend SwiftBUCKS and SwiftGOLD on awesome loot!'
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])({
    // fetchUserRates: 'fetchUserRates'
  })),
  mounted: function mounted() {},

  watch: {
    currentUser: function currentUser() {
      this.$nextTick(function () {});
    }
  }
});

/***/ }),

/***/ "l9jD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.$route.fullPath,staticClass:"room-hello"},[_c('header-title',{attrs:{"title":"ROOM BROWSER"}}),_vm._v(" "),_c('nav',{staticClass:"cyberpunk-menu"},[(_vm.newerRooms)?_c('div',{staticClass:"menu-button",on:{"click":_vm.previousRoom}},[_c('div',[_vm._v("Previous")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"menu-title"},[_vm._v("Explore Recently Updated Rooms")]),_vm._v(" "),(_vm.olderRooms)?_c('div',{staticClass:"menu-button",on:{"click":_vm.nextRoom}},[_c('div',[_vm._v("Next")])]):_vm._e()]),_vm._v(" "),(_vm.user)?_c('div',[_vm._v(_vm._s(_vm.user.twitch_name)+"'s Room "),_c('button',{staticClass:"btn-copy",on:{"click":_vm.copyToClipboard}},[_vm._v("Copy Share Link")])]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"room-container"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_452b4757_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("bcmc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_452b4757_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lvsm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ticket_Raffle_Entries_vue__ = __webpack_require__("mW8/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bdef406_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ticket_Raffle_Entries_vue__ = __webpack_require__("m0Pe");
function injectStyle (ssrContext) {
  __webpack_require__("oSIS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bdef406"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ticket_Raffle_Entries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bdef406_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ticket_Raffle_Entries_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m0Pe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.entries && _vm.entries.length > 0)?_c('div',[(_vm.winners.length > 0)?_c('div',[_c('table',[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.winners),function(entry){return _c('tr',{key:entry.user_id + entry.quantity.toString()},[_c('td',{attrs:{"data-title":"User"}},[_c('User',{attrs:{"user_id":entry.user_id}})],1),_vm._v(" "),_c('td',{attrs:{"data-title":"Amount"}},[_vm._v(_vm._s(_vm.formatCurrency(entry.quantity)+" (" + ((entry.quantity/_vm.ticketRaffle.total_entries).toFixed(4)*100) + "%)"))])])}),0)])]):_vm._e(),_vm._v(" "),_c('table',[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.entries),function(entry,index){return _c('tr',{key:entry.user_id + entry.quantity.toString(),class:index % 2 ? 'pp-odd' : 'pp-even'},[_c('td',{attrs:{"data-title":"User"}},[_c('User',{attrs:{"user_id":entry.user_id}})],1),_vm._v(" "),_c('td',{attrs:{"data-title":"Amount"}},[_vm._v(_vm._s(_vm.formatCurrency(entry.quantity)))])])}),0)])]):_c('div',[_vm._v("No entries")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Winning User")]),_vm._v(" "),_c('th',[_vm._v("# Of Tickets")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("User")]),_vm._v(" "),_c('th',[_vm._v("# Of Tickets")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mHoR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mQLJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mW8/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapState } from 'vuex'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ticket-raffle-entries',
  props: ['ticketRaffleId', 'ticketRaffle'],
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.refreshEntries();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {};
  },

  computed: {
    entries: function entries() {
      // console.log('STORE', this.$store.state.placedBets)
      return this.$store.state.ticketRaffleEntries[this.ticketRaffleId] || [];
    },
    winners: function winners() {
      return this.$store.state.ticketRaffleWinners[this.ticketRaffleId] || [];
    }
  },
  methods: {
    refreshEntries: function refreshEntries() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', _this2.$store.dispatch('fetchTicketRaffleEntries', _this2.ticketRaffleId));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ "mXMQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-title',
  props: ['title', 'title_img_src', 'subtitle'],
  computed: {
    displayTitle: function displayTitle() {
      if (this.title) return this.title;
      // legacy callers pass an svg filename like `ticket-raffles-title.svg`
      return String(this.title_img_src || 'Swiftorland').replace(/\.svg$/i, '').replace(/-title$/i, '').replace(/-/g, ' ').toUpperCase();
    }
  }
});

/***/ }),

/***/ "mwy/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sl-shell",attrs:{"id":"app"}},[_c('div',{staticClass:"sl-texture"}),_vm._v(" "),(_vm.config.ENV != 'production')?_c('debug-panel'):_vm._e(),_vm._v(" "),_c('nav-bar'),_vm._v(" "),_c('div',{staticClass:"maincontent"},[_c('router-view')],1),_vm._v(" "),_c('footer',{staticClass:"site-footer"},[_c('div',{staticClass:"site-footer__inner"},[_c('span',{staticClass:"site-footer__mark"},[_vm._v("SWIFTORLAND")]),_vm._v(" "),_c('span',{staticClass:"site-footer__note"},[_vm._v("\n        For legal, terms of service, privacy policy, or cookie policy\n        "),_c('router-link',{attrs:{"to":"/legal"}},[_vm._v("click here")])],1),_vm._v(" "),_c('span',{staticClass:"site-footer__note"},[_vm._v("© Copyright 2026 Swiftor, Inc.")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n9vI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ne0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title"},[_c('h1',{staticClass:"page-title__text"},[_vm._v(_vm._s(_vm.displayTitle))]),_vm._v(" "),(_vm.subtitle)?_c('p',{staticClass:"page-title__sub"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "niH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("JZSy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eef8d9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("8P3/");
function injectStyle (ssrContext) {
  __webpack_require__("6Wjt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5eef8d9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eef8d9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nmIj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o1B/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bounties"}},[_c('info-box',{attrs:{"description":_vm.description}}),_vm._v(" "),_c('header-title',{attrs:{"title":"LOOT SHOP"}}),_vm._v(" "),(_vm.notification)?_c('span',[_vm._v(_vm._s(_vm.notification))]):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.lootShopLootItemIds),function(lootItemId){return _c('li',{key:lootItemId,staticClass:"shop-item"},[_c('table',{staticStyle:{"width":"100%"}},[_c('tr',{staticStyle:{"height":"200px"}},[_c('td',[(_vm.lootShopLootItems[lootItemId].image_url)?_c('img',{staticClass:"shop-image",attrs:{"src":_vm.lootItemImageUrl(_vm.lootShopLootItems[lootItemId])}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(" "+_vm._s(_vm.lootShopLootItems[lootItemId].name)+" ")])]),_vm._v(" "),(_vm.lootShopLootItems[lootItemId].rarity)?_c('tr',[_c('td',{class:("rarity-" + (_vm.lootShopLootItems[lootItemId].rarity))},[_vm._v(" "+_vm._s(_vm.lootShopLootItems[lootItemId].rarity.toUpperCase())+" ")])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-size":"12px"}},[_vm._v(" "+_vm._s(_vm.categoryTextFor(_vm.lootShopLootItems[lootItemId]))+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(" "+_vm._s(_vm.lootShopLootItems[lootItemId].description)+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(" Owned: "+_vm._s(_vm.ownedLootItemsByLootItemId[lootItemId] ? _vm.ownedLootItemsByLootItemId[lootItemId].quantity : 0)+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(" Max Ownable: "+_vm._s(_vm.lootShopLootItems[lootItemId].max_allowed > 0 ? _vm.lootShopLootItems[lootItemId].max_allowed : 'Unlimited')+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('span',{staticClass:"price-content"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.lootShopLootItems[lootItemId].price))+" "),_c('img',{staticClass:"currency-icon",attrs:{"src":_vm.currencyIcon(_vm.lootShopLootItems[lootItemId].price_currency_type)}})])])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.requiresAttribution)?_c('span',{staticClass:"copyright",domProps:{"innerHTML":_vm._s(_vm.attributionText(_vm.lootShopLootItems[lootItemId]))}}):_vm._e()])]),_vm._v(" "),(_vm.allowedToBuy(_vm.lootShopLootItems[lootItemId]).allowed)?_c('tr',[_c('td',[_c('button',{staticClass:"btn-enabled",on:{"click":function($event){return _vm.buy(_vm.lootShopLootItems[lootItemId])}}},[_vm._v("BUY")])])]):_c('tr',{staticStyle:{"height":"51px"}},[_c('td',[_vm._v(" "+_vm._s(_vm.allowedToBuy(_vm.lootShopLootItems[lootItemId]).reason)+" ")])])])])}),0),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px"}},[_vm._v("All items VIRTUAL. You are not buying physical items!")]),_vm._v(" "),_c('span',{staticClass:"copyright"},[_vm._v("All product names, logos, and brands are property of their respective owners. All company, product and service names used in this website are for identification purposes only. Use of these names, logos, and brands does not imply endorsement.")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oIDu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oJIt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_upload_component__ = __webpack_require__("1Wvq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_upload_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import BigNumber from 'BigNumber.js'



var scriptLoaded = false;
var scriptFinished = false;

function initialState() {
  return {
    subCategory1Options: ['furniture', 'poster', 'electronics', 'accessories', 'wallBase', 'floorBase', 'appliances'],
    subCategory2Options: ['emote', 'banner', 'art', 'tvs', 'tv stands', 'lights', 'bottles', 'tables', 'random', 'fans', 'misc', 'accessories'],
    collection1Options: ['halloween', 'valentines', 'summer', 'pool', 'winter'],
    files: [],
    thumbnailImage: [],
    bumpMapFile: [],
    normalMapFile: [],
    fileToOptimize: [],
    description: {
      title: 'Room Item Management',
      text: 'Do it!'
    },
    roomDisplayed: false,
    room: undefined,
    roomManager: undefined,
    roomObject: undefined,
    roomObjectMap: {},
    wallParams: {},
    floorParams: {},
    scaleFactor: 1,
    itemSize: 100,
    color: undefined,
    normalMap: undefined,
    roughness: undefined,
    metalness: undefined,
    bumpScale: undefined,
    iRotationY: 0,
    notification: undefined,
    initialTriangles: 0,
    triangles: 0,
    selectedItemType: '3d',
    itemName: '',
    itemRarity: 'common',
    itemDescription: '',
    itemForSale: false,
    itemPrice: '50',
    itemPriceCurrencyType: 'mt',
    itemMaxAllowed: '5',
    itemSubCategory1: '',
    itemSubCategory2: '',
    itemCollection1: '',
    itemAttributionAuthor: '',
    itemAttributionAuthorUrl: '',
    itemAttributionTitle: '',
    itemAttributionTitleUrl: '',
    itemAttributionLicense: '',
    sketchFabId: undefined,
    itemDepth: 100,
    itemHeight: undefined,
    existingThumbnailUrl: undefined,
    thumbnailSnapshot: undefined,
    existingItem: undefined,
    fileId: undefined,
    displaying: true
  };
}

/* global SwiftorRooms */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'room-item-editor',
  props: ['itemId'],
  components: {
    VueUploadComponent: __WEBPACK_IMPORTED_MODULE_8_vue_upload_component___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.refreshLootItems();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.loadPage();

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  data: function data() {
    return initialState();
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])(['currentUser', 'lootShopLootItemIds', 'lootShopLootItems']), {
    itemType: function itemType() {
      if (this.selectedItemType === 'rug') {
        return 'wall';
      } else {
        return this.selectedItemType;
      }
    },
    thumbnailUrl: function thumbnailUrl() {
      if (this.thumbnailImage.length > 0) {
        return URL.createObjectURL(this.thumbnailImage[0].file);
      } else if (this.thumbnailSnapshot) {
        return URL.createObjectURL(this.thumbnailSnapshot);
      } else if (this.existingItem) {
        return __WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.WEB_ASSET_BASE_URL + '/' + this.existingItem.image_url;
      }
    },
    assetUrl: function assetUrl() {
      if (this.files.length > 0) {
        return URL.createObjectURL(this.files[0].file);
      } else if (this.existingItem && this.existingItem.meta && this.existingItem.meta.texture) {
        if (typeof this.existingItem.meta.texture === 'string') {
          return __WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.ITEM_ASSET_BASE_URL + '/' + this.existingItem.meta.texture;
        } else {
          return __WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.ITEM_ASSET_BASE_URL + '/' + this.existingItem.meta.texture.map;
        }
      }
    },
    itemTriangles: function itemTriangles() {
      if (this.triangles === 0) {
        return 0;
      }
      return this.triangles - this.initialTriangles;
    },
    itemAttributionLicenseUrl: function itemAttributionLicenseUrl() {
      if (this.itemAttributionLicense === 'CC BY 4.0') {
        return 'https://creativecommons.org/licenses/by/4.0/';
      } else {
        return undefined;
      }
    },
    showScaleFactor: function showScaleFactor() {
      return true;
    },
    showColor: function showColor() {
      return this.isTextureItem(this.itemType);
    },
    showNormalMap: function showNormalMap() {
      return this.isTextureItem(this.itemType);
    },
    showRoughness: function showRoughness() {
      return this.isTextureItem(this.itemType);
    },
    showMetalness: function showMetalness() {
      return this.isTextureItem(this.itemType);
    },
    showBumpMap: function showBumpMap() {
      return this.isTextureItem(this.itemType);
    },
    showBumpScale: function showBumpScale() {
      return this.isTextureItem(this.itemType);
    },
    assetFileName: function assetFileName() {
      if (this.existingItem) {
        if (this.existingItem.meta && this.existingItem.meta.texture && this.existingItem.meta.texture.map) {
          return this.existingItem.meta.texture.map;
        }
      }

      return undefined;
    },
    bumpMapFileName: function bumpMapFileName() {
      if (this.existingItem) {
        if (this.existingItem.meta && this.existingItem.meta.texture && this.existingItem.meta.texture.bump) {
          return this.existingItem.meta.texture.bump;
        }
      }

      return undefined;
    },
    normalMapFileName: function normalMapFileName() {
      if (this.existingItem) {
        if (this.existingItem.meta && this.existingItem.meta.texture && this.existingItem.meta.texture.normalMap) {
          return this.existingItem.meta.texture.normalMap;
        }
      }

      return undefined;
    }
  }),
  methods: {
    loadPage: function loadPage() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this2.roomManager) {
                  _this2.roomManager.quit();
                  _this2.roomManager = undefined;
                  // this.roomManager.room.removeRoomObject(this.roomObject.uuid)
                }
                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(_this2.$data, initialState());

                if (!_this2.itemId) {
                  _context3.next = 6;
                  break;
                }

                _this2.$store.dispatch('fetchLootItem', _this2.itemId).then(function () {
                  var item = _this2.$store.state.lootItems[_this2.itemId];
                  _this2.existingItem = item;
                  _this2.itemName = item.name;
                  _this2.itemRarity = item.rarity;
                  _this2.itemDescription = item.description;
                  _this2.itemForSale = item.for_sale;
                  _this2.itemPrice = item.price;
                  _this2.itemPriceCurrencyType = item.price_currency_type;
                  _this2.itemMaxAllowed = item.max_allowed;
                  _this2.itemSubCategory1 = item.sub_category1;
                  _this2.itemSubCategory2 = item.sub_category2;
                  _this2.itemCollection1 = item.collection1;
                  _this2.itemAttributionAuthor = item.attribution_author;
                  _this2.itemAttributionAuthorUrl = item.attribution_author_url;
                  _this2.itemAttributionTitle = item.attribution_title;
                  _this2.itemAttributionTitleUrl = item.attribution_title_url;
                  _this2.itemAttributionLicense = item.attribution_license;
                  // this.itemAttributionLicenseUrl = item.attribution_license_url
                  _this2.existingThumbnailUrl = item.image_url;
                  _this2.selectedItemType = item.meta.objectType;

                  if (item.meta && item.meta.onWall === 'floor') {
                    _this2.selectedItemType = 'rug';
                  }

                  if (item.meta.scaleFactor) {
                    _this2.scaleFactor = item.meta.scaleFactor;
                  }

                  if (item.meta.iRotationY) {
                    _this2.iRotationY = item.meta.iRotationY;
                  }

                  if (item.meta.size) {
                    _this2.itemSize = item.meta.size[0];
                    _this2.itemHeight = item.meta.size[1];
                    _this2.itemDepth = item.meta.size[2];
                  }

                  if (item.meta.width) {
                    _this2.itemSize = item.meta.width;
                  }

                  if (item.meta.height) {
                    _this2.itemHeight = item.meta.height;
                  }

                  if (item.meta.depth) {
                    _this2.itemDepth = item.meta.depth;
                  }

                  if (item.meta.objectType === '3d') {
                    _this2.fileId = item.meta.modelParams.gltf;
                  } else if (typeof item.meta.texture === 'string') {
                    _this2.fileId = item.meta.texture;
                  } else if (_this2.is2dItem(item.meta.objectType)) {
                    _this2.fileId = item.meta.texture.map;
                  }

                  if (_this2.isTextureItem(item.meta.objectType)) {
                    if (item.meta.texture) {
                      _this2.color = item.meta.texture.color;
                      _this2.scaleFactor = item.meta.texture.scaleFactor;
                      _this2.roughness = item.meta.texture.roughness;
                      _this2.metalness = item.meta.texture.metalness;
                      if (item.meta.texture.bumpScale !== undefined) {
                        _this2.bumpScale = parseInt(item.meta.texture.bumpScale);
                      } else if (item.meta.texture.normalScale !== undefined) {
                        _this2.bumpScale = parseInt(item.meta.texture.normalScale[0]);
                      }
                    }
                  }

                  _this2.loadScript();
                });
                _context3.next = 8;
                break;

              case 6:
                // await Vue.nextTick()
                _this2.existingItem = undefined;
                return _context3.abrupt('return', _this2.loadScript());

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    loadScript: function loadScript() {
      var _this3 = this;

      // if (scriptLoaded) {
      //   scriptLoaded.innerHTML = ''
      //   scriptLoaded = undefined
      // }
      if (!scriptLoaded) {
        var roomScript = document.createElement('script');
        roomScript.setAttribute('src', __WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.ROOM_JS_URL);
        document.head.appendChild(roomScript);

        roomScript.onload = function () {
          scriptFinished = true;

          _this3.displayRoom();
        };

        scriptLoaded = roomScript;
      } else {
        this.displayRoom();
      }

      this.roomScript = scriptLoaded;
    },
    refreshLootItems: function refreshLootItems() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.$store.dispatch('fetchLootShopLootItems');

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    lootShopLootItemForId: function lootShopLootItemForId(id) {
      return this.$store.state.lootShopLootItems[id];
    },
    lootItemImageUrl: function lootItemImageUrl(lootItem) {
      if (lootItem.meta && (lootItem.meta.objectType === 'wallBase' || lootItem.meta.objectType === 'floorBase')) {
        // TODO: WAT
        return this.lootItemItemUrl(this.assetFileName); // `${Vue.config.ITEM_ASSET_BASE_URL}/${prefix}${prefix !== '' ? '_' : ''}${file}`
      } else {
        return __WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.WEB_ASSET_BASE_URL + '/' + lootItem.image_url;
      }
    },
    lootItemItemUrl: function lootItemItemUrl(file) {
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      return __WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.ITEM_ASSET_BASE_URL + '/' + prefix + (prefix !== '' ? '_' : '') + file;
    },
    currencyIcon: function currencyIcon(priceCurrencyType) {
      var image = priceCurrencyType === 'mt' ? 'swiftGold.png' : 'swiftBucks.png';

      return __WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.WEB_ASSET_BASE_URL + '/' + image;
    },
    attributionText: function attributionText(lootItem) {
      if (!lootItem.attribution_author) {
        return;
      }
      // // "Creative Commons 10th Birthday Celebration San Francisco" by tvol is licensed under CC BY 2.0
      return '<a href="' + lootItem.attribution_title_url + '" target="_blank">"' + lootItem.attribution_title + '"</a> by <a href="' + lootItem.attribution_author_url + '" target="_blank">' + lootItem.attribution_author + '</a> <br/> Licensed under <a href="' + lootItem.attribution_license_url + '" target="_blank">' + lootItem.attribution_license + '</a>';
    },
    requiresAttribution: function requiresAttribution(lootItem) {
      return !!lootItem.attribution_author;
    },
    notify: function notify(text) {
      var _this5 = this;

      this.notification = text;
      setTimeout(function () {
        _this5.notification = undefined;
      }, 5000);
    },
    displayRoom: function displayRoom() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var roomParams, wall, floor;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this6.$refs.roomcontainer) {
                  _context5.next = 3;
                  break;
                }

                _context5.next = 3;
                return _this6.sleep(1000);

              case 3:
                // document.getElementById('room-container').innerHTML = ''
                if (_this6.$refs.roomcontainer) {
                  _this6.$refs.roomcontainer.innerHTML = '';
                }

                if (scriptFinished) {
                  _context5.next = 8;
                  break;
                }

                return _context5.abrupt('return');

              case 8:
                _this6.displaying = true;
                _this6.roomManager = undefined;
                _this6.roomObjectMap = {};
                _this6.room = { meta: {} };

                _this6.roomManager = new SwiftorRooms.RoomManager(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({
                  container: _this6.$refs.roomcontainer, // document.getElementById('room-container'),
                  assetBaseUrl: __WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.ITEM_ASSET_BASE_URL,
                  editable: _this6.editable,
                  isMobile: false
                }));
                _this6.roomManager.start();

                roomParams = {};


                if (_this6.itemType === 'wallBase') {
                  wall = { texture: _this6.existingItem.meta.texture };


                  roomParams.wallParams = { left: wall, right: wall, front: wall, back: wall };
                } else if (_this6.itemType === 'floorBase') {
                  floor = { texture: _this6.existingItem.meta.texture
                    // floor.texture.bump = undefined
                  };
                  roomParams.floorParams = floor;
                }
                // await this.roomManager.loadRoom(this.room.meta)
                _context5.next = 18;
                return _this6.roomManager.loadRoom(roomParams);

              case 18:
                // this.addToRoom(ri, ri.loot_item)
                _this6.roomManager.gameLoop();

                _this6.roomDisplayed = 'ya'; // this.user.id

                if (_this6.existingItem) {
                  setTimeout(function () {
                    _this6.roomObject = _this6.roomManager.room.addRoomObject(_this6.existingItem.meta);
                    setTimeout(function () {
                      _this6.triangles = _this6.roomManager.renderer.info.render.triangles;
                      _this6.displaying = false;
                    }, 1000);
                  }, 1000);
                } else {
                  _this6.displaying = false;
                }
                setTimeout(function () {
                  _this6.initialTriangles = _this6.roomManager.renderer.info.render.triangles;
                }, 1000);

              case 22:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    readFileToDataURL: function readFileToDataURL(file) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          return resolve(reader.result);
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },
    sleep: function sleep(ms) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    baseMeta: function baseMeta() {
      var base = {
        objectType: this.itemType
      };

      if (this.itemType === '3d') {
        base.iRotationY = parseInt(this.iRotationY) ? this.iRotationY : 0;
        base.scaleFactor = this.scaleFactor;
      } else if (this.is2dItem(this.itemType)) {
        if (this.itemSize && this.itemSize.toString() !== '') {
          if (!base.size) {
            base.size = [];
          }
          base.size[0] = parseInt(this.itemSize);
        }

        if (this.itemType !== 'wall' && this.itemHeight && this.itemHeight.toString() !== '') {
          if (!base.size) {
            base.size = [];
          }
          base.size[1] = parseInt(this.itemHeight);
        }

        if (this.itemType !== 'wall' && this.itemDepth && this.itemDepth.toString() !== '') {
          if (!base.size) {
            base.size = [];
          }
          base.size[2] = parseInt(this.itemDepth);
        }

        if (this.selectedItemType === 'rug') {
          base.onWall = 'floor';
        }

        base.autoFaceCamera = this.itemType !== 'wall';
      }

      if (this.isTextureItem(this.itemType)) {
        base.texture = {};
        if (this.scaleFactor && this.scaleFactor.toString() !== '0') {
          base.texture.scaleFactor = this.scaleFactor;
        }
        if (this.metalness && this.metalness.toString() !== '0') {
          base.texture.metalness = this.metalness;
        }
        if (this.roughness && this.roughness.toString() !== '0') {
          base.texture.roughness = this.roughness;
        }
        if (this.bumpScale && this.bumpScale.toString() !== '0') {
          var local = this.localMeta();

          if (local.texture.bump) {
            base.texture.bumpScale = parseInt(this.bumpScale);
          } else if (local.texture.normalMap) {
            base.texture.normalScale = [parseInt(this.bumpScale), parseInt(this.bumpScale)];
          }
        }
        if (this.color && this.color.toString() !== '') {
          base.texture.color = this.color;
        }
      }

      return base;
    },
    localMeta: function localMeta() {
      var url = void 0;
      if (this.files[0] && this.files[0].file) {
        url = URL.createObjectURL(this.files[0].file);
      } else {
        url = this.fileId;
      }

      if (this.itemType === '3d') {
        return { modelParams: { gltf: url } };
      } else if (this.isTextureItem(this.itemType)) {
        var local = { texture: {} };
        if (url) {
          local.texture.map = url;
        }

        if (this.bumpMapFile[0] && this.bumpMapFile[0].file) {
          local.texture.bump = URL.createObjectURL(this.bumpMapFile[0].file);
        } else if (this.bumpMapFileName) {
          local.texture.bump = this.bumpMapFileName;
        }

        if (this.normalMapFile[0] && this.normalMapFile[0].file) {
          local.texture.normalMap = URL.createObjectURL(this.normalMapFile[0].file);
        } else if (this.normalMapFileName) {
          local.texture.normalMap = this.normalMapFileName;
        }

        return local;
      } else {
        console.log('Error no local meta');
        return {};
      }
    },
    combinedMeta: function combinedMeta() {
      var base = this.baseMeta();
      var local = this.localMeta();

      var combined = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, base, local);
      if (this.isTextureItem(this.itemType)) {
        combined.texture = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, base.texture, local.texture);
      }
      if (this.itemType === '3d') {
        combined.modelParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, base.modelParams, local.modelParams);
      }

      return combined;
    },
    refreshItem: function refreshItem() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var wall, floor;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this7.refreshWaiting === true || _this7.displaying === true)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt('return');

              case 2:
                if (_this7.roomManager) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt('return');

              case 4:
                _context6.next = 6;
                return __WEBPACK_IMPORTED_MODULE_7_vue__["default"].nextTick();

              case 6:
                if (!_this7.roomObject) {
                  _context6.next = 19;
                  break;
                }

                if (_this7.roomObject.uuid) {
                  _context6.next = 12;
                  break;
                }

                _this7.refreshWaiting = true;
                _context6.next = 11;
                return _this7.sleep(100);

              case 11:
                _this7.refreshWaiting = false;
                // return

              case 12:
                if (!(_this7.roomManager && _this7.roomObject && _this7.roomObject.uuid)) {
                  _context6.next = 17;
                  break;
                }

                _this7.roomManager.room.removeRoomObject(_this7.roomObject.uuid);
                _this7.roomObject = undefined;
                _context6.next = 19;
                break;

              case 17:
                if (!_this7.roomObject) {
                  _context6.next = 19;
                  break;
                }

                return _context6.abrupt('return');

              case 19:
                if (!(!_this7.is2dItem(_this7.itemType) && isNaN(parseInt(_this7.scaleFactor)))) {
                  _context6.next = 21;
                  break;
                }

                return _context6.abrupt('return');

              case 21:

                if (_this7.itemType === 'wallBase') {
                  wall = _this7.combinedMeta(); // {...this.baseMeta(), ...this.localMeta()}

                  _this7.roomManager.room.createWall('left', wall);
                  _this7.roomManager.room.createWall('right', wall);
                  _this7.roomManager.room.createWall('front', wall);
                  _this7.roomManager.room.createWall('back', wall);
                } else if (_this7.itemType === 'floorBase') {
                  // TODO: Add floor
                  floor = _this7.combinedMeta(); // {...this.baseMeta(), ...this.localMeta()}
                  // floor.texture = {...this.baseMeta().texture, ...this.localMeta().texture}

                  _this7.roomManager.room.createFloor(floor);
                } else if (!_this7.isBaseItem(_this7.itemType)) {
                  if (_this7.fileId || _this7.files && _this7.files[0]) {
                    _this7.roomObject = _this7.roomManager.room.addRoomObject(_this7.combinedMeta());
                    setTimeout(function () {
                      if (_this7.files && _this7.files[0]) {
                        if (_this7.roomObject && _this7.roomObject.size.x < 10) {
                          _this7.scaleFactor = parseInt(50 / _this7.roomObject.size.x);
                        }
                      }
                      _this7.triangles = _this7.roomManager.renderer.info.render.triangles;
                    }, 1000);
                  }
                }

              case 22:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    takeThumbnail: function takeThumbnail() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this8.roomManager.render();
                _context7.next = 3;
                return _this8.getCanvasBlob(_this8.roomManager.renderer.domElement);

              case 3:
                _this8.thumbnailSnapshot = _context7.sent;
                return _context7.abrupt('return', _this8.thumbnailSnapshot);

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    save: function save() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var thumbnail, formData, response, id;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                thumbnail = void 0;

                if (!(!_this9.existingThumbnailUrl && _this9.thumbnailImage.length === 0 && !_this9.thumbnailSnapshot)) {
                  _context8.next = 4;
                  break;
                }

                _context8.next = 4;
                return _this9.takeThumbnail();

              case 4:

                if (_this9.thumbnailFile) {
                  thumbnail = _this9.thumbnailFile[0].file;
                } else if (_this9.thumbnailSnapshot) {
                  thumbnail = _this9.thumbnailSnapshot;
                }
                // } else if (!this.thumbnailUrl && this.files[0] && (this.itemType === 'floorBase' || this.itemType === 'wallBase')) {
                //   thumbnail = this.files[0].file
                // }
                formData = new FormData();


                if (_this9.files[0]) {
                  formData.append('itemFile', _this9.files[0].file);
                }
                if (thumbnail) {
                  formData.append('thumbnailFile', thumbnail);
                }
                formData.append('item_type', _this9.itemType);
                formData.append('base_meta', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this9.baseMeta()));
                formData.append('name', _this9.itemName);
                formData.append('price', _this9.itemPrice);
                formData.append('rarity', _this9.itemRarity);
                formData.append('description', _this9.itemDescription);
                formData.append('for_sale', _this9.itemForSale);
                formData.append('price_currency_type', _this9.itemPriceCurrencyType);
                formData.append('max_allowed', _this9.itemMaxAllowed);
                formData.append('sub_category1', _this9.formValue(_this9.itemSubCategory1));
                formData.append('sub_category2', _this9.formValue(_this9.itemSubCategory2));
                formData.append('collection1', _this9.formValue(_this9.itemCollection1));
                formData.append('attribution_author', _this9.formValue(_this9.itemAttributionAuthor));
                formData.append('attribution_author_url', _this9.formValue(_this9.itemAttributionAuthorUrl));
                formData.append('attribution_title', _this9.formValue(_this9.itemAttributionTitle));
                formData.append('attribution_title_url', _this9.formValue(_this9.itemAttributionTitleUrl));
                formData.append('attribution_license', _this9.formValue(_this9.itemAttributionLicense));
                formData.append('attribution_license_url', _this9.formValue(_this9.itemAttributionLicenseUrl));

                if (_this9.bumpMapFile[0]) {
                  formData.append('bumpMapFile', _this9.bumpMapFile[0].file);
                }
                if (_this9.normalMapFile[0]) {
                  formData.append('normalMapFile', _this9.normalMapFile[0].file);
                }

                response = void 0;

                if (!_this9.existingItem) {
                  _context8.next = 35;
                  break;
                }

                _context8.next = 32;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/room-items/' + _this9.existingItem.id, formData, { withCredentials: true });

              case 32:
                response = _context8.sent;
                _context8.next = 38;
                break;

              case 35:
                _context8.next = 37;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/room-items', formData, { withCredentials: true });

              case 37:
                response = _context8.sent;

              case 38:

                if (response.data) {
                  // this.notify('Room Saved.')
                  id = response.data.loot_item.id;


                  __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push({ name: 'RoomItemEditor', query: { notify: 'Item Saved.' }, params: { itemId: id } });
                } else {
                  _this9.notify('ERROR SAVING.');
                }

              case 39:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    giveMeItem: function giveMeItem() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/room-items/giveMe', {
                  lootItemId: _this10.existingItem.id
                }, { withCredentials: true });

              case 2:

                _this10.notify('OK');

              case 3:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    },
    formValue: function formValue(v) {
      return v && v !== '' ? v : '';
    },
    getCanvasBlob: function getCanvasBlob(canvas) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        canvas.toBlob(function (blob) {
          resolve(blob);
        });
      });
    },
    isTextureItem: function isTextureItem(itemType) {
      return ['wallBase', 'floorBase', 'wall', '2d'].includes(itemType);
    },
    isBaseItem: function isBaseItem(itemType) {
      return ['wallBase', 'floorBase'].includes(itemType);
    },
    is2dItem: function is2dItem(itemType) {
      return ['wall', '2d'].includes(itemType);
    },
    sendOptimize: function sendOptimize() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var formData, response, d;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                formData = new FormData();


                if (_this11.fileToOptimize[0]) {
                  formData.append('files', _this11.fileToOptimize[0].file);
                }

                _context10.next = 4;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/room-item-tools/optimize', formData, { responseType: 'blob', withCredentials: true });

              case 4:
                response = _context10.sent;


                if (response.data) {
                  d = new Blob([response.data]);

                  if (_this11.files.length === 0) {
                    _this11.files.push({ file: d, name: 'optimized.glb', size: d.size });
                  } else {
                    __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(_this11.files[0], 'file', d);
                    __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(_this11.files[0], 'name', 'optimized.glb');
                    __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(_this11.files[0], 'size', d.size);
                  }
                }

              case 6:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this11);
      }))();
    },
    fetchSketch: function fetchSketch() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get('https://api.sketchfab.com/v3/models/' + _this12.sketchFabId);

              case 2:
                response = _context11.sent;


                if (response && response.data && response.data.user) {
                  _this12.itemAttributionAuthor = response.data.user.displayName;
                  _this12.itemAttributionAuthorUrl = response.data.user.profileUrl;
                  _this12.itemAttributionTitle = response.data.name;
                  _this12.itemAttributionTitleUrl = response.data.viewerUrl;

                  if (!_this12.itemName || _this12.itemName === '') {
                    _this12.itemName = _this12.itemAttributionTitle;
                  }

                  if (response.data.license && response.data.license.url === 'http://creativecommons.org/licenses/by/4.0/') {
                    _this12.itemAttributionLicense = 'CC BY 4.0';
                  } else {
                    _this12.notify('WARNING: Unknown Sketchfab License');
                  }
                } else {
                  _this12.notify('Error Fetching SketchFab');
                }

              case 4:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this12);
      }))();
    }
  },
  watch: {
    files: function files() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee12() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this13.refreshItem();

              case 1:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this13);
      }))();
    },

    '$route.params.itemId': function $routeParamsItemId(id) {
      this.loadPage();
    },
    scaleFactor: function scaleFactor() {
      this.refreshItem();
    },
    itemSize: function itemSize() {
      this.refreshItem();
    },
    iRotationY: function iRotationY() {
      this.refreshItem();
    },
    color: function color() {
      this.refreshItem();
    },
    metalness: function metalness() {
      this.refreshItem();
    },
    roughness: function roughness() {
      this.refreshItem();
    },
    bumpScale: function bumpScale() {
      this.refreshItem();
    },
    normalMapFile: function normalMapFile() {
      this.refreshItem();
    },
    bumpMapFile: function bumpMapFile() {
      this.refreshItem();
    },
    itemId: function itemId(nv, ov) {
      if (this.itemId) {
        this.$store.dispatch('fetchLootItem', this.itemId);
      }
    }
  }
});

/***/ }),

/***/ "oSIS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oo+N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pMZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  created: function created() {},
  data: function data() {
    return {
      description: {
        title: 'hello!',
        text: 'this is just a test'
      }
    };
  }
});

/***/ }),

/***/ "pgF/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'support',
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  methods: {}
});

/***/ }),

/***/ "qSdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__("pMZz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a072c4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("T6eZ");
function injectStyle (ssrContext) {
  __webpack_require__("/dPA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a072c4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a072c4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qgpy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__User_Avatar__ = __webpack_require__("YpvZ");


//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'User',
  components: {
    UserAvatar: __WEBPACK_IMPORTED_MODULE_2__User_Avatar__["a" /* default */]
  },
  props: ['user_id'],
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // console.log('FETCHING', this.user_id)
              _this.fetched = true;
              _this.$store.dispatch('fetchUser', _this.user_id);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      users: this.$store.state.users,
      fetched: false
    };
  },

  computed: {
    user: function user() {
      return this.users[this.user_id.toLowerCase()];
    }
  }
});

/***/ }),

/***/ "qqoY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bounty-row bounty-grid",on:{"click":_vm.giftSub}},[_c('span',{staticClass:"bounty-grid__rank"},[_vm._v(_vm._s(_vm.rank))]),_vm._v(" "),_c('div',{staticClass:"bounty-row__user"},[_c('user',{attrs:{"user_id":_vm.subBounty.user_id}})],1),_vm._v(" "),_c('span',{staticClass:"bounty-grid__amount"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.subBounty.amount)))]),_vm._v(" "),_c('div',{staticClass:"bounty-grid__action"},[_c('button',{staticClass:"sl-btn sl-btn--ghost sl-btn--sm"},[_vm._v(_vm._s(_vm.btnLabel))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qsJG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_Btn_vue__ = __webpack_require__("b03K");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c092206_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_Btn_vue__ = __webpack_require__("atEt");
function injectStyle (ssrContext) {
  __webpack_require__("fivR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c092206"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_Btn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c092206_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_Btn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rSgh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_Push_Notifications_vue__ = __webpack_require__("vuR3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059f4604_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_Push_Notifications_vue__ = __webpack_require__("j6kf");
function injectStyle (ssrContext) {
  __webpack_require__("oo+N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-059f4604"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_Push_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059f4604_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_Push_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rpM4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tDME":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u4nE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bounties_vue__ = __webpack_require__("dM8B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0292454f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bounties_vue__ = __webpack_require__("H6gW");
function injectStyle (ssrContext) {
  __webpack_require__("VHjs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0292454f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bounties_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0292454f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bounties_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uET0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"inventory-table"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.myFilteredOwnedLootItemIds),function(ownedLootItemId){return _c('tr',{key:ownedLootItemId},[_c('td',{staticStyle:{"height":"30px"}},[(_vm.lootItemForOwnedLootItemId(ownedLootItemId).image_url)?_c('img',{staticClass:"item-image",attrs:{"src":_vm.lootItemImageUrl(_vm.lootItemForOwnedLootItemId(ownedLootItemId))}}):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.lootItemForOwnedLootItemId(ownedLootItemId).name))]),_vm._v(" "),_c('td',[_vm._t("actions",[_vm._v("\n        - \n      ")],{"ownedLootItem":_vm.ownedLootItemForId(ownedLootItemId),"lootItem":_vm.lootItemForOwnedLootItemId(ownedLootItemId)})],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.ownedLootItemForId(ownedLootItemId).quantity))]),_vm._v(" "),_c('td',[_vm._t("numberInRoom",[_vm._v("\n        0 \n      ")],{"ownedLootItem":ownedLootItemId,"lootItem":_vm.lootItemForOwnedLootItemId(ownedLootItemId)})],2)])}),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"10px"},attrs:{"colspan":"5"}},[_vm._v("Want more items for your room? Check out the "),_c('router-link',{attrs:{"to":"/loot-shop"}},[_vm._v("LOOT SHOP")])],1)])],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Image")]),_vm._v(" "),_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Action")]),_vm._v(" "),_c('th',[_vm._v("Quantity")]),_vm._v(" "),_c('th',[_vm._v("# In Room")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uIN5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uOmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Slider_Conrol__ = __webpack_require__("wo/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Combo_Box__ = __webpack_require__("/+6j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pers: 0,
      bet_placed: '',
      placeholder: 'Choose an option',
      selected: { id: undefined, name: undefined },
      valid_amount: false,
      valid_option: false,
      button_value: 'Place Bet'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['currentBalance', 'callFree'])),
  props: ['options'],

  components: {
    sliderConrol: __WEBPACK_IMPORTED_MODULE_1__Slider_Conrol__["a" /* default */],
    comboBox: __WEBPACK_IMPORTED_MODULE_2__Combo_Box__["a" /* default */]
  },
  methods: {
    persChange: function persChange(val) {
      this.bet_placed = Math.floor(this.currentBalance.total * (val / 100));
    },
    betChanged: function betChanged(evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    updateOption: function updateOption(evt) {
      this.selected = evt;
    },
    callPlaceBet: function callPlaceBet() {
      this.$emit('callPlaceBet', this.bet_placed, this.selected.name);
    },
    valueUp: function valueUp() {
      var valDigits = this.bet_placed.toString().length;
      this.bet_placed = parseFloat(this.bet_placed) + Math.pow(10, valDigits - 1);
    },
    valueDown: function valueDown() {
      var valDigits = this.bet_placed.toString().length;
      this.bet_placed = parseFloat(this.bet_placed) - Math.pow(10, valDigits - 1);
    }
  },
  watch: {
    bet_placed: function bet_placed(val) {
      val = parseFloat(val);
      if (val > parseFloat(this.currentBalance.total)) {
        this.persChange(100);
        this.pers = 100;
      } else {
        this.pers = Math.floor(val / parseFloat(this.currentBalance.total) * 100);
        console.log(this.pers);
      }
      this.valid_amount = true;
      if (val < 1) {
        this.valid_amount = false;
      }
    },
    selected: function selected(val) {
      if (val.name) {
        this.valid_option = true;
        console.log(this.valid_option);
      }
    },
    callFree: function callFree() {
      if (this.callFree) {
        this.button_value = 'Place Bet';
        document.getElementsByClassName('balance-row')[0].classList.add('pulse');
      } else {
        document.getElementsByClassName('balance-row')[0].className = 'balance-row';
        this.button_value = 'Processing';
      }
    }
  },
  created: function created() {
    this.bet_placed = Math.floor(parseFloat(this.currentBalance.total) / 10);
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vDKi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"place-bet"}},[_c('table',{staticClass:"bet-form",attrs:{"align":"center"}},[_c('tr',[_c('td',{staticClass:"balance-row",attrs:{"colspan":"4"}},[_c('div',{staticStyle:{"display":"inline-block"}},[_c('h1',[_vm._v("Balance: "+_vm._s(_vm.formatCurrency(_vm.currentBalance.total))+" ")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('tr',[_vm._m(0),_vm._v(" "),_c('td',{staticClass:"input-values"},[_c('comboBox',{attrs:{"id":"bet-option","options":_vm.options,"selected":_vm.selected,"placeholder":_vm.placeholder},on:{"updateOption":function($event){return _vm.updateOption($event)}}})],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('tr',[_vm._m(1),_vm._v(" "),_c('td',{staticClass:"input-values"},[_c('div',{staticStyle:{"display":"inline-block"}},[_c('div',{staticClass:"value-btn",on:{"click":_vm.valueDown}},[_c('img',{staticClass:"value-btn-img",attrs:{"src":__webpack_require__("zpNP")}})]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","vertical-align":"super"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bet_placed),expression:"bet_placed"}],attrs:{"type":"text","placeholder":"Enter Number","id":"bet-amount"},domProps:{"value":(_vm.bet_placed)},on:{"keypress":function($event){return _vm.betChanged($event)},"input":function($event){if($event.target.composing){ return; }_vm.bet_placed=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"value-btn",on:{"click":_vm.valueUp}},[_c('img',{staticClass:"value-btn-img",attrs:{"src":__webpack_require__("WJf4")}})])])])]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('sliderConrol',{staticClass:"slider-conrol",attrs:{"value":_vm.pers},on:{"persChange":function($event){return _vm.persChange($event)}}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('button-a',{staticStyle:{"font-size":"40px","padding":"8px"},attrs:{"button_status":_vm.valid_amount*_vm.valid_option*_vm.callFree},on:{"clicked":_vm.callPlaceBet}},[_vm._v(_vm._s(_vm.button_value))])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"input-title"},[_c('a',[_vm._v("Option: ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"input-title"},[_c('a',[_vm._v("Amount: ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vuR3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'admin-push-notifications',
  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.fetchHistory();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      description: {
        title: 'Admin Push Notifications',
        text: 'Send push notifications to users'
      },
      notification: undefined,
      notificationType: 'info',
      notificationTitle: '',
      notificationMessage: '',
      targetType: 'topic',
      selectedNotificationType: 'live',
      targetUserId: '',
      targetEndpoint: '',
      platforms: {
        ios: true,
        android: true,
        web: false
      },
      includeTwitchDeeplink: true,
      additionalData: '',
      sending: false,
      lastSendResult: null,
      history: [],
      loadingHistory: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])(['currentUser']), {
    isFormValid: function isFormValid() {
      if (!this.notificationTitle || !this.notificationMessage) {
        return false;
      }

      if (this.targetType === 'topic' && !this.selectedNotificationType) {
        return false;
      }

      if (this.targetType === 'user' && !this.targetUserId) {
        return false;
      }

      if (this.targetType === 'endpoint' && !this.targetEndpoint) {
        return false;
      }

      if (!this.platforms.ios && !this.platforms.android && !this.platforms.web) {
        return false;
      }

      return true;
    }
  }),
  methods: {
    fetchHistory: function fetchHistory() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loadingHistory = true;
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/admin/push-notifications/history', { withCredentials: true });

              case 4:
                response = _context2.sent;

                _this2.history = response.data.history || [];
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](1);

                console.error('Error fetching notification history:', _context2.t0);

              case 11:
                _context2.prev = 11;

                _this2.loadingHistory = false;
                return _context2.finish(11);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8, 11, 14]]);
      }))();
    },
    formatTime: function formatTime(dateStr) {
      var d = new Date(dateStr);
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ' ' + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    },
    formatTypeBadge: function formatTypeBadge(entry) {
      if (entry.category === 'live') return 'Live';
      if (entry.type) return entry.type.charAt(0).toUpperCase() + entry.type.slice(1);
      return entry.target_type;
    },
    sendNotification: function sendNotification() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var parsedData, payload, dataObject, response, errorMessage;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.sending = true;
                _this3.lastSendResult = null;

                _context3.prev = 2;

                // Validate JSON if provided
                parsedData = null;

                if (!_this3.additionalData.trim()) {
                  _context3.next = 14;
                  break;
                }

                _context3.prev = 5;

                parsedData = JSON.parse(_this3.additionalData);
                _context3.next = 14;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](5);

                _this3.notify('Invalid JSON in additional data field', 'error');
                _this3.sending = false;
                return _context3.abrupt('return');

              case 14:
                payload = {
                  title: _this3.notificationTitle,
                  message: _this3.notificationMessage,
                  targetType: _this3.targetType,
                  platforms: _this3.platforms
                };


                if (_this3.targetType === 'topic') {
                  if (_this3.selectedNotificationType === 'live') {
                    payload.category = 'live';
                    payload.type = 'all';
                  } else {
                    payload.category = 'update';
                    payload.type = _this3.selectedNotificationType.replace('update_', '');
                  }
                } else if (_this3.targetType === 'user') {
                  payload.userId = _this3.targetUserId;
                } else if (_this3.targetType === 'endpoint') {
                  payload.endpointArn = _this3.targetEndpoint;
                }

                // Build data object with optional Twitch deeplink
                dataObject = parsedData || {};

                if (_this3.includeTwitchDeeplink) {
                  dataObject.twitch_deeplink = 'twitch://stream/swiftor';
                }

                // Only add data to payload if there's something in it
                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dataObject).length > 0) {
                  payload.data = dataObject;
                }

                _context3.next = 21;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/admin/push-notification', payload, { withCredentials: true });

              case 21:
                response = _context3.sent;


                _this3.lastSendResult = {
                  success: true,
                  messageId: response.data.messageId,
                  recipientCount: response.data.recipientCount
                };

                _this3.notify('Push notification sent successfully!', 'success');
                _this3.fetchHistory();
                _context3.next = 34;
                break;

              case 27:
                _context3.prev = 27;
                _context3.t1 = _context3['catch'](2);

                console.error('Error sending notification:', _context3.t1);

                errorMessage = _context3.t1.response && _context3.t1.response.data && _context3.t1.response.data.error && _context3.t1.response.data.error.message || _context3.t1.message;


                _this3.lastSendResult = {
                  success: false,
                  error: errorMessage
                };

                _this3.notify(errorMessage || 'Failed to send notification. Check console for details.', 'error');
                _this3.fetchHistory();

              case 34:
                _context3.prev = 34;

                _this3.sending = false;
                return _context3.finish(34);

              case 37:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[2, 27, 34, 37], [5, 9]]);
      }))();
    },
    resetForm: function resetForm() {
      this.notificationTitle = '';
      this.notificationMessage = '';
      this.targetType = 'topic';
      this.selectedNotificationType = 'live';
      this.targetUserId = '';
      this.targetEndpoint = '';
      this.platforms = {
        ios: true,
        android: true,
        web: false
      };
      this.includeTwitchDeeplink = false;
      this.additionalData = '';
      this.lastSendResult = null;
    },
    notify: function notify(text) {
      var _this4 = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';

      this.notification = text;
      this.notificationType = type;
      setTimeout(function () {
        _this4.notification = undefined;
      }, 5000);
    }
  }
});

/***/ }),

/***/ "wW7H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    clicked: function clicked() {
      this.$emit('clicked');
    }
  },
  data: function data() {
    return {
      button_class: 'btn-disabled'
    };
  },

  props: ['button_status', 'selected'],
  watch: {
    button_status: function button_status(val) {
      console.log('BTN CHNAGED TO: ' + val);
      if (val) {
        this.button_class = 'btn-enabled';
      } else {
        this.button_class = 'btn-disabled';
      }
    }
  },
  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, this.button_class, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'btn-selected', this.selected), _ref;
    }
  },
  created: function created() {
    if (this.button_status === 0) {
      this.button_class = 'btn-disabled';
    } else {
      this.button_class = 'btn-enabled';
    }
  }
});

/***/ }),

/***/ "waJr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"room-item-create"}},[_c('info-box',{attrs:{"description":_vm.description}}),_vm._v(" "),_c('header-title',{attrs:{"title":"ROOM ITEM EDITOR"}}),_vm._v(" "),(_vm.notification)?_c('span',[_vm._v(_vm._s(_vm.notification))]):_vm._e(),_vm._v(" "),_c('div',[_c('div',[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/room-item-management"}},[_vm._v("Back to list")])],1),_vm._v(" "),(_vm.existingItem)?_c('div',[_vm._v("Editing Existing Item: "+_vm._s(_vm.existingItem.id))]):_c('div',[_vm._v("Creating New Item")]),_vm._v(" "),(_vm.existingItem)?_c('div',[_c('button',{on:{"click":_vm.giveMeItem}},[_vm._v("Give Me This Item")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","vertical-align":"super"}},[_c('div',{ref:"roomcontainer",staticStyle:{"width":"500px","float":"right"},attrs:{"id":"room-container"}}),_vm._v(" "),_c('table',{staticClass:"editor-table"},[_vm._m(0),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Item Type")]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItemType),expression:"selectedItemType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedItemType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("3d")]),_vm._v(" "),_c('option',{attrs:{"value":"wall"}},[_vm._v("poster")]),_vm._v(" "),_c('option',{attrs:{"value":"rug"}},[_vm._v("rug")]),_vm._v(" "),_c('option',[_vm._v("2d")]),_vm._v(" "),_c('option',[_vm._v("wallBase")]),_vm._v(" "),_c('option',[_vm._v("floorBase")])])]),_c('td',[_vm._v("Type of item")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Zip Optimization")]),_c('td',[(!_vm.files[0])?_c('file-upload',{ref:"uploadOptimize",attrs:{"input-id":"uploadOptimize"},model:{value:(_vm.fileToOptimize),callback:function ($$v) {_vm.fileToOptimize=$$v},expression:"fileToOptimize"}},[(!_vm.fileToOptimize[0])?_c('button',[_vm._v("Upload File To Optimize")]):_c('span',[_vm._v(_vm._s(_vm.fileToOptimize[0].name))])]):_vm._e(),(_vm.fileToOptimize[0] && !_vm.files[0])?_c('button',{on:{"click":_vm.sendOptimize}},[_vm._v("Optimize Zip")]):_vm._e()],1),_c('td',[_vm._v("Use this only if you have a zip (only tested with sketchFab gltf zips)")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Model/Texture File")]),_c('td',[_c('file-upload',{ref:"upload1",attrs:{"input-id":"upload1"},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},[(!_vm.files[0])?_c('button',[_vm._v("Upload Model/Texture File")]):_c('span',[_vm._v(_vm._s(_vm.files[0].name))])])],1),_c('td',[(_vm.isTextureItem(_vm.itemType))?_c('img',{staticStyle:{"width":"100px"},attrs:{"src":_vm.assetUrl}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Thumbnail Image")]),_c('td',[_c('button',{on:{"click":_vm.takeThumbnail}},[_vm._v("Snap Thumbnail")])]),_c('td',[(_vm.thumbnailUrl)?_c('img',{staticStyle:{"width":"100px"},attrs:{"src":_vm.thumbnailUrl}}):_vm._e()])]),_vm._v(" "),(!_vm.is2dItem(_vm.itemType))?_c('tr',[_c('td',[_vm._v("TOTAL TRIANGLES:")]),_c('td',[_vm._v(_vm._s(_vm.itemTriangles))]),_c('td',[_vm._v("Lower the better ~100-5000")])]):_vm._e(),_vm._v(" "),(_vm.files[0])?_c('tr',[_c('td',[_vm._v("FILE SIZE:")]),_c('td',[_vm._v(_vm._s(_vm.files[0].size))]),_c('td',[_vm._v("Lower the better ~100000 (100k) to 5000000 (5mb)")])]):_vm._e(),_vm._v(" "),(_vm.showColor)?_c('tr',[_c('td',[_vm._v("Color")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.color),expression:"color"}],attrs:{"type":"color","align":"center"},domProps:{"value":(_vm.color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.color=$event.target.value}}}),_vm._v(" "+_vm._s(_vm.color))]),_c('td')]):_vm._e(),_vm._v(" "),(_vm.showRoughness)?_c('tr',[_c('td',[_vm._v("Roughness")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.roughness),expression:"roughness"}],attrs:{"type":"text","placeholder":"Enter Number","align":"center"},domProps:{"value":(_vm.roughness)},on:{"input":function($event){if($event.target.composing){ return; }_vm.roughness=$event.target.value}}})]),_c('td',[_vm._v("Between 0-1 ie 0.5")])]):_vm._e(),_vm._v(" "),(_vm.showMetalness)?_c('tr',[_c('td',[_vm._v("Metalness")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.metalness),expression:"metalness"}],attrs:{"type":"text","placeholder":"Enter Number","align":"center"},domProps:{"value":(_vm.metalness)},on:{"input":function($event){if($event.target.composing){ return; }_vm.metalness=$event.target.value}}})]),_c('td',[_vm._v("Between 0-1 ie 0.5")])]):_vm._e(),_vm._v(" "),(_vm.showBumpMap)?_c('tr',[_c('td',[_vm._v("Bump Map")]),_c('td',[_c('file-upload',{ref:"upload3",attrs:{"input-id":"upload3"},model:{value:(_vm.bumpMapFile),callback:function ($$v) {_vm.bumpMapFile=$$v},expression:"bumpMapFile"}},[(!_vm.bumpMapFile[0])?_c('button',[_vm._v("Upload Bump File")]):_c('span',[_vm._v(_vm._s(_vm.bumpMapFile[0].name))])])],1),_c('td',[(_vm.bumpMapFileName)?_c('img',{staticStyle:{"width":"100px"},attrs:{"src":_vm.lootItemItemUrl(_vm.bumpMapFileName)}}):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.showNormalMap)?_c('tr',[_c('td',[_vm._v("Normal Map")]),_c('td',[_c('file-upload',{ref:"upload4",attrs:{"input-id":"upload4"},model:{value:(_vm.normalMapFile),callback:function ($$v) {_vm.normalMapFile=$$v},expression:"normalMapFile"}},[(!_vm.normalMapFile[0])?_c('button',[_vm._v("Upload Normal Map File")]):_c('span',[_vm._v(_vm._s(_vm.normalMapFile[0].name))])])],1),_c('td',[_vm._v(_vm._s(_vm.normalMapFileName)),(_vm.normalMapFileName !== undefined)?_c('img',{staticStyle:{"width":"100px"},attrs:{"src":_vm.lootItemItemUrl(_vm.normalMapFileName)}}):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.showBumpScale)?_c('tr',[_c('td',[_vm._v("Bump/Normal Scale")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bumpScale),expression:"bumpScale"}],attrs:{"type":"text","placeholder":"Enter Number","align":"center"},domProps:{"value":(_vm.bumpScale)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bumpScale=$event.target.value}}})]),_c('td')]):_vm._e(),_vm._v(" "),(!_vm.is2dItem(_vm.itemType))?_c('tr',[_c('td',[_vm._v("scaleFactor")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.scaleFactor),expression:"scaleFactor"}],attrs:{"type":"text","placeholder":"Enter Number","align":"center"},domProps:{"value":(_vm.scaleFactor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.scaleFactor=$event.target.value}}})]),_c('td',[_vm._v("How big. To make smaller go between 0.01 and 1. Bigger > 1")])]):_vm._e(),_vm._v(" "),(_vm.is2dItem(_vm.itemType))?_c('tr',[_c('td',[_vm._v("width")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemSize),expression:"itemSize"}],attrs:{"type":"text","placeholder":"Enter Number","align":"center"},domProps:{"value":(_vm.itemSize)},on:{"input":function($event){if($event.target.composing){ return; }_vm.itemSize=$event.target.value}}})]),_c('td',[_vm._v("How wide. In centimeters.")])]):_vm._e(),_vm._v(" "),(_vm.itemType === '2d')?_c('tr',[_c('td',[_vm._v("depth")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemDepth),expression:"itemDepth"}],attrs:{"type":"text","placeholder":"Enter Number","align":"center"},domProps:{"value":(_vm.itemDepth)},on:{"input":function($event){if($event.target.composing){ return; }_vm.itemDepth=$event.target.value}}})]),_c('td',[_vm._v("How deep. In centimeters.")])]):_vm._e(),_vm._v(" "),(_vm.itemType === '2d')?_c('tr',[_c('td',[_vm._v("height")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemHeight),expression:"itemHeight"}],attrs:{"type":"text","placeholder":"Enter Number","align":"center"},domProps:{"value":(_vm.itemHeight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.itemHeight=$event.target.value}}})]),_c('td',[_vm._v("How high (usually can leave blank). In centimeters.")])]):_vm._e(),_vm._v(" "),(!_vm.is2dItem(_vm.itemType))?_c('tr',[_c('td',[_vm._v("iRotationY")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.iRotationY),expression:"iRotationY"}],attrs:{"type":"text","placeholder":"Enter Number","align":"center"},domProps:{"value":(_vm.iRotationY)},on:{"input":function($event){if($event.target.composing){ return; }_vm.iRotationY=$event.target.value}}})]),_c('td',[_vm._v("The way it is facing in degrees")])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Name")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemName),expression:"itemName"}],attrs:{"type":"text","placeholder":"Enter","align":"center"},domProps:{"value":(_vm.itemName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.itemName=$event.target.value}}})]),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Rarity")]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemRarity),expression:"itemRarity"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.itemRarity=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("common")]),_vm._v(" "),_c('option',[_vm._v("uncommon")]),_vm._v(" "),_c('option',[_vm._v("rare")]),_vm._v(" "),_c('option',[_vm._v("legendary")]),_vm._v(" "),_c('option',[_vm._v("exotic")])])]),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("For Sale?")]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemForSale),expression:"itemForSale"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.itemForSale=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":true}},[_vm._v("true")]),_vm._v(" "),_c('option',{domProps:{"value":false}},[_vm._v("false")])])]),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Price")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemPrice),expression:"itemPrice"}],attrs:{"type":"text","placeholder":"Enter","align":"center"},domProps:{"value":(_vm.itemPrice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.itemPrice=$event.target.value}}})]),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Currency Type")]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemPriceCurrencyType),expression:"itemPriceCurrencyType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.itemPriceCurrencyType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',[_vm._v("sb")]),_vm._v(" "),_c('option',{attrs:{"value":"mt"}},[_vm._v("mt (gold)")])])]),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Description")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemDescription),expression:"itemDescription"}],attrs:{"type":"text","placeholder":"Enter","align":"center"},domProps:{"value":(_vm.itemDescription)},on:{"input":function($event){if($event.target.composing){ return; }_vm.itemDescription=$event.target.value}}})]),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Max Allowed")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemMaxAllowed),expression:"itemMaxAllowed"}],attrs:{"type":"text","placeholder":"Enter","align":"center"},domProps:{"value":(_vm.itemMaxAllowed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.itemMaxAllowed=$event.target.value}}})]),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Sub Category 1")]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemSubCategory1),expression:"itemSubCategory1"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.itemSubCategory1=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("none")]),_vm._v(" "),_vm._l((_vm.subCategory1Options),function(item){return _c('option',{key:item},[_vm._v(_vm._s(item))])})],2)]),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Sub Category 2")]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemSubCategory2),expression:"itemSubCategory2"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.itemSubCategory2=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("none")]),_vm._v(" "),_vm._l((_vm.subCategory2Options),function(item){return _c('option',{key:item},[_vm._v(_vm._s(item))])})],2)]),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Collection")]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemCollection1),expression:"itemCollection1"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.itemCollection1=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("none")]),_vm._v(" "),_vm._l((_vm.collection1Options),function(item){return _c('option',{key:item},[_vm._v(_vm._s(item))])})],2)]),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Sketchfab Attribution Import")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sketchFabId),expression:"sketchFabId"}],attrs:{"type":"text","placeholder":"Enter","align":"center"},domProps:{"value":(_vm.sketchFabId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sketchFabId=$event.target.value}}}),_c('br'),_c('button',{on:{"click":_vm.fetchSketch}},[_vm._v("Sketchfab Fetch")])]),_c('td',[_vm._v("Enter the SketchFab ID here. Example: 61fc4b5c337f4169a5e26e1c40e92e28")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Attribution Author")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemAttributionAuthor),expression:"itemAttributionAuthor"}],attrs:{"type":"text","placeholder":"Enter","align":"center"},domProps:{"value":(_vm.itemAttributionAuthor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.itemAttributionAuthor=$event.target.value}}})]),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Attribution Author URL")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemAttributionAuthorUrl),expression:"itemAttributionAuthorUrl"}],attrs:{"type":"text","placeholder":"Enter","align":"center"},domProps:{"value":(_vm.itemAttributionAuthorUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.itemAttributionAuthorUrl=$event.target.value}}})]),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Attribution Title")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemAttributionTitle),expression:"itemAttributionTitle"}],attrs:{"type":"text","placeholder":"Enter","align":"center"},domProps:{"value":(_vm.itemAttributionTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.itemAttributionTitle=$event.target.value}}})]),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Attribution Title URL")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemAttributionTitleUrl),expression:"itemAttributionTitleUrl"}],attrs:{"type":"text","placeholder":"Enter","align":"center"},domProps:{"value":(_vm.itemAttributionTitleUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.itemAttributionTitleUrl=$event.target.value}}})]),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Attribution License")]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemAttributionLicense),expression:"itemAttributionLicense"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.itemAttributionLicense=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("none")]),_vm._v(" "),_c('option',[_vm._v("CC BY 4.0")])])]),_c('td',[_vm._v(_vm._s(_vm.itemAttributionLicenseUrl))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"center"},attrs:{"colspan":"3"}},[_c('button',{on:{"click":_vm.save}},[_vm._v("Save")])])])])])]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px"}},[_vm._v("All items VIRTUAL. You are not buying physical items!")]),_vm._v(" "),_c('span',{staticClass:"copyright"},[_vm._v("All product names, logos, and brands are property of their respective owners. All company, product and service names used in this website are for identification purposes only. Use of these names, logos, and brands does not imply endorsement.")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Name")]),_c('th',[_vm._v("Value")]),_c('th',{staticStyle:{"width":"250px"}},[_vm._v("Desc")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wkEd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bet)?_c('div',[_c('table',[_c('tr',{staticStyle:{"width":"100%"}},[_c('td',{staticStyle:{"width":"10%"},on:{"click":_vm.hideBet}}),_vm._v(" "),_c('td',{staticStyle:{"width":"80%"}},[_c('div',{staticClass:"center",on:{"click":function($event){return _vm.showBet()}}},[_c('table',{staticStyle:{"border-collapse":"collapse"}},[_c('tr',[_c('td',{class:'stat-bar-'+_vm.betStatus,attrs:{"rowspan":"4"}}),_vm._v(" "),_c('td',[_c('div',[_c('table',[_c('tr',[_c('td',{staticClass:"bet-title",attrs:{"colspan":"2"}},[_vm._v("\n                        "+_vm._s(_vm.bet.keyword)+"\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"bet-info"},[_c('div',[_c('div',[_c('span',{staticClass:"bet-info-title"},[_vm._v("Status: ")]),_vm._v(" "),_c('span',{staticClass:"bet-info-text"},[_vm._v(_vm._s(_vm.betStatus))])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"bet-info-title"},[_vm._v("Created At: ")]),_vm._v(" "),_c('span',{staticClass:"bet-info-text"},[_vm._v(_vm._s(_vm.getLocalDate(_vm.bet.created_at)))])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"bet-info-title"},[_vm._v("The Pot: ")]),_vm._v(" "),_c('span',{staticClass:"bet-info-text"},[_vm._v(_vm._s(_vm.formatCurrency(_vm.bet.total)))])]),_vm._v(" "),(_vm.showPlaced)?_c('div',[_c('span',{staticClass:"bet-info-title"},[_vm._v("Participants count: ")]),_vm._v(" "),_c('span',{staticClass:"bet-info-text"},[_vm._v(_vm._s(_vm.bet.participantsCount))])]):_vm._e()])]),_vm._v(" "),_c('td',{staticClass:"bet-option-box"},[_c('div',{staticClass:"bet-options"},_vm._l((_vm.bet.bet_options),function(option){return _c('div',{key:option.name,class:{ 'bet-option winner' : _vm.bet.winning_option_number === option.option_number , 'bet-option' : _vm.bet.winning_option_number != option.option_number}},[_vm._v(_vm._s(option.name)+"\n                            "),_c('span',{staticClass:"bet-multiplier"},[_vm._v("("+_vm._s(_vm.formatCurrency(option.multiplier))+"x)")]),_vm._v(" "),(_vm.bet.winning_option_number === option.option_number)?_c('span',[_vm._v("(WINNER)")]):_vm._e()])}),0)])])])])]),_vm._v(" "),_c('td',{class:'stat-bar-'+_vm.betStatus,attrs:{"rowspan":"4"}})])]),_vm._v(" "),_c('div',[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.showPlaced)?_c('div',[_c('br'),_vm._v(" "),(_vm.$store.state.currentUser&&_vm.betStatus=='Open')?_c('placeBet',{attrs:{"options":_vm.bet.bet_options},on:{"callPlaceBet":_vm.callPlaceBet}}):_vm._e(),_vm._v(" "),(!_vm.$store.state.currentUser&&_vm.betStatus=='Open')?_c('login-btn',{staticStyle:{"display":"inline-block"}},[_vm._v("Login to place a bet")]):_vm._e(),_vm._v(" "),(_vm.myBets.length > 0)?_c('div',[_c('div',{staticStyle:{"font-weight":"bold"}},[_vm._v("My Bets")]),_vm._v(" "),(_vm.showPlaced)?_c('placed-bets',{attrs:{"bet_id":_vm.bet.id,"placed_bets":_vm.myBets,"size":"mini"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-weight":"bold"}},[_vm._v("Placed Bets")]),_vm._v(" "),(_vm.showPlaced)?_c('placed-bets',{attrs:{"bet_id":_vm.bet.id,"placed_bets":_vm.placedBets}}):_vm._e()],1):_vm._e()])],1)])]),_vm._v(" "),_c('td',{staticStyle:{"width":"10%"},on:{"click":_vm.hideBet}})])]),_vm._v(" "),_c('br')]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wmGc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-title',{attrs:{"title":"SUPPORT"}}),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"support"},[_c('h2',[_vm._v("Support")]),_vm._v(" "),_c('p',[_vm._v("For any questions or help, please contact "),_c('a',{attrs:{"href":"mailto:joseph@swiftor.com"}},[_vm._v("joseph@swiftor.com")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wo/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_Conrol_vue__ = __webpack_require__("LYVf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0954971e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider_Conrol_vue__ = __webpack_require__("1H49");
function injectStyle (ssrContext) {
  __webpack_require__("CvRS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0954971e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_Conrol_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0954971e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider_Conrol_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wvpE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AchievementProgressBar_vue__ = __webpack_require__("+Bl8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b6795d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AchievementProgressBar_vue__ = __webpack_require__("zCoQ");
function injectStyle (ssrContext) {
  __webpack_require__("ItZT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AchievementProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b6795d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AchievementProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: {
    config: function config() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].config;
    }
  }
});

/***/ }),

/***/ "xMGV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('span',{staticClass:"mini-user-display"},[_c('span',{staticClass:"mini-user-profile-image"},[_c('user-avatar',{attrs:{"name":_vm.user.display_name || _vm.user.twitch_name,"src":_vm.user.profile_image_url}})],1),_vm._v(" "),_c('span',{staticClass:"mini-user-name"},[_vm._v(_vm._s(_vm.user.display_name))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y7Ye":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yVmx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zCoQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"20px","margin-top":"5px"}},[_c('div',{staticClass:"main-bar"},[_c('div',{staticClass:"completed-bar",style:({width: _vm.completedWidth})},[_c('div',{staticClass:"completed-bar-fill"}),_vm._v(" "),_c('div',{staticClass:"shimmer",style:({animationDelay: Math.random() * 0.8 + 's'})})]),_vm._v(" "),_vm._l((_vm.achievementPoints),function(achievement,index){return _c('div',{key:index,staticClass:"achievement-point",style:({left: ("calc(" + (achievement.requirement * 100) + "%)")})},[(achievement.reward)?_c('div',{staticClass:"achievement-text",style:({
        color: achievement.requirement <= _vm.progress ? 'yellow' : 'dimgray',
        transform: ("translate( " + (achievement.requirement * 100 * -1 + '%') + ", 12px)")
      })},[_vm._v(_vm._s(achievement.reward))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"achievement-dot",style:({
        borderColor: achievement.requirement <= _vm.progress ? '#8deb16' : 'gray',
        backgroundColor: achievement.requirement <= _vm.progress ? '#457c00' : 'black'
      })},[_c('div',{staticClass:"dot-shimmer",style:({
        borderColor: achievement.requirement <= _vm.progress ? '#8deb16' : 'gray',
        animationDelay: Math.random() * 3.5 + 's'
      })})])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zLEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_Status_vue__ = __webpack_require__("2nGB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba5f5284_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_Status_vue__ = __webpack_require__("HP7v");
function injectStyle (ssrContext) {
  __webpack_require__("6SV5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ba5f5284"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_Status_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba5f5284_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_Status_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zZHJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__User__ = __webpack_require__("jyJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InventoryBrowser__ = __webpack_require__("J2ke");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobile_device_detect__ = __webpack_require__("nBUE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mobile_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mobile_device_detect__);




//
//
//
//
//
//
//
//
//
//
//
//
//








var scriptLoaded = false;
var scriptFinished = false;

/* global SwiftorRooms */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'room-browser',
  props: ['twitch_name_prop'],
  components: {
    User: __WEBPACK_IMPORTED_MODULE_4__User__["a" /* default */],
    InventoryBrowser: __WEBPACK_IMPORTED_MODULE_5__InventoryBrowser__["a" /* default */]
  },
  data: function data() {
    return {
      roomDisplayed: false,
      room: undefined,
      roomManager: undefined,
      roomObjectMap: {},
      wallParams: {},
      floorParams: {},
      notification: undefined,
      room_user_id: undefined,
      newerRooms: undefined,
      olderRooms: undefined
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])(['currentUser', 'noCurrentUser']), {
    isMobileBrowser: function isMobileBrowser() {
      return __WEBPACK_IMPORTED_MODULE_9_mobile_device_detect__["isMobile"];
    },
    user: function user() {
      if (this.room_user_id) {
        return this.$store.state.users[this.room_user_id];
      } else {
        return this.currentUser;
      }
    },
    user_id: function user_id() {
      return this.room_user_id;
    },

    // twitch_name () {
    //   if (this.room_user_id) {
    //     return this.$store.state.users[this.room_user_id].twitch_name
    //   } else {
    //     return this.currentUser.twitch_name
    //   }
    // },
    editable: function editable() {
      return this.user && this.currentUser && this.user.id === this.currentUser.id;
    },
    showBrowser: function showBrowser() {
      return this.editable && this.roomManager;
    },
    showLogin: function showLogin() {
      return !this.user; // && !this.twitch_name
    }
  }),
  watch: {
    '$route': function $route() {
      this.roomDisplayed = false;
    },
    room_user_id: function room_user_id(nv, ov) {
      if (this.room_user_id) {
        this.$store.dispatch('fetchUser', this.room_user_id);
      }
    },
    room: function room(nv, ov) {
      this.displayRoom();
    },
    user: function user(nv, ov) {
      this.displayRoom();
    },

    // twitch_name (nv, ov) {
    //   if (this.twitch_name) {
    //     this.$store.dispatch('fetchUserByTwitchName', this.twitch_name)
    //   }
    // },
    '$route.path': function $routePath(to, from) {}
  },
  updated: function updated() {},
  destroyed: function destroyed() {},
  mounted: function mounted() {
    var _this = this;

    if (this.user) {
      this.fetchLatestRoom().then(function () {
        _this.displayRoom();
      });
    }
  },

  created: function created() {
    var _this2 = this;

    if (!scriptLoaded) {
      if (this.twitch_name_prop) {
        this.$store.dispatch('fetchUserByTwitchName', this.twitch_name_prop);
      }

      var roomScript = document.createElement('script');
      roomScript.setAttribute('src', __WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.ROOM_JS_URL);
      document.head.appendChild(roomScript);

      roomScript.onload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                scriptFinished = true;

                _context.next = 3;
                return _this2.fetchLatestRoom();

              case 3:
                _this2.displayRoom();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      scriptLoaded = roomScript;
    }

    this.roomScript = scriptLoaded;
  },
  methods: {
    nextRoom: function nextRoom() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/rooms?olderThan=' + Date.parse(_this3.room.updated_at), { withCredentials: true });

              case 2:
                response = _context2.sent;

                if (response.data.room) {
                  _this3.room = response.data.room;
                  _this3.room_user_id = response.data.room.user_id;
                  _this3.newerRooms = response.data.newerRooms;
                  _this3.olderRooms = response.data.olderRooms;
                }

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    previousRoom: function previousRoom() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/rooms?newerThan=' + Date.parse(_this4.room.updated_at), { withCredentials: true });

              case 2:
                response = _context3.sent;

                if (response.data.room) {
                  _this4.room = response.data.room;
                  _this4.room_user_id = response.data.room.user_id;
                  _this4.newerRooms = response.data.newerRooms;
                  _this4.olderRooms = response.data.olderRooms;
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    fetchLatestRoom: function fetchLatestRoom() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/rooms', { withCredentials: true });

              case 2:
                response = _context4.sent;

                if (response.data.room) {
                  _this5.room = response.data.room;
                  _this5.room_user_id = response.data.room.user_id;
                  _this5.newerRooms = response.data.newerRooms;
                  _this5.olderRooms = response.data.olderRooms;
                }

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    copyToClipboard: function copyToClipboard() {
      var el = document.createElement('textarea');
      // console.log(this.user)
      el.value = 'https://swiftorland.com/#/rooms/' + encodeURIComponent(this.user.twitch_name);
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      this.notify('https://swiftorland.com/#/rooms/' + this.user.twitch_name + ' copied to clipboard!');
    },
    isRoomItem: function isRoomItem(lootItem) {
      return lootItem.meta.objectType === '2d' || lootItem.meta.objectType === '3d' || lootItem.meta.objectType === 'wall';
    },
    isWallBaseItem: function isWallBaseItem(lootItem) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      var res = lootItem.meta.objectType === 'wallBase';
      if (position) {
        res = res && (!this.wallParams[position] || this.wallParams[position].loot_item_id !== lootItem.id);
      }
      return res;
    },
    isFloorBaseItem: function isFloorBaseItem(lootItem) {
      return lootItem.meta.objectType === 'floorBase';
    },
    isCurrentFloorBaseItem: function isCurrentFloorBaseItem(lootItem) {
      return lootItem.id === this.floorParams.loot_item_id;
    },
    canPlaceInRoom: function canPlaceInRoom(lootItemId, ownedLootItem) {
      var nir = this.numberInRoom(lootItemId);
      return nir < ownedLootItem.quantity && nir <= 10;
    },
    numberInRoom: function numberInRoom(lootItemId) {
      if (this.roomManager && this.roomManager.room) {
        return this.roomObjectMap[lootItemId] ? this.roomObjectMap[lootItemId].length : 0;
      } else {
        return 66;
      }
    },
    saveRoom: function saveRoom() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.CURRENCY_SERVICE_BASE_URL + '/rooms/' + _this6.currentUser.id.toString(), {
                  'items': _this6.roomParams().items,
                  'walls': _this6.wallParams,
                  'floor': _this6.floorParams
                }, { withCredentials: true });

              case 2:
                response = _context5.sent;

                if (response.data.room) {
                  _this6.notify('Room Saved.');
                } else {
                  _this6.notify('ERROR SAVING.');
                }

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    notify: function notify(text) {
      var _this7 = this;

      this.notification = text;
      setTimeout(function () {
        _this7.notification = undefined;
      }, 5000);
    },
    roomParams: function roomParams() {
      var _this8 = this;

      var items = [];

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.roomObjectMap).forEach(function (lootItemId) {
        _this8.roomObjectMap[lootItemId].forEach(function (roomObject) {
          items.push({
            loot_item_id: lootItemId,
            meta: roomObject.toMeta()
          });
        });
      });
      return {
        items: items
      };
    },
    setWallBase: function setWallBase(position, ownedLootItem, lootItem) {
      if (this.wallParams[position] && this.wallParams[position].loot_item_id === lootItem.id) {
        return this.removeWallBase(position);
      }
      this.roomManager.room.createWall(position, lootItem.meta);
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(this.wallParams, position, { loot_item_id: lootItem.id });
    },
    removeWallBase: function removeWallBase(position) {
      this.roomManager.room.createWall(position);
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(this.wallParams, position, undefined);
    },
    setFloorBase: function setFloorBase(ownedLootItem, lootItem) {
      if (this.floorParams && this.floorParams.loot_item_id === lootItem.id) {
        return this.removeFloorBase();
      }
      // console.log('CREATEING FLOOR', lootItem.meta)
      this.roomManager.room.createFloor(lootItem.meta);
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(this.floorParams, 'loot_item_id', lootItem.id);
    },
    removeFloorBase: function removeFloorBase() {
      this.roomManager.room.createFloor();
      this.floorParams = {};
    },
    addToRoom: function addToRoom(ownedLootItem, lootItem) {
      var roomObject = this.roomManager.room.addRoomObject(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, ownedLootItem.meta, lootItem.meta));
      var arr = this.roomObjectMap[lootItem.id] || [];
      // this.roomObjectMap[lootItem.id] = this.roomObjectMap[lootItem.id] || []
      arr.push(roomObject);
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(this.roomObjectMap, lootItem.id, arr);
      return roomObject;
    },
    removeFromRoom: function removeFromRoom(ownedLootItem, lootItem) {
      var roomObject = this.roomObjectMap[lootItem.id][0];
      var arr = this.roomObjectMap[lootItem.id] || [];
      __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(this.roomObjectMap, lootItem.id, arr.splice(1));
      this.roomManager.room.removeRoomObject(roomObject.uuid);
    },
    roomItemToRoomObject: function roomItemToRoomObject(roomItem) {
      /*
      {
        loot_item_id: "",
        meta: "",
        loot_item: {}
      }
      */
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, roomItem.meta, roomItem.loot_item.meta);
    },
    displayRoom: function displayRoom() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var container;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!scriptFinished || !_this9.user || _this9.roomDisplayed === _this9.room_user_id || !_this9.room)) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt('return');

              case 4:
                if (!(_this9.roomDisplayed !== _this9.room_user_id)) {
                  _context6.next = 21;
                  break;
                }

                _this9.roomDisplayed = _this9.room_user_id;

                // this.room = undefined
                if (_this9.roomManager) {
                  _this9.roomManager.quit();
                }
                // this.roomManager = undefined
                _this9.roomObjectMap = {};

                // this.room = response.data.room

                container = document.getElementById('room-container');

                if (container) {
                  container.innerHTML = '';
                  // console.log('Container Found')
                } else {}
                  // console.log('Container Not Found')


                  // if(!this.roomManager) {
                _this9.roomManager = new SwiftorRooms.RoomManager(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({
                  container: document.getElementById('room-container'),
                  assetBaseUrl: __WEBPACK_IMPORTED_MODULE_6_vue__["default"].config.ITEM_ASSET_BASE_URL,
                  editable: _this9.editable,
                  isMobile: __WEBPACK_IMPORTED_MODULE_9_mobile_device_detect__["isMobile"]
                }));
                // }

                _this9.roomManager.start();

                if (_this9.room.meta && _this9.room.meta.wallParams) {
                  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this9.room.meta.wallParams).forEach(function (k) {
                    __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(_this9.wallParams, k, { loot_item_id: _this9.room.meta.wallParams[k].loot_item_id });
                    _this9.room.meta.wallParams[k] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(_this9.room.meta.wallParams[k], _this9.room.meta.wallParams[k].loot_item.meta);
                  });
                }

                if (_this9.room.meta && _this9.room.meta.floorParams) {
                  _this9.floorParams = { loot_item_id: _this9.room.meta.floorParams.loot_item_id };
                  _this9.room.meta.floorParams = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(_this9.room.meta.floorParams, _this9.room.meta.floorParams.loot_item.meta);
                }

                _context6.next = 16;
                return _this9.roomManager.loadRoom(_this9.room.meta);

              case 16:

                // let roomObjects = []
                if (_this9.room.item_meta && _this9.room.item_meta.items) {
                  // roomObjects = response.data.room.item_meta.items.map(i => this.roomItemToRoomObject(i))
                  _this9.room.item_meta.items.forEach(function (ri) {
                    _this9.addToRoom(ri, ri.loot_item);
                  });
                }
                // await this.roomManager.loadRoom(Object.assign({roomObjects: roomObjects}, this.room.meta))

                _this9.roomManager.gameLoop();

                // console.log('Room Displayed 1', this.roomDisplayed, this.room_user_id)
                _this9.roomDisplayed = _this9.room_user_id;
                // console.log('Room Displayed 2', this.roomDisplayed, this.room_user_id)
                _context6.next = 21;
                break;

              case 21:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    }
  }
});

/***/ }),

/***/ "zpNP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjIwMHB4IiBoZWlnaHQ9IjE1MHB4IiB2aWV3Qm94PSIwIDAgMjAwIDE1MCI+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9IkdyYWRpZW50XzEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iLTAuMDI1MDAwMDAwMDAwMDA1Njg0IiB5MT0iNzUiIHgyPSIxMDAuMDI1IiB5Mj0iNzUiIHNwcmVhZE1ldGhvZD0icGFkIj4KPHN0b3AgIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNGRkZGRkYiLz4KCjxzdG9wICBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNBNEE0QTQiLz4KPC9saW5lYXJHcmFkaWVudD4KCjxsaW5lYXJHcmFkaWVudCBpZD0iR3JhZGllbnRfMiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSIxMDAuMDI1IiB5MT0iNzUiIHgyPSIxOTkuOTc1IiB5Mj0iNzUiIHNwcmVhZE1ldGhvZD0icGFkIj4KPHN0b3AgIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNGRkZGRkYiLz4KCjxzdG9wICBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNBNEE0QTQiLz4KPC9saW5lYXJHcmFkaWVudD4KCjxnIGlkPSJMYXllcjBfMF9GSUxMIj4KPHBhdGggZmlsbD0idXJsKCNHcmFkaWVudF8xKSIgc3Ryb2tlPSJub25lIiBkPSIKTSAwIDAKTCAwIDcwLjQgMTAwLjA1IDE1MCAxMDAuMDUgNzIuOCAwIDAgWiIvPgoKPHBhdGggZmlsbD0idXJsKCNHcmFkaWVudF8yKSIgc3Ryb2tlPSJub25lIiBkPSIKTSAyMDAgNzAuNQpMIDIwMCAwLjA1IDEwMC4wNSA3Mi44IDEwMC4wNSAxNTAgMjAwIDcwLjUgWiIvPgo8L2c+CjwvZGVmcz4KCjxnIHRyYW5zZm9ybT0ibWF0cml4KCAxLCAwLCAwLCAxLCAwLDApICI+Cjx1c2UgeGxpbms6aHJlZj0iI0xheWVyMF8wX0ZJTEwiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "zuBa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('info-box',{attrs:{"description":_vm.description}}),_vm._v(" "),_c('header-title',{attrs:{"title":"RATES"}}),_vm._v(" "),(_vm.userRates && _vm.currentUser)?_c('div',{staticStyle:{"overflow-y":"auto"},style:({maxHeight: '85%'})},[_c('div',{staticClass:"rate-title"},[_c('div',{style:({fontSize: '1.5rem', fontWeight: 700})},[_vm._v("Your Rate")]),_vm._v(" "),_c('div',{style:({fontSize: '2rem'})},[_vm._v(_vm._s(_vm.formatCurrency(_vm.userRates.rate * 100))+"%")])]),_vm._v(" "),_c('div',{staticClass:"rates-cont"},[_c('div',{staticClass:"rate-box"},[_c('div',{staticClass:"rate-info"},[_c('div',{staticClass:"title"},[_vm._v("Discord Connection")]),_vm._v(" "),_c('div',{staticClass:"rate-val"},[_vm._v("+"+_vm._s(_vm.formatCurrency(_vm.userRates.discord * 100))+"%")])]),_vm._v(" "),_c('AchievementProgressBar',{attrs:{"progress":_vm.userRates.discord * 20,"achievements":[{reward: '+5% Bonus', requirement: 1}]}}),_vm._v(" "),_c('div',{staticClass:"rate-desc"},[_c('div',[_c('div',[_vm._v(_vm._s(_vm.userRates.discord != 0 ? 'Thanks for connecting your Discord to Swiftorland - this is your 5% bonus!' : 'Click on the Discord logo on the todiv right to get a 5% bonus for connecting your Discord account!'))])])])],1),_vm._v(" "),_c('div',{staticClass:"rate-box"},[_c('div',{staticClass:"rate-info"},[_c('div',{staticClass:"title"},[_vm._v("Sub Tier")]),_vm._v(" "),_c('div',{staticClass:"rate-val"},[_vm._v("+"+_vm._s(_vm.formatCurrency(_vm.userRates.subLevel * 100))+"%")])]),_vm._v(" "),_c('AchievementProgressBar',{attrs:{"progress":(_vm.userRates.subLevel) / 10,"achievements":[{reward: "+1000% Bonus", requirement: 1}]}}),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"rate-box"},[_c('div',{staticClass:"rate-info"},[_c('div',{staticClass:"title"},[_vm._v("Sub Gifts")]),_vm._v(" "),_c('div',{staticClass:"rate-val"},[_vm._v("+"+_vm._s(_vm.formatCurrency(_vm.userRates.gifts * 100))+"%")])]),_vm._v(" "),_c('AchievementProgressBar',{attrs:{"progress":_vm.userRates.gifts,"achievements":[{reward: 'Custom ReSub Sound!', requirement: 0.5}, {reward: 'Custom Gift Sub Sound!', requirement: 1}]}}),_vm._v(" "),_vm._m(1)],1),_vm._v(" "),_c('div',{staticClass:"rate-box"},[_c('div',{staticClass:"rate-info"},[_c('div',{staticClass:"title"},[_vm._v("Gold + Tokens")]),_vm._v(" "),_c('div',{staticClass:"rate-val"},[_vm._v("+"+_vm._s(_vm.formatCurrency(_vm.userRates.gold * 100))+"%")])]),_vm._v(" "),_c('AchievementProgressBar',{attrs:{"progress":_vm.userRates.gold,"achievements":[{reward: 'Custom Save Sound', requirement: 0.5}, {reward: 'Custom Kill Sound', requirement: 1}]}}),_vm._v(" "),_vm._m(2)],1),_vm._v(" "),_c('div',{staticClass:"rate-box"},[_c('div',{staticClass:"rate-info"},[_c('div',{staticClass:"title"},[_vm._v("Cheer")]),_vm._v(" "),_c('div',{staticClass:"rate-val"},[_vm._v("+"+_vm._s(_vm.formatCurrency(_vm.userRates.cheer * 100))+"%")])]),_vm._v(" "),_c('AchievementProgressBar',{attrs:{"progress":_vm.userRates.cheer,"achievements":[{reward: 'Custom Cheer Sound', requirement: 0.5}, {reward: '+100% Bonus', requirement: 1}]}}),_vm._v(" "),_vm._m(3)],1)])]):_c('span',[_c('login-btn',{staticStyle:{"font-size":"40px","padding":"8px"},attrs:{"buttonClass":"btn-enabled"}},[_vm._v("Login to View Rates!")])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rate-desc"},[_c('div',[_vm._v("Twitch & Discord Sub Bonus. Twitch Tier 1 = 100%, Tier 2= 300%, Tier 3 = 900%.  A "),_c('a',{attrs:{"href":"https://discord.com/channels/94542586735230976/role-subscriptions","target":"_blank"}},[_vm._v("Discord paid sub")]),_vm._v(" also stacks: Discord Tier 1 = 100%. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rate-desc"},[_c('div',[_vm._v("Every 5 gift subs of any tier on Twitch is 1% (after 100% it gets harder to increase)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rate-desc"},[_c('div',[_vm._v("Every 25 "),_c('a',{attrs:{"href":"https://swiftorland.com/#/gold","target":"_blank"}},[_vm._v("Gold")]),_vm._v(" obtained is 1% (after 100% it gets harder to increase). Save = 10 gold, Kill = 66. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rate-desc"},[_c('div',[_vm._v("Every 2,500 cheer on Twitch is 1% (after 100% it gets harder to increase)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.8db78378cd17b873361e.js